msgid ""
msgstr ""
"POT-Creation-Date: 2026-02-10 20:45-0500\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: en\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#: src/components/slot_scheduler/MidRollConfigPanel.tsx
msgid " Scheduling Strategy"
msgstr " Scheduling Strategy"

#: src/components/programming_controls/AddRestrictHoursModal.tsx
msgid " the following day."
msgstr " the following day."

#. placeholder {0}: channel.name
#: src/pages/watch/ChannelWatchPage.tsx
msgid "\"{0}\" Live"
msgstr "\"{0}\" Live"

#. placeholder {0}: channel.name
#: src/components/channels/ChannelSessionsDialog.tsx
msgid "\"{0}\" Sessions"
msgstr "\"{0}\" Sessions"

#: src/components/channel_config/ChannelEpgConfig.tsx
msgid "\"Stealth\" channels are hidden from TV guides, spoofed HDHR, m3u playlist, etc. The channel can still be streamed directly or be used as a redirect target."
msgstr "\"Stealth\" channels are hidden from TV guides, spoofed HDHR, m3u playlist, etc. The channel can still be streamed directly or be used as a redirect target."

#. placeholder {0}: badge.count
#: src/components/ui/patterns/AppShell/NavBadge.tsx
msgid "{0, plural, one {(# health check issue)} other {(# health check issues)}}"
msgstr "{0, plural, one {(# health check issue)} other {(# health check issues)}}"

#. placeholder {0}: customShow.contentCount
#: src/components/channel_config/SelectedProgrammingList.tsx
msgid "{0, plural, one {# item} other {# items}}"
msgstr "{0, plural, one {# item} other {# items}}"

#. placeholder {0}: channel.programCount
#. placeholder {0}: programList.length
#. placeholder {0}: value?.programCount ?? 0
#: src/components/channel_config/ChannelLineupList.tsx
#: src/components/slot_scheduler/FillerListSlotProgrammingForm.tsx
#: src/pages/channels/ChannelsPage.tsx
msgid "{0, plural, one {# program} other {# programs}}"
msgstr "{0, plural, one {# program} other {# programs}}"

#. placeholder {0}: customShow.contentCount
#: src/components/channel_config/CustomShowProgrammingSelector.tsx
msgid "{0, plural, one {# Program} other {# Programs}}"
msgstr "{0, plural, one {# Program} other {# Programs}}"

#. placeholder {0}: media.childCount ?? 0
#. placeholder {1}: media.grandchildCount ?? 0
#: src/components/channel_config/SelectedProgrammingList.tsx
msgid "{0, plural, one {# season} other {# seasons}}, {1, plural, one {# total episode} other {# total episodes}}"
msgstr "{0, plural, one {# season} other {# seasons}}, {1, plural, one {# total episode} other {# total episodes}}"

#. placeholder {0}: selectedMedia.length
#: src/components/channel_config/SelectedProgrammingActions.tsx
msgid "{0, plural, one {# Selected Item} other {# Selected Items}}"
msgstr "{0, plural, one {# Selected Item} other {# Selected Items}}"

#. placeholder {0}: sessions.length
#: src/pages/channels/ChannelsPage.tsx
#: src/pages/channels/ChannelsPage.tsx
msgid "{0, plural, one {# session} other {# sessions}}"
msgstr "{0, plural, one {# session} other {# sessions}}"

#: src/pages/welcome/WelcomePage.tsx
#~ msgid "{0, plural, one {# source connected.} other {# sources connected.}}"
#~ msgstr "{0, plural, one {# source connected.} other {# sources connected.}}"

#. placeholder {0}: currentBackupSchedule!.increment
#: src/components/settings/general/BackupForm.tsx
#: src/components/settings/general/LogRollForm.tsx
msgid "{0, plural, one {Day} other {Days}}"
msgstr "{0, plural, one {Day} other {Days}}"

#. placeholder {0}: currentBackupSchedule!.increment
#: src/components/settings/general/BackupForm.tsx
#: src/components/settings/general/LogRollForm.tsx
msgid "{0, plural, one {Hour} other {Hours}}"
msgstr "{0, plural, one {Hour} other {Hours}}"

#. placeholder {0}: paths.length
#: src/components/settings/media_source/LocalMediaEditDialog.tsx
msgid "{0, plural, one {Path} other {Paths}}"
msgstr "{0, plural, one {Path} other {Paths}}"

#. placeholder {0}: slot.programCount
#: src/components/slot_scheduler/SlotProgrammingTooLongWarningDetails.tsx
msgid "{0, plural, one {program} other {programs}}"
msgstr "{0, plural, one {program} other {programs}}"

#. placeholder {0}: selectedMedia.length
#: src/components/channel_config/SelectedProgrammingList.tsx
msgid "{0, plural, one {Selected Item} other {Selected Items}}"
msgstr "{0, plural, one {Selected Item} other {Selected Items}}"

#. placeholder {0}: prettifySnakeCaseString(programType)
#: src/components/programs/ProgramDetailsDialog.tsx
msgid "{0} Info"
msgstr "{0} Info"

#. placeholder {0}: warning.programs.length
#. placeholder {1}: slot.programCount
#. placeholder {2}: import { betterHumanize } from '@/helpers/dayjs.ts'; import { alternateColors } from '@/helpers/util.ts'; import { plural } from '@lingui/core/macro'; import { Trans } from '@lingui/react/macro'; import { useProgramTitleFormatter } from '@/hooks/useProgramTitleFormatter.ts'; import type { ProgramTooLongWarning, SlotTableWarnings, } from '@/model/CommonSlotModels'; import { removeChannelProgramsById } from '@/store/entityEditor/util.ts'; import { useStoreProgramLookup } from '@/store/selectors.ts'; import { Delete, Error, ExpandMore, WarningAmber } from '@mui/icons-material'; import { Accordion, AccordionDetails, AccordionSummary, Box, Button, IconButton, ListItem, ListItemText, Stack, Typography, } from '@mui/material'; import { seq } from '@tunarr/shared/util'; import type { BaseSlot } from '@tunarr/types/api'; import dayjs from 'dayjs'; import { map, uniqBy, values } from 'lodash-es'; import { averageProgramDurationMs } from '@/helpers/slots.ts'; import type { ListChildComponentProps } from 'react-window'; import { FixedSizeList } from 'react-window'; type Props = { slot: BaseSlot & SlotTableWarnings; slotType: 'time' | 'random'; warning: ProgramTooLongWarning; }; export const SlotProgrammingTooLongWarningDetails = ({ slot, warning, slotType, }: Props) => { const formatter = useProgramTitleFormatter(); const programLookup = useStoreProgramLookup(); const longPrograms = seq.collect( uniqBy(warning.programs, (p) => p.id), ({ id }) => { return programLookup[id]; }, ); const renderLongProgramRow = (props: ListChildComponentProps) => { const program = longPrograms[props.index]; if (!program.id) { return null; } const programId = program.id; return ( <ListItem style={props.style} sx={{ backgroundColor: (theme) => alternateColors(props.index, theme.palette.mode), }} key={programId} component="div" > <ListItemText primary={formatter(program)} /> <IconButton onClick={() => removeChannelProgramsById(programId)} edge="end" aria-label="delete" size="small" > <Delete fontSize="small" /> </IconButton> </ListItem> ); }; const averageLengthMs = averageProgramDurationMs(slot, values(programLookup)); return ( <Accordion defaultExpanded={slot.warnings.length === 1} key={warning.type} elevation={5} > <AccordionSummary expandIcon={<ExpandMore />}> {warning.programs.length === slot.programCount ? ( <Error sx={{ mr: 1, color: (theme) => theme.palette.error.main }} /> ) : ( <WarningAmber sx={{ mr: 1, color: (theme) => theme.palette.warning.main }} /> )} <Typography> <Trans>Programs Too Long</Trans> </Typography> </AccordionSummary> <AccordionDetails> <Stack> <Stack direction="row"> <Button onClick={() => removeChannelProgramsById( new Set(map(warning.programs, (p) => p.id)), ) } > <Trans>Remove All</Trans> </Button> </Stack> <div> <p> <Trans> {warning.programs.length} of {slot.programCount}{' '} {plural(slot.programCount, { one: 'program', other: 'programs', })}{' '} exceed the length of this slot ( {betterHumanize(dayjs.duration(slot.durationMs ?? 0))}). </Trans> {averageLengthMs !== undefined && ( <> {' '} <Trans> Average program length:{' '} {betterHumanize(dayjs.duration(averageLengthMs))} </Trans> </> )} <br /> <Trans> This could cause the following slot's programs to go unscheduled. Possible solutions include: </Trans> </p> <ul> {} {slotType === 'time' && ( <li> <Trans>Increasing "Max Overflow" for the schedule.</Trans> </li> )} <li> <Trans>Increasing the slot duration.</Trans> </li> <li> <Trans>Removing overrun programs from the channel.</Trans> </li> </ul> </div> <Box sx={{ width: '100%', height: 400 }}> <FixedSizeList height={400} width={'100%'} itemSize={46} itemCount={longPrograms.length} overscanCount={5} > {renderLongProgramRow} </FixedSizeList> </Box> </Stack> </AccordionDetails> </Accordion> ); }; 
#. placeholder {3}: betterHumanize(dayjs.duration(slot.durationMs ?? 0))
#: src/components/slot_scheduler/SlotProgrammingTooLongWarningDetails.tsx
msgid "{0} of {1} {2} exceed the length of this slot ({3})."
msgstr "{0} of {1} {2} exceed the length of this slot ({3})."

#: src/components/slot_scheduler/SlotProgrammingTooLongWarningDetails.tsx
#~ msgid "{0} of {1} {2} exceed the length of this slot ({3}). Average program length: {4}"
#~ msgstr "{0} of {1} {2} exceed the length of this slot ({3}). Average program length: {4}"

#. placeholder {0}: program.title
#: src/components/programs/MediaDetailCard.tsx
msgid "{0} Poster"
msgstr "{0} Poster"

#: src/components/programming_controls/AddRerunBlockModal.tsx
msgid "{block} Hours"
msgstr "{block} Hours"

#: src/components/library/extractSubtitle.tsx
#: src/components/programs/ProgramInfoBar.tsx
msgid "{count, plural, one {# album} other {# albums}}"
msgstr "{count, plural, one {# album} other {# albums}}"

#: src/components/library/extractSubtitle.tsx
#: src/components/programs/ProgramInfoBar.tsx
msgid "{count, plural, one {# episode} other {# episodes}}"
msgstr "{count, plural, one {# episode} other {# episodes}}"

#: src/components/library/extractSubtitle.tsx
#: src/components/programs/ProgramInfoBar.tsx
msgid "{count, plural, one {# item} other {# items}}"
msgstr "{count, plural, one {# item} other {# items}}"

#: src/components/slot_scheduler/ProgramCalendarView.tsx
msgid "{count, plural, one {# program} other {# programs}}"
msgstr "{count, plural, one {# program} other {# programs}}"

#: src/components/library/extractSubtitle.tsx
#: src/components/programs/ProgramInfoBar.tsx
msgid "{count, plural, one {# season} other {# seasons}}"
msgstr "{count, plural, one {# season} other {# seasons}}"

#: src/components/library/extractSubtitle.tsx
#: src/components/programs/ProgramInfoBar.tsx
msgid "{count, plural, one {# track} other {# tracks}}"
msgstr "{count, plural, one {# track} other {# tracks}}"

#: src/helpers/dayjs.ts
msgid "{count, plural, one {day} other {days}}"
msgstr "{count, plural, one {day} other {days}}"

#: src/components/programming_controls/RemoveShowsModal.tsx
msgid "{count, plural, one {episode} other {episodes}}"
msgstr "{count, plural, one {episode} other {episodes}}"

#: src/helpers/dayjs.ts
msgid "{count, plural, one {hour} other {hours}}"
msgstr "{count, plural, one {hour} other {hours}}"

#: src/helpers/dayjs.ts
msgid "{count, plural, one {min} other {mins}}"
msgstr "{count, plural, one {min} other {mins}}"

#: src/components/programming_controls/RemoveShowsModal.tsx
#: src/components/programming_controls/RemoveShowsModal.tsx
msgid "{count, plural, one {program} other {programs}}"
msgstr "{count, plural, one {program} other {programs}}"

#: src/helpers/dayjs.ts
msgid "{count, plural, one {second} other {seconds}}"
msgstr "{count, plural, one {second} other {seconds}}"

#: src/components/programming_controls/RemoveShowsModal.tsx
msgid "{count, plural, one {track} other {tracks}}"
msgstr "{count, plural, one {track} other {tracks}}"

#. placeholder {0}: betterHumanize( dayjs.duration(details.totalDuration), { style: 'short', }, )
#: src/components/programming_controls/RemoveShowsModal.tsx
msgid "{count} {programLabel}, {0}"
msgstr "{count} {programLabel}, {0}"

#: src/components/channels/ChannelSummaryQuickStats.tsx
msgid "{days, plural, one {# day} other {# days}}"
msgstr "{days, plural, one {# day} other {# days}}"

#: src/components/settings/media_source/MediaSourceLibrariesChip.tsx
msgid "{enabled} of {total} enabled"
msgstr "{enabled} of {total} enabled"

#: src/components/ui/table/DataTable.tsx
msgid "{from}–{to} of {count}"
msgstr "{from}–{to} of {count}"

#: src/components/channels/ChannelSummaryQuickStats.tsx
msgid "{hours, plural, one {# hour} other {# hours}}"
msgstr "{hours, plural, one {# hour} other {# hours}}"

#: src/components/slot_scheduler/RandomSlotTable.tsx
#: src/components/slot_scheduler/TimeSlotTable.tsx
msgid "{len, plural, one {There is # warning. Click for details.} other {There are # warnings. Click for details.}}"
msgstr "{len, plural, one {There is # warning. Click for details.} other {There are # warnings. Click for details.}}"

#: src/components/channels/ChannelSummaryQuickStats.tsx
msgid "{minutes, plural, one {# minute} other {# minutes}}"
msgstr "{minutes, plural, one {# minute} other {# minutes}}"

#: src/components/guide/TvGuide.tsx
msgid "{remainingTime} left"
msgstr "{remainingTime} left"

#: src/pages/channels/ChannelsPage.tsx
#: src/pages/channels/ChannelsPage.tsx
msgid "{totalConnections, plural, one {# connection} other {# connections}}"
msgstr "{totalConnections, plural, one {# connection} other {# connections}}"

#: src/pages/channels/ChannelsPage.tsx
#: src/pages/channels/ChannelsPage.tsx
msgid "{totalConnections} total"
msgstr "{totalConnections} total"

#: src/pages/channels/RandomSlotEditorPage.tsx
#: src/pages/channels/TimeSlotEditorPage.tsx
msgid "{unavailableSlotCount, plural, one {# slot uses a custom show that is empty or deleted. Fix or remove it before saving.} other {# slots use a custom show that is empty or deleted. Fix or remove them before saving.}}"
msgstr "{unavailableSlotCount, plural, one {# slot uses a custom show that is empty or deleted. Fix or remove it before saving.} other {# slots use a custom show that is empty or deleted. Fix or remove them before saving.}}"

#: src/components/slot_scheduler/RandomSlotTable.tsx
msgid "{value, plural, one {# program} other {# programs}}"
msgstr "{value, plural, one {# program} other {# programs}}"

#: src/pages/settings/HdhrSettingsPage.tsx
msgid "* Restart required"
msgstr "* Restart required"

#: src/components/programming_controls/AddBlockShuffleModal.tsx
msgid "# of Programs"
msgstr "# of Programs"

#: src/pages/channels/ChannelsPage.tsx
#: src/pages/library/CustomShowsPage.tsx
#: src/pages/library/FillerListsPage.tsx
msgid "# Programs"
msgstr "# Programs"

#: src/pages/settings/FfmpegSettingsPage.tsx
msgid "<0>Configure the directory where Tunarr writes HLS segment files when transcoding. Tunarr will create the target directory (but not intermediate directories) if it doesn't exist.<1/>Changing this field will only affect new sessions. Existing sessions will continue writing to the previous setting, but will clean out segments when the segment ends.<2/>When unset, Tunarr will write segments to its current working directory.</0>"
msgstr "<0>Configure the directory where Tunarr writes HLS segment files when transcoding. Tunarr will create the target directory (but not intermediate directories) if it doesn't exist.<1/>Changing this field will only affect new sessions. Existing sessions will continue writing to the previous setting, but will clean out segments when the segment ends.<2/>When unset, Tunarr will write segments to its current working directory.</0>"

#. placeholder {0}: e.message
#: src/pages/library/CustomShowsPage.tsx
msgid "<0>Error deleting custom show: {0}<1/>Please consider opening a bug with details!</0>"
msgstr "<0>Error deleting custom show: {0}<1/>Please consider opening a bug with details!</0>"

#. placeholder {0}: e.message
#: src/pages/library/FillerListsPage.tsx
msgid "<0>Error deleting filler list: {0}<1/>Please consider opening a bug with details!</0>"
msgstr "<0>Error deleting filler list: {0}<1/>Please consider opening a bug with details!</0>"

#: src/components/settings/general/GeneralSettingsForm.tsx
#~ msgid "<0>Experimental:</0> Enable Plex Request Cache"
#~ msgstr "<0>Experimental:</0> Enable Plex Request Cache"

#: src/components/slot_scheduler/RandomSlotSettingsForm.tsx
msgid "<0>None:</0> slots are picked in the order they are specified in the table (i.e. not randomly)<1/><2>Uniform:</2> all slots have an equal chance to be picked.<3/><4>Weighted:</4> each slot is picked with a specified probability"
msgstr "<0>None:</0> slots are picked in the order they are specified in the table (i.e. not randomly)<1/><2>Uniform:</2> all slots have an equal chance to be picked.<3/><4>Weighted:</4> each slot is picked with a specified probability"

#: src/components/slot_scheduler/RandomSlotSettingsForm.tsx
msgid "<0>Pad Slot:</0> Align slot start times to the specified pad time.<1/><2>Pad Episode:</2> Align episode start times (within a slot) to the specified pad time. <3>NOTE:</3> Depending on slot length and the chosen pad time, this could potentially create a lot of flex."
msgstr "<0>Pad Slot:</0> Align slot start times to the specified pad time.<1/><2>Pad Episode:</2> Align episode start times (within a slot) to the specified pad time. <3>NOTE:</3> Depending on slot length and the chosen pad time, this could potentially create a lot of flex."

#. placeholder {0}: new URL( '/api/xmltv.xml', isEmpty(backendUri) ? document.location.href : backendUri, ).href
#: src/pages/settings/XmlTvSettingsPage.tsx
msgid "<0>You can edit this location in your settings.json within your Tunarr data directory<1/><2>NOTE:</2> When manually adding the XMLTV location to a client like Plex, do not use this file directly. Instead, use the generated XMLTV from the Tunarr API endpoint: {0}</0>"
msgstr "<0>You can edit this location in your settings.json within your Tunarr data directory<1/><2>NOTE:</2> When manually adding the XMLTV location to a client like Plex, do not use this file directly. Instead, use the generated XMLTV from the Tunarr API endpoint: {0}</0>"

#: src/components/channels/ChannelSummaryQuickStats.tsx
#: src/helpers/dayjs.ts
msgid "0 mins"
msgstr "0 mins"

#: src/components/settings/general/WebSettings.tsx
msgid "12-hour"
msgstr "12-hour"

#: src/components/settings/general/WebSettings.tsx
msgid "24-hour"
msgstr "24-hour"

#: src/components/settings/media_source/LocalMediaEditDialog.tsx
msgid "A root path to scan for media. Local sources can search many different paths."
msgstr "A root path to scan for media. Local sources can search many different paths."

#: src/components/channel_config/ChannelProgrammingSort.tsx
#: src/components/custom-shows/CustomShowSortToolsMenu.tsx
msgid "A-Z (asc)"
msgstr "A-Z (asc)"

#: src/components/channel_config/ChannelProgrammingSort.tsx
#: src/components/custom-shows/CustomShowSortToolsMenu.tsx
msgid "A-Z (desc)"
msgstr "A-Z (desc)"

#: src/helpers/dayjs.ts
msgid "about "
msgstr "about "

#: src/components/settings/media_source/EmbyServerEditDialog.tsx
#: src/components/settings/media_source/EmbyServerEditDialog.tsx
#: src/components/settings/media_source/JelllyfinServerEditDialog.tsx
#: src/components/settings/media_source/JelllyfinServerEditDialog.tsx
#: src/components/settings/media_source/PlexServerEditDialog.tsx
#: src/components/settings/media_source/PlexServerEditDialog.tsx
msgid "Access Token"
msgstr "Access Token"

#: src/components/ui/table/ActionsHeader.tsx
msgid "Actions"
msgstr "Actions"

#: src/components/channel_config/AddProgrammingButton.tsx
#: src/components/library/ProgramListItem.tsx
#: src/components/settings/AddPlexServer.tsx
#: src/components/settings/media_source/AddMediaSourceButton.tsx
#: src/components/settings/media_source/EditPathReplacementsForm.tsx
#: src/components/settings/media_source/EmbyServerEditDialog.tsx
#: src/components/settings/media_source/JelllyfinServerEditDialog.tsx
#: src/components/settings/media_source/LocalMediaEditDialog.tsx
#: src/components/settings/media_source/PlexServerEditDialog.tsx
#: src/hooks/useRouteName.ts
msgid "Add"
msgstr "Add"

#. placeholder {0}: item.type
#: src/components/library/ProgramListItem.tsx
msgid "Add {0}"
msgstr "Add {0}"

#: src/components/channel_config/ChannelFlexConfig.tsx
msgid "Add a Filler List"
msgstr "Add a Filler List"

#: src/components/search/SearchFilterBuilder.tsx
msgid "Add a filter expression to fine-tune results of the search"
msgstr "Add a filter expression to fine-tune results of the search"

#: src/components/channel_config/AddSelectedMediaButton.tsx
#~ msgid "Add All"
#~ msgstr "Add All"

#: src/components/channel_config/AddSelectedMediaButton.tsx
#~ msgid "Add all selected programs to channel"
#~ msgstr "Add all selected programs to channel"

#: src/components/programming_controls/AddBreaksModal.tsx
msgid "Add Breaks"
msgstr "Add Breaks"

#: src/components/channel_config/ChannelProgrammingFlexTools.tsx
msgid "Add Breaks..."
msgstr "Add Breaks..."

#: src/components/programming_controls/AddRedirectModal.tsx
msgid "Add Channel Redirect"
msgstr "Add Channel Redirect"

#: src/components/search/SearchGroupNode.tsx
msgid "Add field"
msgstr "Add field"

#: src/components/slot_scheduler/SlotFillerDialogPanel.tsx
msgid "Add filler"
msgstr "Add filler"

#: src/components/channel_config/AddProgrammingButton.tsx
#~ msgid "Add Flex"
#~ msgstr "Add Flex"

#: src/components/programming_controls/AddFlexModal.tsx
msgid "Add Flex Time"
msgstr "Add Flex Time"

#: src/components/search/SearchGroupNode.tsx
msgid "Add group"
msgstr "Add group"

#: src/components/channel_config/ChannelSubtitlePreferencesTable.tsx
msgid "Add Language Preference"
msgstr "Add Language Preference"

#: src/components/channel_config/SelectedProgrammingActions.tsx
#: src/components/custom-shows/EditCustomShowForm.tsx
#: src/components/filler/EditFillerListForm.tsx
msgid "Add Media"
msgstr "Add Media"

#: src/components/programming_controls/AddPaddingModal.tsx
msgid "Add Padding"
msgstr "Add Padding"

#: src/components/slot_scheduler/MidRollConfigPanel.tsx
msgid "Add point (%)"
msgstr "Add point (%)"

#: src/hooks/useRouteName.ts
#: src/hooks/useRouteName.ts
msgid "Add Programming"
msgstr "Add Programming"

#: src/components/custom-shows/EditCustomShowForm.tsx
msgid "Add programming to custom show"
msgstr "Add programming to custom show"

#: src/components/channel_config/AddProgrammingButton.tsx
#~ msgid "Add Redirect"
#~ msgstr "Add Redirect"

#: src/components/channel_config/SelectedProgrammingActions.tsx
msgid "Add Selected Media"
msgstr "Add Selected Media"

#: src/components/channel_config/CustomShowProgrammingSelector.tsx
msgid "Add Show"
msgstr "Add Show"

#: src/components/slot_scheduler/AddRandomSlotButton.tsx
#: src/components/slot_scheduler/AddTimeSlotButton.tsx
msgid "Add Slot"
msgstr "Add Slot"

#: src/pages/welcome/WelcomePage.tsx
msgid "Add these links to an IPTV client. Jellyfin and Emby can use Tunarr as either an M3U source or an HDHomeRun tuner. Plex can add Tunarr as an HDHomeRun tuner."
msgstr "Add these links to an IPTV client. Jellyfin and Emby can use Tunarr as either an M3U source or an HDHomeRun tuner. Plex can add Tunarr as an HDHomeRun tuner."

#: src/components/filler/EditFillerListForm.tsx
msgid "Add TV Shows or Movies to filler"
msgstr "Add TV Shows or Movies to filler"

#: src/components/channel_config/AddProgrammingButton.tsx
msgid "Add TV Shows or Movies to programming list."
msgstr "Add TV Shows or Movies to programming list."

#: src/components/channel_config/AddProgrammingButton.tsx
msgid "Adds a channel redirect. During this period of time, the channel will redirect to another channel."
msgstr "Adds a channel redirect. During this period of time, the channel will redirect to another channel."

#: src/components/channel_config/ChannelProgrammingFlexTools.tsx
msgid "Adds Flex after each TV episode or movie so the next program starts at one of the allowed minute marks, such as XX:00 or XX:30. Removes existing Flex first."
msgstr "Adds Flex after each TV episode or movie so the next program starts at one of the allowed minute marks, such as XX:00 or XX:30. Removes existing Flex first."

#: src/components/programming_controls/AddPaddingModal.tsx
msgid "Adds Flex breaks after each TV episode or movie to ensure that the program starts at one of the allowed minute marks."
msgstr "Adds Flex breaks after each TV episode or movie to ensure that the program starts at one of the allowed minute marks."

#: src/components/channel_config/AddProgrammingButton.tsx
#: src/components/channel_config/AddProgrammingButton.tsx
#~ msgid "Adds Flex breaks after each TV episode or movie to ensure that the program starts at one of the allowed minute marks. For example, you can use this to ensure that all your programs start at either XX:00 times or XX:30 times. Removes any existing Flex periods before adding the new ones. This button might be disabled if the channel is already too large."
#~ msgstr "Adds Flex breaks after each TV episode or movie to ensure that the program starts at one of the allowed minute marks. For example, you can use this to ensure that all your programs start at either XX:00 times or XX:30 times. Removes any existing Flex periods before adding the new ones. This button might be disabled if the channel is already too large."

#: src/components/channel_config/ChannelProgrammingFlexTools.tsx
msgid "Adds Flex breaks between programs so that no run of consecutive programs goes longer than the time you set. Existing Flex stays in place."
msgstr "Adds Flex breaks between programs so that no run of consecutive programs goes longer than the time you set. Existing Flex stays in place."

#: src/components/programming_controls/AddBreaksModal.tsx
msgid "Adds Flex breaks between programs, attempting to avoid groups of consecutive programs that exceed the specified number of minutes."
msgstr "Adds Flex breaks between programs, attempting to avoid groups of consecutive programs that exceed the specified number of minutes."

#: src/components/channel_config/AddProgrammingButton.tsx
msgid "Adds one Flex time slot. To add Flex across the whole lineup at once, use the Flex menu next to Add."
msgstr "Adds one Flex time slot. To add Flex across the whole lineup at once, use the Flex menu next to Add."

#: src/components/settings/ffmpeg/TranscodeConfigAudioSettingsForm.tsx
msgid "Adjust the output volume (not recommended). Values higher than 100 will boost the audio."
msgstr "Adjust the output volume (not recommended). Values higher than 100 will boost the audio."

#: src/components/programming_controls/AdjustWeightsModal.tsx
#: src/components/slot_scheduler/RandomSlotsWeightAdjustDialog.tsx
#: src/components/slot_scheduler/RandomSlotTable.tsx
msgid "Adjust Weights"
msgstr "Adjust Weights"

#: src/components/channel_config/plex/PlexProgrammingFilterToolbar.tsx
#~ msgid "Advanced"
#~ msgstr "Advanced"

#: src/components/settings/ffmpeg/TranscodeConfigAudioSettingsForm.tsx
msgid "Advanced options relating to audio. In general, do not change these unless you know what you are doing!"
msgstr "Advanced options relating to audio. In general, do not change these unless you know what you are doing!"

#: src/components/settings/ffmpeg/TranscodeConfigSettingsForm.tsx
msgid "Advanced options relating to transcoding. In general, do not change these unless you know what you are doing! These settings exist in order to leave some parity with the old dizqueTV transcode pipeline as well as to provide mechanisms to aid in debugging streaming issues."
msgstr "Advanced options relating to transcoding. In general, do not change these unless you know what you are doing! These settings exist in order to leave some parity with the old dizqueTV transcode pipeline as well as to provide mechanisms to aid in debugging streaming issues."

#: src/components/settings/ffmpeg/TranscodeConfigAudioSettingsForm.tsx
#: src/components/settings/ffmpeg/TranscodeConfigSettingsForm.tsx
msgid "Advanced Video Options"
msgstr "Advanced Video Options"

#: src/components/programming_controls/AddBreaksModal.tsx
msgid "After Every"
msgstr "After Every"

#: src/components/programming_controls/AddBreaksModal.tsx
msgid "after every program"
msgstr "after every program"

#: src/components/programs/Albums.tsx
msgid "Albums"
msgstr "Albums"

#: src/components/settings/ffmpeg/TranscodeConfigsTable.tsx
#: src/pages/settings/FfmpegSettingsPage.tsx
msgid "All channels assigned to this config will be set to use the default configuration. If this is the last configuration, a new default configuration will be created."
msgstr "All channels assigned to this config will be set to use the default configuration. If this is the last configuration, a new default configuration will be created."

#: src/components/MediaSourceLibraryTable.tsx
msgid "All folders"
msgstr "All folders"

#: src/components/channel_config/jellyfin/JellyfinLibrarySelector.tsx
#~ msgid "All Genres"
#~ msgstr "All Genres"

#: src/components/slot_scheduler/SlotLinkingControl.tsx
#~ msgid "All linked slots show the same episode, advancing only after all have played."
#~ msgstr "All linked slots show the same episode, advancing only after all have played."

#: src/components/channel_config/ChannelFlexConfig.tsx
msgid "All lists are used"
msgstr "All lists are used"

#: src/pages/welcome/WelcomePage.tsx
#~ msgid "All Set!"
#~ msgstr "All Set!"

#: src/components/channel_config/ChannelSubtitlePreferencesTable.tsx
msgid "Allow External"
msgstr "Allow External"

#: src/components/channel_config/ChannelSubtitlePreferencesTable.tsx
msgid "Allow Image Based"
msgstr "Allow Image Based"

#: src/pages/channels/TimeSlotEditorPage.tsx
#~ msgid "Allows programs to play a bit late if the previous program took longer than usual. If a program is too late, Flex is scheduled instead."
#~ msgstr "Allows programs to play a bit late if the previous program took longer than usual. If a program is too late, Flex is scheduled instead."

#: src/components/channel_config/ChannelProgrammingDeleteOptions.tsx
msgid "Allows you to pick specific programming to remove from the channel."
msgstr "Allows you to pick specific programming to remove from the channel."

#: src/components/programming_controls/AddBlockShuffleModal.tsx
msgid "Alphabetical"
msgstr "Alphabetical"

#: src/components/channel_config/ChannelProgrammingSort.tsx
#: src/components/custom-shows/CustomShowSortToolsMenu.tsx
msgid "Alphabetically"
msgstr "Alphabetically"

#: src/components/programming_controls/AddBlockShuffleModal.tsx
#~ msgid "Alternate programs in blocks. You can pick the number of programs in each block, whether episodes play in order, and whether shows take turns or come up at random."
#~ msgstr "Alternate programs in blocks. You can pick the number of programs in each block, whether episodes play in order, and whether shows take turns or come up at random."

#: src/components/programming_controls/AddBlockShuffleModal.tsx
#~ msgid "Alternate programs in blocks. You can pick the number of programs in each block, whether episodes play in order, and whether shows take turns or come up at random. Each preset fills in these settings, and you can change them before shuffling."
#~ msgstr "Alternate programs in blocks. You can pick the number of programs in each block, whether episodes play in order, and whether shows take turns or come up at random. Each preset fills in these settings, and you can change them before shuffling."

#: src/components/programming_controls/AddBlockShuffleModal.tsx
#~ msgid "Alternate programs in blocks. You can pick the number of programs per-type in each block and if the order of shows in each block should be randomized."
#~ msgstr "Alternate programs in blocks. You can pick the number of programs per-type in each block and if the order of shows in each block should be randomized."

#: src/components/channel_config/ChannelProgrammingSort.tsx
#: src/components/custom-shows/CustomShowSortToolsMenu.tsx
msgid "Alternates TV shows in blocks of episodes. You can pick the number of episodes per show in each block and if the order of shows in each block should be randomized. Movies are moved to the bottom."
msgstr "Alternates TV shows in blocks of episodes. You can pick the number of episodes per show in each block and if the order of shows in each block should be randomized. Movies are moved to the bottom."

#: src/components/search/DateSearchValueNode.tsx
msgid "Amount"
msgstr "Amount"

#. placeholder {0}: error.message
#: src/components/guide/TvGuide.tsx
msgid "An error occurred: {0}"
msgstr "An error occurred: {0}"

#: src/components/slot_scheduler/MidRollConfigPanel.tsx
msgid "Apply to Program Types (empty = all)"
msgstr "Apply to Program Types (empty = all)"

#: src/components/settings/general/BackupForm.tsx
#: src/components/settings/general/BackupForm.tsx
msgid "Archive Format"
msgstr "Archive Format"

#. placeholder {0}: deletingSmartCollection?.name
#: src/components/smart_collections/SmartCollectionsTable.tsx
msgid "Are you sure you want to delete Smart Collection \"{0}\"?"
msgstr "Are you sure you want to delete Smart Collection \"{0}\"?"

#: src/components/channels/ChannelPrograms.tsx
msgid "Artists"
msgstr "Artists"

#: src/components/slot_scheduler/SlotOrderFormControl.tsx
msgid "Asc"
msgstr "Asc"

#: src/components/programming_controls/AddBlockShuffleModal.tsx
msgid "Ascending"
msgstr "Ascending"

#: src/pages/system/StatusPage.tsx
msgid "Attempt Auto-Fix"
msgstr "Attempt Auto-Fix"

#: src/components/programming_controls/BalanceProgrammingModal.tsx
msgid "Attempts to balance programming groups by either total lineup duration or number of unique programs. For instance, for a channel with many seasons of one show and few seasons of another, balancing will attempt to create an even mix of both shows by inserting repeats of the show with fewer episodes."
msgstr "Attempts to balance programming groups by either total lineup duration or number of unique programs. For instance, for a channel with many seasons of one show and few seasons of another, balancing will attempt to create an even mix of both shows by inserting repeats of the show with fewer episodes."

#: src/pages/system/TroubleshootPage.tsx
msgid "Audio"
msgstr "Audio"

#: src/pages/settings/FfmpegSettingsPage.tsx
msgid "Audio & Subtitle Options"
msgstr "Audio & Subtitle Options"

#: src/components/channel_config/ChannelTranscodingConfig.tsx
msgid "Audio & Subtitles"
msgstr "Audio & Subtitles"

#: src/pages/system/TroubleshootPage.tsx
msgid "Audio Action"
msgstr "Audio Action"

#: src/components/settings/ffmpeg/TranscodeConfigAudioSettingsForm.tsx
msgid "Audio Bitrate"
msgstr "Audio Bitrate"

#: src/components/settings/ffmpeg/TranscodeConfigAudioSettingsForm.tsx
msgid "Audio Buffer Size"
msgstr "Audio Buffer Size"

#: src/components/settings/ffmpeg/TranscodeConfigAudioSettingsForm.tsx
msgid "Audio Channels"
msgstr "Audio Channels"

#: src/components/settings/ffmpeg/TranscodeConfigAudioSettingsForm.tsx
#: src/components/settings/ffmpeg/TranscodeConfigsTable.tsx
msgid "Audio Format"
msgstr "Audio Format"

#: src/pages/settings/FfmpegSettingsPage.tsx
msgid "Audio Language Preferences"
msgstr "Audio Language Preferences"

#: src/components/settings/ffmpeg/TranscodeConfigAudioSettingsForm.tsx
#: src/components/settings/ffmpeg/TranscodeConfigAudioSettingsForm.tsx
msgid "Audio Loudness Normalization"
msgstr "Audio Loudness Normalization"

#: src/components/settings/ffmpeg/TranscodeConfigSettingsForm.tsx
msgid "Audio Options"
msgstr "Audio Options"

#: src/components/settings/ffmpeg/TranscodeConfigAudioSettingsForm.tsx
msgid "Audio Sample Rate"
msgstr "Audio Sample Rate"

#: src/pages/system/TroubleshootPage.tsx
msgid "Audio Streams"
msgstr "Audio Streams"

#: src/components/settings/ffmpeg/TranscodeConfigAudioSettingsForm.tsx
msgid "Audio Volume"
msgstr "Audio Volume"

#: src/components/settings/general/WebSettings.tsx
msgid "Auto"
msgstr "Auto"

#: src/components/settings/ffmpeg/TranscodeConfigVideoSettingsForm.tsx
msgid "Auto Deinterlace Video"
msgstr "Auto Deinterlace Video"

#: src/components/settings/general/WebSettings.tsx
msgid "Auto uses the time convention for the selected language."
msgstr "Auto uses the time convention for the selected language."

#: src/components/settings/media_source/PlexServerEditDialog.tsx
msgid "Auto-Update Guide"
msgstr "Auto-Update Guide"

#: src/components/programming_controls/AdjustWeightsModal.tsx
msgid "Automatic"
msgstr "Automatic"

#. placeholder {0}: betterHumanize(dayjs.duration(averageLengthMs))
#: src/components/slot_scheduler/SlotProgrammingTooLongWarningDetails.tsx
msgid "Average program length: {0}"
msgstr "Average program length: {0}"

#: src/pages/welcome/WelcomePage.tsx
#~ msgid "Back"
#~ msgstr "Back"

#: src/pages/channels/RandomSlotEditorPage.tsx
#: src/pages/channels/TimeSlotEditorPage.tsx
msgid "Back to Programming"
msgstr "Back to Programming"

#: src/components/settings/general/GeneralSettingsForm.tsx
msgid "Backups"
msgstr "Backups"

#: src/pages/system/StatusPage.tsx
msgid "Backups:"
msgstr "Backups:"

#: src/components/programming_controls/BalanceProgrammingModal.tsx
msgid "Balance"
msgstr "Balance"

#: src/components/programming_controls/BalanceProgrammingModal.tsx
msgid "Balance By:"
msgstr "Balance By:"

#: src/components/programming_controls/BalanceProgrammingModal.tsx
msgid "Balance Programming"
msgstr "Balance Programming"

#: src/components/channel_config/ChannelProgrammingOrganizeOptions.tsx
msgid "Balance..."
msgstr "Balance..."

#: src/components/channel_config/plex/PlexProgrammingFilterToolbar.tsx
#~ msgid "Basic"
#~ msgstr "Basic"

#: src/components/custom-shows/CustomShowSortToolsMenu.tsx
msgid "Basic button group"
msgstr "Basic button group"

#: src/pages/system/TroubleshootPage.tsx
msgid "Bit Depth"
msgstr "Bit Depth"

#: src/components/settings/ffmpeg/TranscodeConfigAudioSettingsForm.tsx
msgid "Bitrate cannot be changed when copying input audio"
msgstr "Bitrate cannot be changed when copying input audio"

#: src/components/programming_controls/AddRerunBlockModal.tsx
msgid "Block"
msgstr "Block"

#: src/components/channel_config/ChannelProgrammingSort.tsx
#: src/components/channel_config/ChannelProgrammingSort.tsx
#: src/components/custom-shows/CustomShowSortToolsMenu.tsx
#: src/components/custom-shows/CustomShowSortToolsMenu.tsx
#: src/components/programming_controls/AddBlockShuffleModal.tsx
msgid "Block Shuffle"
msgstr "Block Shuffle"

#: src/components/slot_scheduler/MidRollConfigPanel.tsx
msgid "Break Duration"
msgstr "Break Duration"

#: src/components/slot_scheduler/MidRollConfigPanel.tsx
msgid "Break Duration (minutes)"
msgstr "Break Duration (minutes)"

#: src/components/slot_scheduler/MidRollConfigPanel.tsx
msgid "Break Interval (minutes)"
msgstr "Break Interval (minutes)"

#: src/components/slot_scheduler/MidRollConfigPanel.tsx
msgid "Break Positioning"
msgstr "Break Positioning"

#: src/components/settings/ffmpeg/TranscodeConfigAudioSettingsForm.tsx
msgid "Buffer size cannot be changed when copying input audio"
msgstr "Buffer size cannot be changed when copying input audio"

#: src/components/settings/ffmpeg/TranscodeConfigVideoSettingsForm.tsx
msgid "Buffer size effects how frequently ffmpeg reconsiders the output bitrate. <0>Read more</0>"
msgstr "Buffer size effects how frequently ffmpeg reconsiders the output bitrate. <0>Read more</0>"

#: src/pages/system/TroubleshootPage.tsx
msgid "Builder"
msgstr "Builder"

#: src/components/settings/general/BackupForm.tsx
msgid "By default, saves backups in the server's run directory, or, if running in Docker, to /config/tunarr/backups"
msgstr "By default, saves backups in the server's run directory, or, if running in Docker, to /config/tunarr/backups"

#: src/pages/channels/TimeSlotEditorPage.tsx
msgid "By default, time slots are time of the day-based, you can change it to time of the day + day of the week. That means scheduling 7x the number of time slots. If you change from daily to weekly, the current schedule will be repeated 7 times. If you change from weekly to daily, many of the slots will be deleted."
msgstr "By default, time slots are time of the day-based, you can change it to time of the day + day of the week. That means scheduling 7x the number of time slots. If you change from daily to weekly, the current schedule will be repeated 7 times. If you change from weekly to daily, many of the slots will be deleted."

#: src/components/settings/general/GeneralSettingsForm.tsx
#~ msgid "Caching"
#~ msgstr "Caching"

#: src/hooks/slot_scheduler/useScheduleSlots.ts
msgid "Calculated {humanizedDuration} ({numShows} programs) of programming in {duration}ms"
msgstr "Calculated {humanizedDuration} ({numShows} programs) of programming in {duration}ms"

#: src/components/programming_controls/AddBlockShuffleModal.tsx
msgid "Calculates a schedule where all programs end at the same time, creating a perfectly looping schedule."
msgstr "Calculates a schedule where all programs end at the same time, creating a perfectly looping schedule."

#: src/pages/channels/RandomSlotEditorPage.tsx
msgid "Calculating Slots..."
msgstr "Calculating Slots..."

#: src/components/channels/ChannelDeleteDialog.tsx
#: src/components/DeleteConfirmationDialog.tsx
#: src/components/programming_controls/AddBlockShuffleModal.tsx
#: src/components/programming_controls/AddBreaksModal.tsx
#: src/components/programming_controls/AddFlexModal.tsx
#: src/components/programming_controls/AddPaddingModal.tsx
#: src/components/programming_controls/AddRedirectModal.tsx
#: src/components/programming_controls/AddReplicateModal.tsx
#: src/components/programming_controls/AddRerunBlockModal.tsx
#: src/components/programming_controls/AddRestrictHoursModal.tsx
#: src/components/programming_controls/AdjustWeightsModal.tsx
#: src/components/programming_controls/BalanceProgrammingModal.tsx
#: src/components/programming_controls/RemoveShowsModal.tsx
#: src/components/programming_controls/ShuffleProgrammingModal.tsx
#: src/components/settings/media_source/EmbyServerEditDialog.tsx
#: src/components/settings/media_source/JelllyfinServerEditDialog.tsx
#: src/components/settings/media_source/LocalMediaEditDialog.tsx
#: src/components/settings/media_source/PlexServerEditDialog.tsx
#: src/components/settings/UnsavedNavigationAlert.tsx
#: src/components/slot_scheduler/EditRandomSlotDialogContent.tsx
#: src/components/slot_scheduler/EditTimeSlotDialogContent.tsx
#: src/components/slot_scheduler/RandomSlotsWeightAdjustDialog.tsx
#: src/components/slot_scheduler/SlotLinkingControl.tsx
#: src/components/slot_scheduler/SlotSchedulerCyclicShuffleDialog.tsx
#: src/components/smart_collections/CreateSmartCollectionDialog.tsx
#: src/components/smart_collections/EditSmartCollectionDialog.tsx
#: src/pages/channels/ChannelsPage.tsx
#: src/pages/library/CustomShowsPage.tsx
#: src/pages/library/FillerListsPage.tsx
#: src/pages/library/TrashPage.tsx
msgid "Cancel"
msgstr "Cancel"

#: src/components/settings/media_source/EmbyServerEditDialog.tsx
#: src/components/settings/media_source/JelllyfinServerEditDialog.tsx
#: src/components/settings/media_source/PlexServerEditDialog.tsx
msgid "Cannot be empty"
msgstr "Cannot be empty"

#: src/components/MediaSourceLibraryTable.tsx
#: src/components/settings/media_source/EditMediaSourceLibrariesDialog.tsx
msgid "Cannot disable libraries when they are locked"
msgstr "Cannot disable libraries when they are locked"

#: src/components/channel_config/ChannelPropertiesEditor.tsx
msgid "Cannot use a channel number <= 0"
msgstr "Cannot use a channel number <= 0"

#: src/components/programs/Actors.tsx
msgid "Cast & Crew"
msgstr "Cast & Crew"

#: src/components/settings/general/GeneralSettingsForm.tsx
msgid "Category Log Levels"
msgstr "Category Log Levels"

#: src/components/settings/general/GeneralSettingsForm.tsx
msgid "Change the verbosity of specific categories of logs. Useful if debugging a specific feature."
msgstr "Change the verbosity of specific categories of logs. Useful if debugging a specific feature."

#: src/components/programming_controls/AddRedirectModal.tsx
#: src/components/programming_controls/AddRedirectModal.tsx
#: src/components/shell/CommandPaletteContainer.tsx
#: src/pages/system/TroubleshootPage.tsx
#: src/pages/system/TroubleshootPage.tsx
msgid "Channel"
msgstr "Channel"

#. placeholder {0}: channel.number
#: src/pages/channels/ChannelSummaryPage.tsx
msgid "Channel #{0}"
msgstr "Channel #{0}"

#: src/components/channel_config/ChannelFlexConfig.tsx
msgid "Channel Fallback"
msgstr "Channel Fallback"

#: src/components/channel_config/ChannelPropertiesEditor.tsx
msgid "Channel Group"
msgstr "Channel Group"

#: src/components/channel_config/ChannelPropertiesEditor.tsx
#: src/components/channel_config/ChannelPropertiesEditor.tsx
msgid "Channel group is required"
msgstr "Channel group is required"

#: src/components/channel_config/ChannelPropertiesEditor.tsx
msgid "Channel Name"
msgstr "Channel Name"

#: src/components/channel_config/ChannelPropertiesEditor.tsx
#: src/components/channel_config/ChannelPropertiesEditor.tsx
msgid "Channel name is required"
msgstr "Channel name is required"

#: src/components/channel_config/ChannelPropertiesEditor.tsx
msgid "Channel Number"
msgstr "Channel Number"

#: src/components/channel_config/ChannelEditActions.tsx
msgid "Channel settings saved!"
msgstr "Channel settings saved!"

#: src/components/channel_config/ChannelTranscodingConfig.tsx
#: src/components/channel_config/ChannelTranscodingConfig.tsx
msgid "Channel Stream Mode"
msgstr "Channel Stream Mode"

#: src/components/channel_config/ChannelTranscodingConfig.tsx
#: src/components/channel_config/ChannelTranscodingConfig.tsx
msgid "Channel Transcode Config"
msgstr "Channel Transcode Config"

#: src/App.tsx
#: src/components/shell/CommandPaletteContainer.tsx
#: src/components/shell/useShellNav.tsx
#: src/hooks/useRouteName.ts
#: src/pages/channels/ChannelsPage.tsx
#: src/pages/system/TroubleshootPage.tsx
msgid "Channels"
msgstr "Channels"

#: src/pages/settings/FfmpegSettingsPage.tsx
msgid "Channels configured to use the HLS Direct stream mode will output in the selected container format."
msgstr "Channels configured to use the HLS Direct stream mode will output in the selected container format."

#: src/pages/system/StatusPage.tsx
msgid "Channels M3U Link:"
msgstr "Channels M3U Link:"

#: src/pages/welcome/WelcomePage.tsx
msgid "Channels play your content on a schedule, like live TV."
msgstr "Channels play your content on a schedule, like live TV."

#: src/components/settings/ffmpeg/EtvNextCompatibilityNotice.tsx
msgid "Channels using this config cannot stream on the ErsatzTV next backend"
msgstr "Channels using this config cannot stream on the ErsatzTV next backend"

#: src/pages/system/SystemDebugPage.tsx
#: src/pages/system/SystemDebugPage.tsx
msgid "Check"
msgstr "Check"

#: src/pages/welcome/WelcomePage.tsx
msgid "Check FFmpeg"
msgstr "Check FFmpeg"

#: src/components/channel_config/ChannelTranscodingConfig.tsx
msgid "Choose the transcode configuration to use for this channel. Configure transcode configurations on the <0>FFmpeg settings page</0>."
msgstr "Choose the transcode configuration to use for this channel. Configure transcode configurations on the <0>FFmpeg settings page</0>."

#: src/components/channel_config/SelectedProgrammingActions.tsx
#: src/components/search/SearchFieldRestrictMenu.tsx
msgid "Clear"
msgstr "Clear"

#: src/components/custom-shows/CustomShowSortToolsMenu.tsx
#: src/components/filler/EditFillerListForm.tsx
#: src/components/slot_scheduler/ClearSlotsButton.tsx
msgid "Clear All"
msgstr "Clear All"

#: src/components/ui/table/DataTable.tsx
msgid "Clear filters"
msgstr "Clear filters"

#: src/components/channel_config/ChannelProgrammingDeleteOptions.tsx
msgid "Clear Schedule"
msgstr "Clear Schedule"

#: src/components/channel_config/CustomShowProgrammingSelector.tsx
msgid "Click to preview the items in this Custom Show. Note that only the whole show can be added at once."
msgstr "Click to preview the items in this Custom Show. Note that only the whole show can be added at once."

#: src/components/ui/patterns/AppShell/CommandPalette.tsx
msgid "close"
msgstr "close"

#: src/components/channel_config/SelectedProgrammingList.tsx
#: src/components/channels/ChannelSessionsDialog.tsx
#: src/components/settings/media_source/EditMediaSourceLibrariesDialog.tsx
msgid "Close"
msgstr "Close"

#: src/pages/system/TroubleshootPage.tsx
#: src/pages/system/TroubleshootPage.tsx
#: src/pages/system/TroubleshootPage.tsx
msgid "Codec"
msgstr "Codec"

#: src/components/channel_config/plex/PlexProgrammingSelector.tsx
#~ msgid "Collections"
#~ msgstr "Collections"

#: src/pages/system/TroubleshootPage.tsx
msgid "Color"
msgstr "Color"

#: src/components/settings/general/WebSettings.tsx
msgid "Comfortable"
msgstr "Comfortable"

#: src/components/slot_scheduler/RandomSlotsWeightAdjustDialog.tsx
msgid "Commit"
msgstr "Commit"

#: src/components/channel_config/ChannelProgrammingSort.tsx
#: src/components/custom-shows/CustomShowSortToolsMenu.tsx
msgid "Completely randomizes the order of programs."
msgstr "Completely randomizes the order of programs."

#: src/pages/system/SystemLogsPage.tsx
msgid "Component"
msgstr "Component"

#: src/pages/system/TroubleshootPage.tsx
msgid "Condition"
msgstr "Condition"

#: src/components/slot_scheduler/EditTimeSlotDialogContent.tsx
msgid "Config"
msgstr "Config"

#: src/components/slot_scheduler/SlotSchedulerCyclicShuffleDialog.tsx
msgid "Configure Cyclic Shuffle"
msgstr "Configure Cyclic Shuffle"

#: src/pages/settings/FfmpegSettingsPage.tsx
msgid "Configure preferred audio languages globally."
msgstr "Configure preferred audio languages globally."

#: src/components/channel_config/ChannelTranscodingConfig.tsx
msgid "Configure subtitle preferences. Preferences are evaluated in order of priority. The first matching subtitle stream on a program will be used."
msgstr "Configure subtitle preferences. Preferences are evaluated in order of priority. The first matching subtitle stream on a program will be used."

#: src/pages/settings/FfmpegSettingsPage.tsx
msgid "Configure transcoding settings for Tunarr's streams. Each channel is assigned one transcode configuration."
msgstr "Configure transcoding settings for Tunarr's streams. Each channel is assigned one transcode configuration."

#: src/components/channel_config/ChannelFlexConfig.tsx
msgid "Configure what appears on your channel when there is no suitable filler content available. Using channel fallbacks requires ffmpeg transcoding."
msgstr "Configure what appears on your channel when there is no suitable filler content available. Using channel fallbacks requires ffmpeg transcoding."

#: src/pages/welcome/WelcomePage.tsx
#~ msgid "Congrats, you're ready to start building channels! Just click Finish below to start working on your first channel."
#~ msgstr "Congrats, you're ready to start building channels! Just click Finish below to start working on your first channel."

#: src/pages/welcome/WelcomePage.tsx
msgid "Connect a media source"
msgstr "Connect a media source"

#: src/components/channel_config/ProgrammingSelector.tsx
msgid "Connect Media Source"
msgstr "Connect Media Source"

#: src/pages/welcome/WelcomePage.tsx
#~ msgid "Connect Media Sources"
#~ msgstr "Connect Media Sources"

#: src/pages/welcome/WelcomePage.tsx
#~ msgid "Connect Sources"
#~ msgstr "Connect Sources"

#: src/pages/settings/FfmpegSettingsPage.tsx
msgid "Console"
msgstr "Console"

#: src/components/channel_config/ChannelProgrammingOrganizeOptions.tsx
msgid "Consolidate"
msgstr "Consolidate"

#: src/components/channel_config/ChannelProgrammingOrganizeOptions.tsx
msgid "Consolidates contiguous match flex and redirect blocks into singular spans"
msgstr "Consolidates contiguous match flex and redirect blocks into singular spans"

#: src/components/slot_scheduler/SlotLinkingControl.tsx
msgid "Continue"
msgstr "Continue"

#: src/components/slot_scheduler/SlotLinkingControl.tsx
msgid "Continue with New Content"
msgstr "Continue with New Content"

#: src/components/slot_scheduler/SlotLinkingControl.tsx
msgid "Controls what happens when this slot runs out of replayed content from earlier continue slots."
msgstr "Controls what happens when this slot runs out of replayed content from earlier continue slots."

#: src/components/slot_scheduler/EditRandomSlotDialogContent.tsx
#: src/components/slot_scheduler/RandomSlotTable.tsx
msgid "Cooldown"
msgstr "Cooldown"

#: src/components/channel_config/ChannelFlexConfig.tsx
msgid "Cooldown (s)"
msgstr "Cooldown (s)"

#: src/components/channel_config/ChannelFlexConfig.tsx
#~ msgid "Cooldown (seconds)"
#~ msgstr "Cooldown (seconds)"

#: src/components/TopBar.tsx
#~ msgid "Copied {0} URL to clipboard"
#~ msgstr "Copied {0} URL to clipboard"

#: src/components/channels/ChannelOptionsMenu.tsx
msgid "Copied channel \"{channelName}\" m3u link to clipboard"
msgstr "Copied channel \"{channelName}\" m3u link to clipboard"

#: src/components/channels/ChannelOptionsMenu.tsx
msgid "Copied Channel ID!"
msgstr "Copied Channel ID!"

#: src/components/shell/HelpMenuContainer.tsx
msgid "Copied M3U URL to clipboard"
msgstr "Copied M3U URL to clipboard"

#: src/hooks/useCopyToClipboard.ts
msgid "Copied to clipboard!"
msgstr "Copied to clipboard!"

#: src/components/shell/HelpMenuContainer.tsx
msgid "Copied XMLTV URL to clipboard"
msgstr "Copied XMLTV URL to clipboard"

#: src/pages/system/SystemDebugPage.tsx
#: src/pages/system/SystemDebugPage.tsx
#: src/pages/system/SystemDebugPage.tsx
msgid "Copy"
msgstr "Copy"

#: src/components/channels/ChannelOptionsMenu.tsx
msgid "Copy Channel ID"
msgstr "Copy Channel ID"

#: src/pages/system/TroubleshootPage.tsx
msgid "Copy Full Report"
msgstr "Copy Full Report"

#: src/components/channels/ChannelOptionsMenu.tsx
#: src/components/ui/patterns/AppShell/HelpMenu.tsx
msgid "Copy M3U URL"
msgstr "Copy M3U URL"

#: src/pages/system/TroubleshootPage.tsx
msgid "Copy to clipboard"
msgstr "Copy to clipboard"

#: src/components/ProgramStreamDetails.tsx
#: src/components/RawProgramDetails.tsx
msgid "Copy to Clipboard"
msgstr "Copy to Clipboard"

#: src/components/ui/patterns/AppShell/HelpMenu.tsx
msgid "Copy XMLTV URL"
msgstr "Copy XMLTV URL"

#: src/hooks/useEmptyTrash.ts
msgid "Could not cancel emptying the trash."
msgstr "Could not cancel emptying the trash."

#: src/components/search/SearchFilterBuilder.tsx
msgid "Could not parse this filter expression. Check the <0>documentation</0> for information about filter expressions."
msgstr "Could not parse this filter expression. Check the <0>documentation</0> for information about filter expressions."

#: src/pages/welcome/WelcomePage.tsx
msgid "Could not save setup progress. {message}"
msgstr "Could not save setup progress. {message}"

#: src/components/smart_collections/SmartCollectionsTable.tsx
msgid "Create"
msgstr "Create"

#: src/pages/welcome/WelcomePage.tsx
msgid "Create a channel"
msgstr "Create a channel"

#: src/components/channel_config/NoChannelsCreated.tsx
msgid "Create a Channel"
msgstr "Create a Channel"

#: src/components/programming_controls/AddRerunBlockModal.tsx
msgid "Create Rerun Block"
msgstr "Create Rerun Block"

#: src/components/smart_collections/CreateSmartCollectionDialog.tsx
msgid "Creates a new collection"
msgstr "Creates a new collection"

#: src/components/guide/TvGuide.tsx
msgid "Custom Program"
msgstr "Custom Program"

#: src/components/shell/CommandPaletteContainer.tsx
msgid "Custom show"
msgstr "Custom show"

#: src/components/slot_scheduler/CustomShowSlotProgrammingForm.tsx
#: src/components/slot_scheduler/SlotSchedulerCyclicShuffleDialog.tsx
#: src/components/slot_scheduler/SlotSchedulerCyclicShuffleDialog.tsx
#: src/hooks/useProgramTitleFormatter.ts
msgid "Custom Show"
msgstr "Custom Show"

#. placeholder {0}: customShow.name
#. placeholder {0}: showName ?? ''
#: src/components/channel_config/SelectedProgrammingList.tsx
#: src/hooks/slot_scheduler/useSlotName.ts
msgid "Custom Show - {0}"
msgstr "Custom Show - {0}"

#: src/components/slot_scheduler/EditSlotProgrammingForm.tsx
msgid "Custom Show (add programs to a custom show first)"
msgstr "Custom Show (add programs to a custom show first)"

#: src/components/programming_controls/AddBlockShuffleModal.tsx
msgid "Custom show programs are grouped by their parent show"
msgstr "Custom show programs are grouped by their parent show"

#. placeholder {0}: cs.description
#: src/components/slot_scheduler/SlotSchedulerCyclicShuffleDialog.tsx
msgid "Custom Show: {0}"
msgstr "Custom Show: {0}"

#: src/components/channel_config/ProgrammingSelector.tsx
#: src/components/shell/CommandPaletteContainer.tsx
#: src/components/shell/useShellNav.tsx
#: src/hooks/useRouteName.ts
#: src/pages/library/CustomShowsPage.tsx
msgid "Custom Shows"
msgstr "Custom Shows"

#: src/pages/library/CustomShowsPage.tsx
msgid "Custom Shows are sequences of videos that represent a episodes of a virtual TV show. When you add these shows to a channel, the schedule tools will treat the videos as if they belonged to a single TV show."
msgstr "Custom Shows are sequences of videos that represent a episodes of a virtual TV show. When you add these shows to a channel, the schedule tools will treat the videos as if they belonged to a single TV show."

#: src/components/programming_controls/AddBlockShuffleModal.tsx
msgid "Customize how movie blocks are sorted"
msgstr "Customize how movie blocks are sorted"

#: src/components/channel_config/ChannelProgrammingSort.tsx
#: src/components/channel_config/ChannelProgrammingSort.tsx
#: src/components/programming_controls/AddBlockShuffleModal.tsx
msgid "Cyclic Shuffle"
msgstr "Cyclic Shuffle"

#: src/components/slot_scheduler/SlotSchedulerCyclicShuffleDialog.tsx
msgid "Cyclic Shuffle randomly shuffles groups of programming."
msgstr "Cyclic Shuffle randomly shuffles groups of programming."

#: src/pages/channels/TimeSlotEditorPage.tsx
msgid "Daily"
msgstr "Daily"

#: src/components/settings/DarkModeButton.tsx
msgid "Dark"
msgstr "Dark"

#: src/pages/system/StatusPage.tsx
msgid "Data Directory:"
msgstr "Data Directory:"

#: src/components/channel_config/ChannelProgrammingConfig.tsx
#: src/components/slot_scheduler/EditTimeSlotDialogContent.tsx
#: src/components/slot_scheduler/EditTimeSlotDialogContent.tsx
msgid "Day"
msgstr "Day"

#: src/components/slot_scheduler/RandomSlotSettingsForm.tsx
#: src/components/slot_scheduler/RandomSlotSettingsForm.tsx
#: src/pages/channels/TimeSlotEditorPage.tsx
#: src/pages/channels/TimeSlotEditorPage.tsx
msgid "Days to Precalculate"
msgstr "Days to Precalculate"

#: src/components/shell/useShellNav.tsx
msgid "Debug"
msgstr "Debug"

#: src/pages/system/TroubleshootPage.tsx
#: src/pages/system/TroubleshootPage.tsx
msgid "Default"
msgstr "Default"

#: src/components/settings/ffmpeg/TranscodeConfigsTable.tsx
msgid "Default Config"
msgstr "Default Config"

#: src/components/channel_config/ChannelProgrammingDeleteOptions.tsx
#: src/components/channels/ChannelDeleteDialog.tsx
#: src/components/custom-shows/CustomShowSortToolsMenu.tsx
#: src/components/DeleteConfirmationDialog.tsx
#: src/components/settings/ffmpeg/TranscodeConfigsTable.tsx
#: src/components/smart_collections/SmartCollectionsTable.tsx
#: src/pages/channels/ChannelsPage.tsx
#: src/pages/library/CustomShowsPage.tsx
#: src/pages/library/CustomShowsPage.tsx
#: src/pages/library/FillerListsPage.tsx
#: src/pages/library/FillerListsPage.tsx
#: src/pages/library/FillerListsPage.tsx
msgid "Delete"
msgstr "Delete"

#. placeholder {0}: deletingSmartCollection?.name
#: src/components/smart_collections/SmartCollectionsTable.tsx
msgid "Delete \"{0}\""
msgstr "Delete \"{0}\""

#: src/components/channels/ChannelOptionsMenu.tsx
#: src/pages/channels/ChannelsPage.tsx
msgid "Delete Channel"
msgstr "Delete Channel"

#. placeholder {0}: channel.name
#: src/components/channels/ChannelDeleteDialog.tsx
msgid "Delete Channel \"{0}\"?"
msgstr "Delete Channel \"{0}\"?"

#. placeholder {0}: find(customShows, { id: deleteConfirmationId })?.name
#: src/pages/library/CustomShowsPage.tsx
msgid "Delete Custom Show \"{0}\"?"
msgstr "Delete Custom Show \"{0}\"?"

#. placeholder {0}: find(fillerLists, { id: deleteConfirmationId })?.name
#: src/pages/library/FillerListsPage.tsx
msgid "Delete Filler List \"{0}\"?"
msgstr "Delete Filler List \"{0}\"?"

#. placeholder {0}: deletingMediaSource?.name
#: src/pages/settings/MediaSourceSettingsPage.tsx
msgid "Delete Media Source \"{0}\"?"
msgstr "Delete Media Source \"{0}\"?"

#: src/components/settings/media_source/MediaSourceDeleteDialog.tsx
#~ msgid "Delete Media Source?"
#~ msgstr "Delete Media Source?"

#: src/components/slot_scheduler/RandomSlotTable.tsx
#: src/components/slot_scheduler/TimeSlotTable.tsx
msgid "Delete Slot"
msgstr "Delete Slot"

#. placeholder {0}: confirmDeleteTranscodeConfig?.name
#. placeholder {0}: confirmDeleteTranscodeConfig?.name ?? ''
#: src/components/settings/ffmpeg/TranscodeConfigsTable.tsx
#: src/pages/settings/FfmpegSettingsPage.tsx
msgid "Delete Transcoding Config \"{0}\"?"
msgstr "Delete Transcoding Config \"{0}\"?"

#: src/components/slot_scheduler/CustomShowSlotProgrammingForm.tsx
msgid "Deleted custom show"
msgstr "Deleted custom show"

#: src/components/channels/ChannelDeleteDialog.tsx
#: src/pages/channels/ChannelsPage.tsx
msgid "Deleting a Channel will remove all programming from the channel. This action cannot be undone."
msgstr "Deleting a Channel will remove all programming from the channel. This action cannot be undone."

#: src/pages/library/CustomShowsPage.tsx
msgid "Deleting a Custom Show will remove its programming from channels that use it. This action cannot be undone."
msgstr "Deleting a Custom Show will remove its programming from channels that use it. This action cannot be undone."

#: src/pages/library/FillerListsPage.tsx
msgid "Deleting a Filler will remove all programming from the channel. This action cannot be undone."
msgstr "Deleting a Filler will remove all programming from the channel. This action cannot be undone."

#: src/pages/settings/MediaSourceSettingsPage.tsx
msgid "Deleting a media source will remove all of its associated programs from Tunarr."
msgstr "Deleting a media source will remove all of its associated programs from Tunarr."

#: src/components/settings/media_source/MediaSourceDeleteDialog.tsx
#~ msgid "Deleting a Plex server will remove all programming from your channels associated with this plex server. Missing programming will be replaced with Flex time. This action cannot be undone."
#~ msgstr "Deleting a Plex server will remove all programming from your channels associated with this plex server. Missing programming will be replaced with Flex time. This action cannot be undone."

#: src/components/settings/general/WebSettings.tsx
msgid "Dense"
msgstr "Dense"

#: src/components/settings/general/WebSettings.tsx
msgid "Dense fits more rows on screen with smaller controls."
msgstr "Dense fits more rows on screen with smaller controls."

#: src/components/settings/general/WebSettings.tsx
#: src/components/settings/general/WebSettings.tsx
msgid "Density"
msgstr "Density"

#: src/components/slot_scheduler/SlotOrderFormControl.tsx
msgid "Desc"
msgstr "Desc"

#: src/components/programming_controls/AddBlockShuffleModal.tsx
msgid "Descending"
msgstr "Descending"

#: src/pages/settings/TaskSettingsPage.tsx
msgid "Description"
msgstr "Description"

#: src/components/channels/ChannelNowPlayingCard.tsx
msgid "Details"
msgstr "Details"

#: src/components/settings/media_source/JelllyfinServerEditDialog.tsx
msgid "Did not receive an accessToken or userId from Jellyfin server."
msgstr "Did not receive an accessToken or userId from Jellyfin server."

#: src/components/settings/ffmpeg/TranscodeConfigAdvancedOptions.tsx
msgid "Disable Hardware Decoding"
msgstr "Disable Hardware Decoding"

#: src/components/settings/ffmpeg/TranscodeConfigAdvancedOptions.tsx
msgid "Disable Hardware Encoding"
msgstr "Disable Hardware Encoding"

#: src/components/settings/ffmpeg/TranscodeConfigAdvancedOptions.tsx
msgid "Disable Hardware Filters"
msgstr "Disable Hardware Filters"

#: src/components/channel_config/ChannelTranscodingConfig.tsx
msgid "Disable Image Scaling"
msgstr "Disable Image Scaling"

#: src/components/settings/ffmpeg/TranscodeConfigSettingsForm.tsx
msgid "Disable Watermarks"
msgstr "Disable Watermarks"

#: src/components/settings/ffmpeg/TranscodeConfigAudioSettingsForm.tsx
#: src/pages/settings/FfmpegSettingsPage.tsx
#: src/pages/system/StatusPage.tsx
msgid "Disabled"
msgstr "Disabled"

#: src/hooks/useVersion.tsx
msgid "Dismiss"
msgstr "Dismiss"

#: src/components/channel_config/ChannelTranscodingConfig.tsx
msgid "Display Watermark on Leading Edge"
msgstr "Display Watermark on Leading Edge"

#. placeholder {0}: logBuf.length
#: src/pages/system/SystemLogsPage.tsx
msgid "Displays the last {0} system log events. Use the buttons below to export these logs or download the entire log file for debugging."
msgstr "Displays the last {0} system log events. Use the buttons below to export these logs or download the entire log file for debugging."

#: src/components/slot_scheduler/RandomSlotSettingsForm.tsx
#: src/components/slot_scheduler/RandomSlotSettingsForm.tsx
msgid "Distribution"
msgstr "Distribution"

#: src/components/programming_controls/AddRerunBlockModal.tsx
msgid "Divides the programming in blocks of 4, 6, 8 or 12 hours then repeats each of the blocks the specified number of times."
msgstr "Divides the programming in blocks of 4, 6, 8 or 12 hours then repeats each of the blocks the specified number of times."

#: src/components/programming_controls/ShuffleProgrammingModal.tsx
msgid "Do not group programs at all. Normal shuffle."
msgstr "Do not group programs at all. Normal shuffle."

#: src/pages/welcome/WelcomePage.tsx
msgid "Docs"
msgstr "Docs"

#: src/components/ui/patterns/AppShell/HelpMenu.tsx
msgid "Documentation"
msgstr "Documentation"

#: src/components/MediaSourceLibraryTable.tsx
#~ msgid "Don't see the library you want here? Ensure it is enabled in the <0>Media Source Settings.</0>"
#~ msgstr "Don't see the library you want here? Ensure it is enabled in the <0>Media Source Settings.</0>"

#: src/components/slot_scheduler/RandomSlotWarningsDialog.tsx
#: src/components/slot_scheduler/TimeSlotWarningsDialog.tsx
msgid "Done"
msgstr "Done"

#: src/pages/system/SystemLogsPage.tsx
msgid "Download all logs"
msgstr "Download all logs"

#: src/pages/system/TroubleshootPage.tsx
msgid "Download Backend Diagnostics ({dossierCount})"
msgstr "Download Backend Diagnostics ({dossierCount})"

#: src/pages/system/TroubleshootPage.tsx
msgid "Download JSON"
msgstr "Download JSON"

#. placeholder {0}: table.getRowCount()
#. placeholder {1}: table.getRowCount()
#: src/pages/system/SystemLogsPage.tsx
msgid "Download last {0} {1, plural, one {# row} other {# rows}}"
msgstr "Download last {0} {1, plural, one {# row} other {# rows}}"

#: src/components/settings/ffmpeg/TranscodeConfigsTable.tsx
msgid "Duplicate"
msgstr "Duplicate"

#: src/components/channels/ChannelOptionsMenu.tsx
msgid "Duplicate Channel"
msgstr "Duplicate Channel"

#: src/components/channel_config/ChannelProgrammingDeleteOptions.tsx
msgid "Duplicates"
msgstr "Duplicates"

#: src/components/programming_controls/BalanceProgrammingModal.tsx
#: src/components/slot_scheduler/EditRandomSlotDialogContent.tsx
#: src/components/slot_scheduler/RandomSlotTable.tsx
#: src/pages/channels/ChannelsPage.tsx
#: src/pages/system/TroubleshootPage.tsx
msgid "Duration"
msgstr "Duration"

#: src/components/programming_controls/AddFlexModal.tsx
#: src/components/programming_controls/AddRedirectModal.tsx
msgid "Duration (seconds)"
msgstr "Duration (seconds)"

#: src/components/programming_controls/AddFlexModal.tsx
msgid "Duration must be greater than 0."
msgstr "Duration must be greater than 0."

#: src/components/programming_controls/AddFlexModal.tsx
msgid "Duration must be numeric"
msgstr "Duration must be numeric"

#: src/components/slot_scheduler/EditRandomSlotDialogContent.tsx
msgid "Dynamic"
msgstr "Dynamic"

#: src/components/programming_controls/AddBlockShuffleModal.tsx
msgid "Each next block comes from a random show. Shows with more episodes come up more often unless Loop Short Programs is on."
msgstr "Each next block comes from a random show. Shows with more episodes come up more often unless Loop Short Programs is on."

#: src/components/slot_scheduler/MidRollConfigPanel.tsx
msgid "Eager"
msgstr "Eager"

#: src/components/settings/ConnectMediaSources.tsx
#: src/components/settings/ffmpeg/TranscodeConfigsTable.tsx
#: src/components/smart_collections/SmartCollectionsTable.tsx
#: src/hooks/useRouteName.ts
#: src/hooks/useRouteName.ts
#: src/hooks/useRouteName.ts
#: src/pages/library/CustomShowsPage.tsx
#: src/pages/library/FillerListsPage.tsx
#: src/pages/library/FillerListsPage.tsx
msgid "Edit"
msgstr "Edit"

#: src/components/channels/ChannelOptionsMenu.tsx
msgid "Edit Channel"
msgstr "Edit Channel"

#: src/components/programming_controls/AddRedirectModal.tsx
msgid "Edit Channel Redirect"
msgstr "Edit Channel Redirect"

#: src/pages/channels/ChannelsPage.tsx
msgid "Edit Channel Settings"
msgstr "Edit Channel Settings"

#: src/pages/library/EditFillerPage.tsx
msgid "Edit Filler List"
msgstr "Edit Filler List"

#: src/components/programming_controls/AddFlexModal.tsx
msgid "Edit Flex Time"
msgstr "Edit Flex Time"

#: src/pages/settings/MediaSourceSettingsPage.tsx
msgid "Edit Libraries"
msgstr "Edit Libraries"

#: src/pages/settings/MediaSourceSettingsPage.tsx
msgid "Edit Media Source"
msgstr "Edit Media Source"

#: src/components/slot_scheduler/RandomSlotTable.tsx
#: src/components/slot_scheduler/RandomSlotTable.tsx
#: src/components/slot_scheduler/TimeSlotTable.tsx
#: src/components/slot_scheduler/TimeSlotTable.tsx
msgid "Edit Slot"
msgstr "Edit Slot"

#: src/hooks/useRouteName.ts
msgid "Edit Transcode Config"
msgstr "Edit Transcode Config"

#. placeholder {0}: initialConfig.name
#: src/components/settings/ffmpeg/TranscodeConfigSettingsForm.tsx
msgid "Edit Transcode Config: \"{0}\""
msgstr "Edit Transcode Config: \"{0}\""

#. placeholder {0}: server.name
#. placeholder {0}: source.name
#: src/components/settings/media_source/EmbyServerEditDialog.tsx
#: src/components/settings/media_source/JelllyfinServerEditDialog.tsx
#: src/components/settings/media_source/LocalMediaEditDialog.tsx
msgid "Editing \"{0}\""
msgstr "Editing \"{0}\""

#. placeholder {0}: server.name
#: src/components/settings/media_source/PlexServerEditDialog.tsx
msgid "Editing Plex Server \"{0}\""
msgstr "Editing Plex Server \"{0}\""

#. placeholder {0}: smartCollection.name
#: src/components/smart_collections/EditSmartCollectionDialog.tsx
msgid "Editing Smart Collection \"{0}\""
msgstr "Editing Smart Collection \"{0}\""

#: src/components/settings/media_source/AddMediaSourceButton.tsx
msgid "Emby"
msgstr "Emby"

#. placeholder {0}: ev.detail.deleted
#: src/hooks/useEmptyTrash.ts
msgid "Emptied trash. Removed {0} item(s)."
msgstr "Emptied trash. Removed {0} item(s)."

#: src/pages/library/TrashPage.tsx
msgid "Empty Trash"
msgstr "Empty Trash"

#: src/hooks/useEmptyTrash.ts
msgid "Emptying the trash failed. Check the server logs for details."
msgstr "Emptying the trash failed. Check the server logs for details."

#: src/hooks/useEmptyTrash.ts
msgid "Emptying trash in the background. You can keep using Tunarr."
msgstr "Emptying trash in the background. You can keep using Tunarr."

#. placeholder {0}: status.deleted
#. placeholder {1}: status.total
#: src/pages/library/TrashPage.tsx
msgid "Emptying trash: {0} / {1}"
msgstr "Emptying trash: {0} / {1}"

#: src/components/settings/ffmpeg/TranscodeConfigAudioSettingsForm.tsx
msgid "Enable <0>EBU R 128</0> loudness normalization via the <1>loudnorm</1> FFmpeg filter. May increase CPU usage during streaming."
msgstr "Enable <0>EBU R 128</0> loudness normalization via the <1>loudnorm</1> FFmpeg filter. May increase CPU usage during streaming."

#: src/components/channel_config/ChannelTranscodingConfig.tsx
msgid "Enable Animation"
msgstr "Enable Animation"

#: src/components/settings/general/GeneralSettingsForm.tsx
msgid "Enable Backups"
msgstr "Enable Backups"

#: src/components/settings/DarkModeButton.tsx
msgid "Enable dark Mode"
msgstr "Enable dark Mode"

#: src/pages/settings/FfmpegSettingsPage.tsx
msgid "Enable embedded subtitle extraction"
msgstr "Enable embedded subtitle extraction"

#: src/pages/settings/FfmpegSettingsPage.tsx
msgid "Enable ffmpeg logging to different sinks. Outputting to a file will create a new log file for every spawned ffmpeg process in the Tunarr log directory. These files are automatically cleaned up by a background process."
msgstr "Enable ffmpeg logging to different sinks. Outputting to a file will create a new log file for every spawned ffmpeg process in the Tunarr log directory. These files are automatically cleaned up by a background process."

#: src/components/channel_config/ChannelTranscodingConfig.tsx
msgid "Enable if the watermark is an animated GIF or PNG. The watermark will loop according to the image's configuration. If this option is enabled and the image is not animated, there will be playback errors."
msgstr "Enable if the watermark is an animated GIF or PNG. The watermark will loop according to the image's configuration. If this option is enabled and the image is not animated, there will be playback errors."

#: src/components/settings/DarkModeButton.tsx
msgid "Enable light Mode"
msgstr "Enable light Mode"

#: src/components/settings/general/LogRollForm.tsx
msgid "Enable Log File Rolling"
msgstr "Enable Log File Rolling"

#: src/components/settings/general/LogRollForm.tsx
msgid "Enable rolling log files using time and/or size based criteria"
msgstr "Enable rolling log files using time and/or size based criteria"

#: src/pages/settings/HdhrSettingsPage.tsx
msgid "Enable SSDP server"
msgstr "Enable SSDP server"

#: src/components/channel_config/ChannelTranscodingConfig.tsx
msgid "Enable Subtitles"
msgstr "Enable Subtitles"

#: src/components/channel_config/ChannelTranscodingConfig.tsx
msgid "Enable Watermark"
msgstr "Enable Watermark"

#: src/components/channel_config/ChannelPropertiesEditor.tsx
#: src/pages/system/StatusPage.tsx
msgid "Enabled"
msgstr "Enabled"

#: src/components/settings/ffmpeg/TranscodeConfigAudioSettingsForm.tsx
msgid "Enabled (loudnorm)"
msgstr "Enabled (loudnorm)"

#: src/pages/settings/FfmpegSettingsPage.tsx
msgid "Enabling embedded subtitle extaction will periodically scan your upcoming programming for embedded text-based subtitle streams and extract them to a local cache. This is necessary in order to enable subtitle burning for text-based subtitles which are not external streams."
msgstr "Enabling embedded subtitle extaction will periodically scan your upcoming programming for embedded text-based subtitle streams and extract them to a local cache. This is necessary in order to enable subtitle burning for text-based subtitles which are not external streams."

#: src/hooks/useEmptyTrash.ts
msgid "Encountered an error when emptying trash. Check console logs for details."
msgstr "Encountered an error when emptying trash. Check console logs for details."

#: src/components/programming_controls/AddRestrictHoursModal.tsx
msgid "End Time"
msgstr "End Time"

#: src/pages/channels/TimeSlotEditorPage.tsx
msgid "Ensures programs have a nice-looking start time, it will add Flex time to fill the gaps."
msgstr "Ensures programs have a nice-looking start time, it will add Flex time to fill the gaps."

#: src/components/slot_scheduler/RandomSlotSettingsForm.tsx
msgid "Ensures programs start only at a particular interval within the hour. This makes for nice looking schedules. Flex time is scheduled to facilitate."
msgstr "Ensures programs start only at a particular interval within the hour. This makes for nice looking schedules. Flex time is scheduled to facilitate."

#: src/components/settings/media_source/EmbyServerEditDialog.tsx
msgid "Enter a name for your Emby Server"
msgstr "Enter a name for your Emby Server"

#: src/components/settings/media_source/JelllyfinServerEditDialog.tsx
msgid "Enter a name for your Jellyfin Server"
msgstr "Enter a name for your Jellyfin Server"

#: src/components/settings/media_source/LocalMediaEditDialog.tsx
msgid "Enter a name for your Local Media Source"
msgstr "Enter a name for your Local Media Source"

#: src/components/settings/media_source/EmbyServerEditDialog.tsx
msgid "Enter your Emby password to generate a new access token."
msgstr "Enter your Emby password to generate a new access token."

#: src/components/settings/media_source/JelllyfinServerEditDialog.tsx
msgid "Enter your Jellyfin password to generate a new access token.<0/><1>NOTE:</1> These are never saved to the Tunarr DB. Instead they are sent to Jellyfin to exchange for a session token."
msgstr "Enter your Jellyfin password to generate a new access token.<0/><1>NOTE:</1> These are never saved to the Tunarr DB. Instead they are sent to Jellyfin to exchange for a session token."

#: src/components/channel_config/EditChannelForm.tsx
msgid "EPG"
msgstr "EPG"

#: src/pages/settings/XmlTvSettingsPage.tsx
#: src/pages/settings/XmlTvSettingsPage.tsx
msgid "EPG (Hours)"
msgstr "EPG (Hours)"

#: src/components/programming_controls/AddBlockShuffleModal.tsx
#: src/components/programming_controls/AddBlockShuffleModal.tsx
msgid "Episode Order"
msgstr "Episode Order"

#: src/components/programs/Episodes.tsx
#: src/pages/library/TrashPage.tsx
msgid "Episodes"
msgstr "Episodes"

#: src/components/settings/ffmpeg/TranscodeConfigErrorOptions.tsx
msgid "Error Audio"
msgstr "Error Audio"

#: src/components/channels/ChannelOptionsMenu.tsx
msgid "Error copying channel m3u link to clipboard"
msgstr "Error copying channel m3u link to clipboard"

#: src/hooks/useCopyToClipboard.ts
msgid "Error copying to clipboard!"
msgstr "Error copying to clipboard!"

#: src/components/programming_controls/AddRedirectModal.tsx
msgid "Error occurred while loading channels, please try again soon."
msgstr "Error occurred while loading channels, please try again soon."

#: src/components/settings/ffmpeg/TranscodeConfigSettingsForm.tsx
msgid "Error Options"
msgstr "Error Options"

#: src/components/channel_config/SelectedProgrammingActions.tsx
msgid "Error querying Plex. Check console log and consider reporting a bug!"
msgstr "Error querying Plex. Check console log and consider reporting a bug!"

#: src/components/settings/media_source/EmbyServerEditDialog.tsx
msgid "Error saving new Emby server. See browser console and server logs for details"
msgstr "Error saving new Emby server. See browser console and server logs for details"

#: src/components/settings/media_source/JelllyfinServerEditDialog.tsx
msgid "Error saving new Jellyfin server. See browser console and server logs for details"
msgstr "Error saving new Jellyfin server. See browser console and server logs for details"

#: src/components/smart_collections/CreateSmartCollectionDialog.tsx
msgid "Error saving new Smart Collection. Check server logs and browser console for details."
msgstr "Error saving new Smart Collection. Check server logs and browser console for details."

#: src/components/channel_config/ChannelProgrammingConfig.tsx
#~ msgid "Error saving programs. {0}"
#~ msgstr "Error saving programs. {0}"

#: src/components/channel_config/ChannelProgrammingConfig.tsx
msgid "Error saving programs. {message}"
msgstr "Error saving programs. {message}"

#: src/pages/channels/RandomSlotEditorPage.tsx
#: src/pages/channels/TimeSlotEditorPage.tsx
msgid "Error saving schedule. {message}"
msgstr "Error saving schedule. {message}"

#: src/components/settings/ffmpeg/TranscodeConfigErrorOptions.tsx
msgid "Error Screen"
msgstr "Error Screen"

#: src/components/channel_config/ChannelEditActions.tsx
msgid "Error updating channel.<0/>Check browser console for details"
msgstr "Error updating channel.<0/>Check browser console for details"

#: src/components/smart_collections/EditSmartCollectionDialog.tsx
msgid "Error updating Smart Collection. Check logs for details."
msgstr "Error updating Smart Collection. Check logs for details."

#: src/pages/system/TroubleshootPage.tsx
msgid "Error while copying to clipboard. Check browser logs for details"
msgstr "Error while copying to clipboard. Check browser logs for details"

#: src/pages/system/StatusPage.tsx
msgid "Error while running system fixer {fixerId}. Check server logs for details."
msgstr "Error while running system fixer {fixerId}. Check server logs for details."

#: src/components/settings/general/GeneralSettingsForm.tsx
msgid "Error while saving settings. Please check console for details."
msgstr "Error while saving settings. Please check console for details."

#: src/components/settings/ffmpeg/useTranscodeConfigFormOptions.ts
#: src/components/settings/ffmpeg/useTranscodeConfigFormOptions.ts
msgid "Error while saving transcode config. See console log for details."
msgstr "Error while saving transcode config. See console log for details."

#: src/pages/settings/TaskSettingsPage.tsx
msgid "Error while scheduling {taskId}. Check server logs for details"
msgstr "Error while scheduling {taskId}. Check server logs for details"

#: src/pages/system/TroubleshootPage.tsx
msgid "Errors"
msgstr "Errors"

#. placeholder {0}: version.etvNext
#: src/components/ui/patterns/AppShell/HelpMenu.tsx
msgid "ErsatzTV Next {0}"
msgstr "ErsatzTV Next {0}"

#: src/components/ui/patterns/AppShell/CommandPalette.tsx
msgid "Esc, close search"
msgstr "Esc, close search"

#: src/pages/settings/FeaturesSettingsPage.tsx
msgid "Escape Hatches"
msgstr "Escape Hatches"

#: src/components/settings/general/BackupForm.tsx
#: src/components/settings/general/LogRollForm.tsx
msgid "Every"
msgstr "Every"

#: src/components/slot_scheduler/ShowSearchSlotProgrammingForm.tsx
msgid "Exclude Seasons"
msgstr "Exclude Seasons"

#: src/components/smart_collections/CreateSmartCollectionDialog.tsx
msgid "Existing query: {filterString}"
msgstr "Existing query: {filterString}"

#: src/pages/settings/FeaturesSettingsPage.tsx
msgid "Experimental Features"
msgstr "Experimental Features"

#: src/components/programming_controls/AddBlockShuffleModal.tsx
msgid "Experimental: Make perfect schedule loop"
msgstr "Experimental: Make perfect schedule loop"

#: src/pages/settings/FeaturesSettingsPage.tsx
msgid "Failed to load feature flags."
msgstr "Failed to load feature flags."

#: src/components/programs/ProgramDetailsDialog.tsx
msgid "Failed to load item details! Check logs for details"
msgstr "Failed to load item details! Check logs for details"

#: src/components/smart_collections/EditSmartCollectionDialog.tsx
msgid "Failed to load Smart Collection"
msgstr "Failed to load Smart Collection"

#: src/components/programs/ProgramDetailsDialog.tsx
msgid "Failed to load stream details! Check logs for details"
msgstr "Failed to load stream details! Check logs for details"

#: src/pages/settings/FeaturesSettingsPage.tsx
msgid "Failed to save feature flags."
msgstr "Failed to save feature flags."

#: src/pages/settings/ScannerSettingsPage.tsx
msgid "Failed to update Media Source settings. Please check server and browser logs for details."
msgstr "Failed to update Media Source settings. Please check server and browser logs for details."

#: src/components/slot_scheduler/SlotFillerDialogPanel.tsx
msgid "Fallback"
msgstr "Fallback"

#: src/components/channel_config/ChannelFlexConfig.tsx
#: src/components/channel_config/ChannelFlexConfig.tsx
msgid "Fallback Mode"
msgstr "Fallback Mode"

#: src/pages/settings/FeaturesSettingsPage.tsx
msgid "Feature flags saved!"
msgstr "Feature flags saved!"

#: src/components/shell/useShellNav.tsx
msgid "Features"
msgstr "Features"

#: src/components/shell/useShellNav.tsx
msgid "FFmpeg"
msgstr "FFmpeg"

#: src/pages/settings/SettingsLayout.tsx
#~ msgid "FFMPEG"
#~ msgstr "FFMPEG"

#. placeholder {0}: version.ffmpeg
#: src/components/ui/patterns/AppShell/HelpMenu.tsx
msgid "FFmpeg {0}"
msgstr "FFmpeg {0}"

#: src/pages/system/TroubleshootPage.tsx
msgid "FFmpeg Command"
msgstr "FFmpeg Command"

#: src/pages/settings/FfmpegSettingsPage.tsx
msgid "FFmpeg Executable Path"
msgstr "FFmpeg Executable Path"

#: src/pages/welcome/WelcomePage.tsx
#~ msgid "FFMPEG is installed. Detected version {0}"
#~ msgstr "FFMPEG is installed. Detected version {0}"

#: src/pages/welcome/WelcomePage.tsx
#~ msgid "FFMPEG is not detected."
#~ msgstr "FFMPEG is not detected."

#: src/pages/system/TroubleshootPage.tsx
msgid "FFmpeg Log"
msgstr "FFmpeg Log"

#: src/pages/settings/FfmpegSettingsPage.tsx
#: src/pages/settings/FfmpegSettingsPage.tsx
msgid "FFMPEG Log Level"
msgstr "FFMPEG Log Level"

#: src/pages/settings/FfmpegSettingsPage.tsx
#: src/pages/settings/FfmpegSettingsPage.tsx
msgid "FFMPEG Log Method"
msgstr "FFMPEG Log Method"

#: src/App.tsx
msgid "FFmpeg not found. For all features to work, we recommend installing FFmpeg 7.1+ or update your FFmpeg executable path in settings."
msgstr "FFmpeg not found. For all features to work, we recommend installing FFmpeg 7.1+ or update your FFmpeg executable path in settings."

#: src/hooks/useRouteName.ts
msgid "FFmpeg Settings"
msgstr "FFmpeg Settings"

#: src/pages/settings/FfmpegSettingsPage.tsx
msgid "FFmpeg Transcode Path"
msgstr "FFmpeg Transcode Path"

#: src/pages/welcome/WelcomePage.tsx
#~ msgid "FFMPEG transcoding is required for some features like channel overlay, subtitles, and measures to prevent issues when switching episodes."
#~ msgstr "FFMPEG transcoding is required for some features like channel overlay, subtitles, and measures to prevent issues when switching episodes."

#: src/pages/settings/FfmpegSettingsPage.tsx
msgid "FFmpeg version 7.1+ recommended. Check your current version in the sidebar"
msgstr "FFmpeg version 7.1+ recommended. Check your current version in the sidebar"

#: src/components/VersionFooter.tsx
#~ msgid "FFMPEG: {0}"
#~ msgstr "FFMPEG: {0}"

#: src/pages/settings/FfmpegSettingsPage.tsx
msgid "FFprobe Executable Path"
msgstr "FFprobe Executable Path"

#: src/pages/settings/FfmpegSettingsPage.tsx
msgid "FFprobe version 6.0+ recommended. Check your current version in the sidebar"
msgstr "FFprobe version 6.0+ recommended. Check your current version in the sidebar"

#: src/components/search/SearchGroupNode.tsx
#: src/components/search/SearchGroupNode.tsx
#: src/components/search/SearchValueNode.tsx
#: src/components/search/SearchValueNode.tsx
msgid "Field"
msgstr "Field"

#: src/pages/settings/FfmpegSettingsPage.tsx
msgid "File"
msgstr "File"

#: src/pages/ErrorPage.tsx
msgid "File a Bug Report"
msgstr "File a Bug Report"

#: src/components/slot_scheduler/SlotLinkingControl.tsx
msgid "Fill with Flex"
msgstr "Fill with Flex"

#: src/components/slot_scheduler/EditRandomSlotDialogContent.tsx
#: src/components/slot_scheduler/EditTimeSlotDialogContent.tsx
#: src/components/slot_scheduler/FillerListSlotProgrammingForm.tsx
#: src/components/slot_scheduler/SlotSchedulerCyclicShuffleDialog.tsx
#: src/components/slot_scheduler/TimeSlotTable.tsx
msgid "Filler"
msgstr "Filler"

#. placeholder {0}: showName ?? ''
#: src/hooks/slot_scheduler/useSlotName.ts
msgid "Filler - {0}"
msgstr "Filler - {0}"

#: src/components/channel_config/ChannelFlexConfig.tsx
msgid "Filler Content"
msgstr "Filler Content"

#: src/components/channel_config/ChannelFlexConfig.tsx
msgid "Filler cooldown must be a number"
msgstr "Filler cooldown must be a number"

#: src/components/slot_scheduler/MidRollConfigPanel.tsx
msgid "Filler is picked fresh at stream time like Flex time. The guide shows \"Commercial Break\" placeholders."
msgstr "Filler is picked fresh at stream time like Flex time. The guide shows \"Commercial Break\" placeholders."

#: src/components/slot_scheduler/MidRollConfigPanel.tsx
msgid "Filler is resolved at schedule time. The guide shows specific filler titles."
msgstr "Filler is resolved at schedule time. The guide shows specific filler titles."

#: src/components/shell/CommandPaletteContainer.tsx
msgid "Filler list"
msgstr "Filler list"

#: src/components/channel_config/ChannelFlexConfig.tsx
#: src/components/channel_config/ChannelFlexConfig.tsx
#: src/components/slot_scheduler/SlotFillerDialogPanel.tsx
#: src/components/slot_scheduler/SlotSchedulerCyclicShuffleDialog.tsx
msgid "Filler List"
msgstr "Filler List"

#: src/components/channel_config/ChannelFlexConfig.tsx
msgid "Filler List Cooldown (seconds)"
msgstr "Filler List Cooldown (seconds)"

#. placeholder {0}: cs.description
#: src/components/slot_scheduler/SlotSchedulerCyclicShuffleDialog.tsx
msgid "Filler List: {0}"
msgstr "Filler List: {0}"

#: src/components/shell/CommandPaletteContainer.tsx
#: src/components/shell/useShellNav.tsx
#: src/hooks/useRouteName.ts
#: src/pages/library/FillerListsPage.tsx
#: src/pages/library/FillerListsPage.tsx
msgid "Filler Lists"
msgstr "Filler Lists"

#: src/pages/library/FillerListsPage.tsx
msgid "Filler lists are collections of videos that you may want to play during 'flex' time segments. Flex is time within a channel that does not have a program scheduled (usually used for padding)."
msgstr "Filler lists are collections of videos that you may want to play during 'flex' time segments. Flex is time within a channel that does not have a program scheduled (usually used for padding)."

#: src/components/channel_config/ChannelFlexConfig.tsx
msgid "Filler Options"
msgstr "Filler Options"

#: src/components/channel_config/ChannelSubtitlePreferencesTable.tsx
#: src/components/search/PointAndClickSearchBuilder.tsx
#: src/components/search/SearchFilterBuilder.tsx
#: src/components/smart_collections/CreateSmartCollectionDialog.tsx
msgid "Filter"
msgstr "Filter"

#: src/components/ui/table/filters/TextFilter.tsx
#: src/components/ui/table/filters/TextFilter.tsx
msgid "Filter by {label}"
msgstr "Filter by {label}"

#: src/components/channel_config/ChannelSubtitlePreferencesTable.tsx
msgid "Filter Type"
msgstr "Filter Type"

#: src/components/channel_config/ChannelSubtitlePreferencesTable.tsx
msgid "Filter which subtitle tracks are considered<0/><1>Any: </1> All subtitle tracks are considered <2/><3>Forced: </3>Only consider <4>\"forced\"</4>subtitle tracks <5/><6>Default: </6>Only consider default subtitle tracks <7/><8>None: </8> Do not select any subtitles"
msgstr "Filter which subtitle tracks are considered<0/><1>Any: </1> All subtitle tracks are considered <2/><3>Forced: </3>Only consider <4>\"forced\"</4>subtitle tracks <5/><6>Default: </6>Only consider default subtitle tracks <7/><8>None: </8> Do not select any subtitles"

#: src/pages/welcome/WelcomePage.tsx
msgid "Finish"
msgstr "Finish"

#: src/components/programming_controls/AddBlockShuffleModal.tsx
msgid "First Episode"
msgstr "First Episode"

#: src/components/programming_controls/AddReplicateModal.tsx
#: src/components/slot_scheduler/EditRandomSlotDialogContent.tsx
#: src/components/slot_scheduler/MidRollConfigPanel.tsx
msgid "Fixed"
msgstr "Fixed"

#: src/components/slot_scheduler/MidRollConfigPanel.tsx
msgid "Fixed Interval"
msgstr "Fixed Interval"

#: src/components/channel_config/ChannelProgrammingFlexTools.tsx
#: src/components/channel_config/EditChannelForm.tsx
#: src/hooks/programming_controls/useSlotProgramOptions.ts
#: src/hooks/programming_controls/useSlotProgramOptions.ts
#: src/hooks/slot_scheduler/useSlotName.ts
#: src/hooks/useProgramTitleFormatter.ts
#: src/hooks/useRouteName.ts
msgid "Flex"
msgstr "Flex"

#: src/components/channel_config/AddProgrammingButton.tsx
msgid "Flex Slot..."
msgstr "Flex Slot..."

#: src/components/slot_scheduler/RandomSlotSettingsForm.tsx
#: src/components/slot_scheduler/RandomSlotSettingsForm.tsx
#: src/pages/channels/TimeSlotEditorPage.tsx
#: src/pages/channels/TimeSlotEditorPage.tsx
msgid "Flex Style"
msgstr "Flex Style"

#: src/components/channel_config/AddProgrammingButton.tsx
#~ msgid "Flex..."
#~ msgstr "Flex..."

#: src/pages/welcome/WelcomePage.tsx
msgid "Follow these steps to set up your first channel. Each step will update upon completion. You can skip setup at any time and do all of this from the menu later."
msgstr "Follow these steps to set up your first channel. Each step will update upon completion. You can skip setup at any time and do all of this from the menu later."

#: src/components/settings/media_source/PlexServerEditDialog.tsx
msgid "For more details on manually retrieving a Plex token, see <0>here</0>"
msgstr "For more details on manually retrieving a Plex token, see <0>here</0>"

#: src/components/MediaSourceLibraryTable.tsx
msgid "Force Scan"
msgstr "Force Scan"

#: src/pages/system/TroubleshootPage.tsx
msgid "Forced"
msgstr "Forced"

#: src/pages/system/TroubleshootPage.tsx
msgid "Frame Rate"
msgstr "Frame Rate"

#: src/components/slot_scheduler/EditRandomSlotDialogContent.tsx
msgid "Frequency"
msgstr "Frequency"

#: src/components/channel_config/ChannelPropertiesEditor.tsx
#: src/components/settings/ffmpeg/TranscodeConfigSettingsForm.tsx
#: src/components/shell/useShellNav.tsx
msgid "General"
msgstr "General"

#: src/pages/ErrorPage.tsx
msgid "Generating Bug Report Link..."
msgstr "Generating Bug Report Link..."

#: src/components/channel_config/jellyfin/JellyfinLibrarySelector.tsx
#: src/components/channel_config/jellyfin/JellyfinLibrarySelector.tsx
#~ msgid "Genre"
#~ msgstr "Genre"

#: src/pages/settings/FfmpegSettingsPage.tsx
msgid "Global Options"
msgstr "Global Options"

#: src/routes/__root.tsx
msgid "Go Home"
msgstr "Go Home"

#: src/components/ui/table/DataTable.tsx
msgid "Go to first page"
msgstr "Go to first page"

#: src/components/ui/table/DataTable.tsx
msgid "Go to last page"
msgstr "Go to last page"

#: src/components/ui/table/DataTable.tsx
msgid "Go to next page"
msgstr "Go to next page"

#: src/components/ui/table/DataTable.tsx
msgid "Go to previous page"
msgstr "Go to previous page"

#: src/components/base/ProgramViewToggleButton.tsx
msgid "Grid"
msgstr "Grid"

#: src/components/programming_controls/ShuffleProgrammingModal.tsx
msgid "Group episode programs by their show."
msgstr "Group episode programs by their show."

#: src/components/programming_controls/AddBlockShuffleModal.tsx
msgid "Grouping works as follows:"
msgstr "Grouping works as follows:"

#: src/components/shell/useShellNav.tsx
#: src/pages/guide/GuidePage.tsx
msgid "Guide"
msgstr "Guide"

#: src/pages/guide/GuidePage.tsx
msgid "Guide Start Time"
msgstr "Guide Start Time"

#: src/components/settings/ffmpeg/TranscodeConfigsTable.tsx
msgid "Hardware Accel."
msgstr "Hardware Accel."

#: src/components/settings/ffmpeg/TranscodeConfigVideoSettingsForm.tsx
msgid "Hardware Acceleration"
msgstr "Hardware Acceleration"

#: src/pages/welcome/WelcomePage.tsx
#~ msgid "HDHomeRun Settings"
#~ msgstr "HDHomeRun Settings"

#: src/components/shell/useShellNav.tsx
msgid "HDHR"
msgstr "HDHR"

#: src/pages/settings/HdhrSettingsPage.tsx
msgid "HDHR: Loading..."
msgstr "HDHR: Loading..."

#: src/components/slot_scheduler/SlotFillerDialogPanel.tsx
msgid "Head"
msgstr "Head"

#: src/pages/settings/MediaSourceSettingsPage.tsx
msgid "Healthy?"
msgstr "Healthy?"

#: src/components/ui/patterns/AppShell/HelpMenu.tsx
#: src/components/ui/patterns/AppShell/HelpMenu.tsx
msgid "Help and links"
msgstr "Help and links"

#: src/components/settings/ffmpeg/TranscodeConfigSettingsForm.tsx
msgid "Hide Advanced"
msgstr "Hide Advanced"

#: src/components/channel_config/ChannelFlexConfig.tsx
msgid "Hide watermark during filler"
msgstr "Hide watermark during filler"

#: src/pages/settings/FfmpegSettingsPage.tsx
#: src/pages/settings/FfmpegSettingsPage.tsx
msgid "HLS Direct Output Format"
msgstr "HLS Direct Output Format"

#: src/components/Video.tsx
msgid "HLS not supported in this browser!"
msgstr "HLS not supported in this browser!"

#: src/pages/channels/TimeSlotEditorPage.tsx
msgid "How far past its boundary can a slot's content extend? 'One extra item' allows exactly one more program that crosses the boundary."
msgstr "How far past its boundary can a slot's content extend? 'One extra item' allows exactly one more program that crosses the boundary."

#: src/pages/settings/ScannerSettingsPage.tsx
msgid "How frequently libraries should be scanned (starting from midnight)."
msgstr "How frequently libraries should be scanned (starting from midnight)."

#: src/components/slot_scheduler/MidRollConfigPanel.tsx
msgid "How long each commercial break lasts"
msgstr "How long each commercial break lasts"

#: src/pages/settings/XmlTvSettingsPage.tsx
msgid "How often the XMLTV file is regenerated"
msgstr "How often the XMLTV file is regenerated"

#: src/components/slot_scheduler/MidRollConfigPanel.tsx
msgid "How often to insert a break"
msgstr "How often to insert a break"

#: src/pages/system/TroubleshootPage.tsx
msgid "HW Accel"
msgstr "HW Accel"

#: src/pages/system/TroubleshootPage.tsx
msgid "HW Acceleration"
msgstr "HW Acceleration"

#: src/pages/channels/ChannelsPage.tsx
msgid "Icon"
msgstr "Icon"

#: src/pages/channels/TimeSlotEditorPage.tsx
msgid "If a previous slot ran long, should this slot still play? Controls how late a slot can start."
msgstr "If a previous slot ran long, should this slot still play? Controls how late a slot can start."

#: src/pages/settings/XmlTvSettingsPage.tsx
msgid "If enabled, TV show episodes will use the poster of their show, instead of the individual episode poster."
msgstr "If enabled, TV show episodes will use the poster of their show, instead of the individual episode poster."

#: src/components/slot_scheduler/RandomSlotSettingsForm.tsx
msgid "If no more programs can fit into a duration-based slot, flex time is added to fill the gap. This setting determines how flex is added <0>within</0> the slot to ensure all time is filled.<1/><2>Between:</2> Flex time is added between videos within a slot, if there are multiple<3/><4>End:</4> Flex time is added at the end of the slot"
msgstr "If no more programs can fit into a duration-based slot, flex time is added to fill the gap. This setting determines how flex is added <0>within</0> the slot to ensure all time is filled.<1/><2>Between:</2> Flex time is added between videos within a slot, if there are multiple<3/><4>End:</4> Flex time is added at the end of the slot"

#: src/components/settings/ffmpeg/TranscodeConfigSettingsForm.tsx
#: src/components/settings/ffmpeg/TranscodeConfigVideoSettingsForm.tsx
msgid "If set, all watermark overlays will be disabled for channels assigned this transcode config."
msgstr "If set, all watermark overlays will be disabled for channels assigned this transcode config."

#: src/components/programming_controls/AddBlockShuffleModal.tsx
msgid "If set, any programming group with fewer episodes will be looped in order to make perfectly even blocks."
msgstr "If set, any programming group with fewer episodes will be looped in order to make perfectly even blocks."

#: src/components/settings/ffmpeg/TranscodeConfigErrorOptions.tsx
msgid "If there are issues playing a video, Tunarr will try to use an error screen as a placeholder while retrying loading the video every 60 seconds."
msgstr "If there are issues playing a video, Tunarr will try to use an error screen as a placeholder while retrying loading the video every 60 seconds."

#: src/components/slot_scheduler/RandomSlotSettingsForm.tsx
msgid "If true, adjusting the weight of one slot will scale the weights of other slots such that all weights total 100%. Otherwise, weights can be adjusted freely and the weight of each slot is only relative to the total weight."
msgstr "If true, adjusting the weight of one slot will scale the weights of other slots such that all weights total 100%. Otherwise, weights can be adjusted freely and the weight of each slot is only relative to the total weight."

#: src/pages/welcome/WelcomePage.tsx
#~ msgid "If you are confident FFMPEG is installed, you may just need to update the executable path in the settings. To do so, simply click Edit above to update the path."
#~ msgstr "If you are confident FFMPEG is installed, you may just need to update the executable path in the settings. To do so, simply click Edit above to update the path."

#: src/components/settings/UnsavedNavigationAlert.tsx
msgid "If you proceed, all unsaved changes will be lost. Are you sure you want to proceed?"
msgstr "If you proceed, all unsaved changes will be lost. Are you sure you want to proceed?"

#: src/components/channel_config/ChannelFlexConfig.tsx
msgid "Image"
msgstr "Image"

#: src/components/channel_config/ChannelFlexConfig.tsx
msgid "Image URL"
msgstr "Image URL"

#: src/components/programming_controls/AddBlockShuffleModal.tsx
msgid "In Order"
msgstr "In Order"

#: src/components/slot_scheduler/ShowSearchSlotProgrammingForm.tsx
msgid "Include Seasons"
msgstr "Include Seasons"

#: src/components/slot_scheduler/SlotProgrammingTooLongWarningDetails.tsx
#~ msgid "Increasing \"Max Lateness\" for the schedule."
#~ msgstr "Increasing \"Max Lateness\" for the schedule."

#: src/components/slot_scheduler/SlotProgrammingTooLongWarningDetails.tsx
msgid "Increasing \"Max Overflow\" for the schedule."
msgstr "Increasing \"Max Overflow\" for the schedule."

#: src/components/slot_scheduler/SlotProgrammingTooLongWarningDetails.tsx
msgid "Increasing the slot duration."
msgstr "Increasing the slot duration."

#: src/components/settings/general/BackupForm.tsx
msgid "Increment"
msgstr "Increment"

#: src/components/slot_scheduler/MidRollConfigPanel.tsx
msgid "Initial Delay (minutes)"
msgstr "Initial Delay (minutes)"

#: src/components/slot_scheduler/MidRollConfigPanel.tsx
msgid "Initial Delay + Interval"
msgstr "Initial Delay + Interval"

#: src/components/slot_scheduler/MidRollConfigPanel.tsx
msgid "Insert breaks at these percentages of the program duration"
msgstr "Insert breaks at these percentages of the program duration"

#: src/pages/welcome/WelcomePage.tsx
#: src/pages/welcome/WelcomePage.tsx
#~ msgid "Install FFMPEG"
#~ msgstr "Install FFMPEG"

#: src/components/slot_scheduler/MidRollConfigPanel.tsx
msgid "Interval (minutes)"
msgstr "Interval (minutes)"

#: src/components/slot_scheduler/SlotOrderFormControl.tsx
msgid "Inverse linear decay, heavier weighting."
msgstr "Inverse linear decay, heavier weighting."

#: src/components/channel_config/MediaGridItem.tsx
msgid "Item was not present during the last scan"
msgstr "Item was not present during the last scan"

#: src/components/channel_config/ChannelFlexConfig.tsx
msgid "Items from any filler list will not be chosen more frequently than this cooldown setting."
msgstr "Items from any filler list will not be chosen more frequently than this cooldown setting."

#: src/components/settings/media_source/AddMediaSourceButton.tsx
msgid "Jellyfin"
msgstr "Jellyfin"

#: src/components/search/SearchInput.tsx
#: src/components/smart_collections/CreateSmartCollectionDialog.tsx
msgid "Keywords"
msgstr "Keywords"

#: src/components/search/SearchInput.tsx
msgid "Keywords perform full text search across all (or configured) fields"
msgstr "Keywords perform full text search across all (or configured) fields"

#: src/pages/system/TroubleshootPage.tsx
msgid "Label"
msgstr "Label"

#: src/components/channel_config/ChannelSubtitlePreferencesTable.tsx
#: src/components/LanguageAutocomplete.tsx
#: src/components/LanguagePreferencesList.tsx
#: src/components/settings/general/WebSettings.tsx
#: src/components/settings/general/WebSettings.tsx
#: src/components/settings/general/WebSettings.tsx
#: src/pages/system/TroubleshootPage.tsx
#: src/pages/system/TroubleshootPage.tsx
msgid "Language"
msgstr "Language"

#: src/pages/settings/TaskSettingsPage.tsx
msgid "Last run"
msgstr "Last run"

#. placeholder {0}: library.lastScannedAt ? dayjs(library.lastScannedAt)?.format() : t`never`
#: src/components/settings/media_source/EditMediaSourceLibrariesDialog.tsx
msgid "Last Scanned: {0}"
msgstr "Last Scanned: {0}"

#: src/pages/settings/TaskSettingsPage.tsx
msgid "Last Scheduled Execution"
msgstr "Last Scheduled Execution"

#: src/components/MediaSourceLibraryTable.tsx
msgid "Last Synced"
msgstr "Last Synced"

#. placeholder {0}: dayjs(customShow.lastSyncedAt).fromNow()
#: src/components/custom-shows/EditCustomShowForm.tsx
msgid "Last synced {0}"
msgstr "Last synced {0}"

#: src/components/slot_scheduler/MidRollConfigPanel.tsx
msgid "Lazy"
msgstr "Lazy"

#: src/components/channel_config/ChannelTranscodingConfig.tsx
msgid "Leave blank to use the channel's icon."
msgstr "Leave blank to use the channel's icon."

#: src/pages/welcome/WelcomePage.tsx
#~ msgid "Let's get started..."
#~ msgstr "Let's get started..."

#: src/pages/system/SystemLogsPage.tsx
msgid "Level"
msgstr "Level"

#: src/components/settings/ConnectMediaSources.tsx
#: src/components/settings/media_source/EditMediaSourceLibrariesDialog.tsx
#: src/components/shell/useShellNav.tsx
#: src/pages/settings/MediaSourceSettingsPage.tsx
msgid "Libraries"
msgstr "Libraries"

#: src/components/channel_config/ImportedLibrarySeletor.tsx
#: src/components/channel_config/ImportedLibrarySeletor.tsx
#: src/components/shell/useShellNav.tsx
#: src/hooks/useRouteName.ts
#: src/pages/library/LibraryIndexPage.tsx
msgid "Library"
msgstr "Library"

#: src/components/channel_config/ChannelFlexConfig.tsx
msgid "Library Clip (not yet implemented)"
msgstr "Library Clip (not yet implemented)"

#. placeholder {0}: library.name
#: src/routes/media_sources_/$mediaSourceId/libraries_.$libraryId.tsx
msgid "Library: {0}"
msgstr "Library: {0}"

#: src/components/settings/DarkModeButton.tsx
msgid "Light"
msgstr "Light"

#: src/components/channel_config/ChannelProgrammingSort.tsx
#~ msgid "Like Random Shuffle, but tries to preserve the sequence of episodes for each TV show. If a TV show has multiple instances of its episodes, they are also cycled appropriately."
#~ msgstr "Like Random Shuffle, but tries to preserve the sequence of episodes for each TV show. If a TV show has multiple instances of its episodes, they are also cycled appropriately."

#: src/components/channel_config/plex/PlexFilterBuilder.tsx
#~ msgid "Limit"
#~ msgstr "Limit"

#: src/components/channel_config/plex/PlexFilterBuilder.tsx
#~ msgid "Limit must be numeric"
#~ msgstr "Limit must be numeric"

#: src/components/slot_scheduler/SlotOrderFormControl.tsx
msgid "Linear"
msgstr "Linear"

#: src/components/slot_scheduler/SlotLinkingControl.tsx
#: src/components/slot_scheduler/SlotLinkingControl.tsx
msgid "Link Mode"
msgstr "Link Mode"

#: src/components/slot_scheduler/SlotLinkingControl.tsx
msgid "Link to existing slot"
msgstr "Link to existing slot"

#: src/components/slot_scheduler/SlotLinkingControl.tsx
msgid "Linked slots advance episode progression together sequentially."
msgstr "Linked slots advance episode progression together sequentially."

#: src/components/base/ProgramViewToggleButton.tsx
#: src/components/channel_config/ChannelProgrammingConfig.tsx
msgid "List"
msgstr "List"

#: src/components/programs/Actors.tsx
msgid "Load More"
msgstr "Load More"

#: src/components/Video.tsx
msgid "Load Stream"
msgstr "Load Stream"

#: src/pages/channels/RandomSlotEditorPage.tsx
msgid "Loading"
msgstr "Loading"

#: src/components/ui/patterns/AppShell/HelpMenu.tsx
msgid "Loading version…"
msgstr "Loading version…"

#: src/components/ProgramSearchAutocomplete.tsx
msgid "Loading..."
msgstr "Loading..."

#: src/components/ProgramSearchAutocomplete.tsx
#: src/components/ui/patterns/AppShell/CommandPalette.tsx
msgid "Loading…"
msgstr "Loading…"

#: src/components/settings/media_source/AddMediaSourceButton.tsx
msgid "Local"
msgstr "Local"

#: src/components/settings/media_source/EditPathReplacementsForm.tsx
msgid "Local Path"
msgstr "Local Path"

#: src/components/slot_scheduler/RandomSlotSettingsForm.tsx
msgid "Lock Weights"
msgstr "Lock Weights"

#: src/components/settings/general/GeneralSettingsForm.tsx
#: src/components/settings/general/GeneralSettingsForm.tsx
msgid "Log Level"
msgstr "Log Level"

#: src/pages/settings/FfmpegSettingsPage.tsx
msgid "Log level to pass to ffmpeg. Read more about ffmpeg's log levels <0>here</0>"
msgstr "Log level to pass to ffmpeg. Read more about ffmpeg's log levels <0>here</0>"

#: src/components/slot_scheduler/SlotOrderFormControl.tsx
msgid "Logarithmic"
msgstr "Logarithmic"

#: src/components/slot_scheduler/SlotOrderFormControl.tsx
msgid "Logarithmic decay, lighter weighting."
msgstr "Logarithmic decay, lighter weighting."

#: src/components/settings/general/GeneralSettingsForm.tsx
msgid "Logging"
msgstr "Logging"

#: src/components/shell/useShellNav.tsx
msgid "Logs"
msgstr "Logs"

#: src/pages/system/StatusPage.tsx
msgid "Logs Directory:"
msgstr "Logs Directory:"

#: src/pages/ErrorPage.tsx
msgid "Looks like something went wrong."
msgstr "Looks like something went wrong."

#: src/components/programming_controls/AddBlockShuffleModal.tsx
msgid "Loop Short Programs"
msgstr "Loop Short Programs"

#: src/components/settings/ffmpeg/TranscodeConfigAudioSettingsForm.tsx
msgid "Loudness Range Target"
msgstr "Loudness Range Target"

#: src/components/settings/ffmpeg/TranscodeConfigAudioSettingsForm.tsx
msgid "Loudness Target"
msgstr "Loudness Target"

#: src/components/settings/ffmpeg/TranscodeConfigAudioSettingsForm.tsx
msgid "Loudnorm Options"
msgstr "Loudnorm Options"

#: src/pages/welcome/WelcomePage.tsx
msgid "M3U playlist"
msgstr "M3U playlist"

#: src/components/ui/patterns/AppShell/PhoneNav.tsx
#: src/components/ui/patterns/AppShell/ShellTopBar.tsx
msgid "Main"
msgstr "Main"

#: src/components/programming_controls/AddReplicateModal.tsx
msgid "Makes multiple copies of the schedule and plays them in sequence"
msgstr "Makes multiple copies of the schedule and plays them in sequence"

#: src/components/channel_config/ChannelProgrammingOrganizeOptions.tsx
msgid "Makes multiple copies of the schedule and plays them in sequence. Normally this isn't necessary, because Tunarr will always play the schedule back from the beginning when it finishes. But creating replicas is a useful intermediary step sometimes before applying other transformations. Note that because very large channels can be problematic, the number of replicas will be limited to avoid creating really large channels."
msgstr "Makes multiple copies of the schedule and plays them in sequence. Normally this isn't necessary, because Tunarr will always play the schedule back from the beginning when it finishes. But creating replicas is a useful intermediary step sometimes before applying other transformations. Note that because very large channels can be problematic, the number of replicas will be limited to avoid creating really large channels."

#: src/components/settings/media_source/EditMediaSourceLibrariesDialog.tsx
msgid "Manage Libraries"
msgstr "Manage Libraries"

#: src/components/programming_controls/AdjustWeightsModal.tsx
msgid "Manual"
msgstr "Manual"

#: src/components/settings/media_source/EmbyServerEditDialog.tsx
msgid "Manually add an access token from your Emby server"
msgstr "Manually add an access token from your Emby server"

#: src/components/settings/media_source/JelllyfinServerEditDialog.tsx
msgid "Manually add an access token from your Jellyfin server"
msgstr "Manually add an access token from your Jellyfin server"

#: src/pages/system/TroubleshootPage.tsx
msgid "Match"
msgstr "Match"

#: src/components/search/SearchGroupNode.tsx
msgid "Match all of"
msgstr "Match all of"

#: src/components/search/SearchGroupNode.tsx
msgid "Match any of"
msgstr "Match any of"

#: src/components/ui/table/filters/RangeFilter.tsx
msgid "Max"
msgstr "Max"

#: src/components/ui/table/filters/RangeFilter.tsx
msgid "Max {label}"
msgstr "Max {label}"

#: src/components/settings/general/BackupForm.tsx
#: src/components/settings/general/BackupForm.tsx
msgid "Max Backups"
msgstr "Max Backups"

#: src/components/programming_controls/AddBreaksModal.tsx
msgid "Max Duration"
msgstr "Max Duration"

#: src/components/slot_scheduler/MidRollConfigPanel.tsx
msgid "Max Duration (minutes)"
msgstr "Max Duration (minutes)"

#: src/components/settings/general/LogRollForm.tsx
msgid "Max file size (bytes)"
msgstr "Max file size (bytes)"

#: src/components/slot_scheduler/TimeSlotConfigDialogPanel.tsx
#: src/components/slot_scheduler/TimeSlotConfigDialogPanel.tsx
#: src/pages/channels/TimeSlotEditorPage.tsx
#: src/pages/channels/TimeSlotEditorPage.tsx
msgid "Max Lateness"
msgstr "Max Lateness"

#: src/components/slot_scheduler/TimeSlotConfigDialogPanel.tsx
#: src/components/slot_scheduler/TimeSlotConfigDialogPanel.tsx
#: src/pages/channels/TimeSlotEditorPage.tsx
#: src/pages/channels/TimeSlotEditorPage.tsx
msgid "Max Overflow"
msgstr "Max Overflow"

#: src/components/settings/ffmpeg/TranscodeConfigAudioSettingsForm.tsx
msgid "Max True Peak"
msgstr "Max True Peak"

#: src/components/slot_scheduler/MidRollConfigPanel.tsx
msgid "Maximum number of breaks per program (0 = unlimited)"
msgstr "Maximum number of breaks per program (0 = unlimited)"

#: src/components/slot_scheduler/RandomSlotSettingsForm.tsx
msgid "Maximum number of days to precalculate the schedule. Note that the length of the schedule is also bounded by the maximum number of programs allowed in a channel."
msgstr "Maximum number of days to precalculate the schedule. Note that the length of the schedule is also bounded by the maximum number of programs allowed in a channel."

#: src/pages/channels/TimeSlotEditorPage.tsx
msgid "Maximum number of days to precalculate the schedule. Note that the length of the schedule is also bounded by the maximum number of programs allowed in a channel.<0/><1>Note: Previewing the schedule in the browser for long lengths of time can cause UI performance issues</1>"
msgstr "Maximum number of days to precalculate the schedule. Note that the length of the schedule is also bounded by the maximum number of programs allowed in a channel.<0/><1>Note: Previewing the schedule in the browser for long lengths of time can cause UI performance issues</1>"

#: src/pages/system/TroubleshootPage.tsx
msgid "Media Info"
msgstr "Media Info"

#: src/components/channel_config/ProgrammingSelector.tsx
#: src/components/channel_config/ProgrammingSelector.tsx
#: src/components/custom-shows/EditCustomShowForm.tsx
msgid "Media Source"
msgstr "Media Source"

#. placeholder {0}: library.mediaSource.name
#. placeholder {0}: mediaSource.name
#: src/routes/media_sources_/$mediaSourceId/index.tsx
#: src/routes/media_sources_/$mediaSourceId/libraries_.$libraryId.tsx
msgid "Media Source: \"{0}\""
msgstr "Media Source: \"{0}\""

#: src/pages/settings/MediaSourceSettingsPage.tsx
msgid "Media Sources"
msgstr "Media Sources"

#: src/pages/settings/MediaSourceSettingsPage.tsx
msgid "Media Sources are where Tunarr sources your content. Media can come from your filesystem or a remote server, like Plex or Jellyfin. At least one Media Source is necessary to create channels and play media in Tunarr."
msgstr "Media Sources are where Tunarr sources your content. Media can come from your filesystem or a remote server, like Plex or Jellyfin. At least one Media Source is necessary to create channels and play media in Tunarr."

#: src/pages/welcome/WelcomePage.tsx
msgid "Media sources provide the content for your channels. Tunarr supports Plex, Jellyfin, Emby, and local folders."
msgstr "Media sources provide the content for your channels. Tunarr supports Plex, Jellyfin, Emby, and local folders."

#: src/components/MediaSourceLibraryTable.tsx
#: src/components/settings/media_source/LocalMediaEditDialog.tsx
#: src/components/settings/media_source/LocalMediaEditDialog.tsx
msgid "Media Type"
msgstr "Media Type"

#: src/components/channel_config/AddProgrammingButton.tsx
msgid "Media..."
msgstr "Media..."

#: src/pages/system/SystemLogsPage.tsx
msgid "Message"
msgstr "Message"

#: src/components/slot_scheduler/SlotFillerDialogPanel.tsx
msgid "Mid"
msgstr "Mid"

#: src/components/slot_scheduler/EditRandomSlotDialogContent.tsx
#: src/components/slot_scheduler/EditTimeSlotDialogContent.tsx
msgid "Mid-Roll"
msgstr "Mid-Roll"

#: src/components/ui/table/filters/RangeFilter.tsx
msgid "Min"
msgstr "Min"

#: src/components/ui/table/filters/RangeFilter.tsx
msgid "Min {label}"
msgstr "Min {label}"

#: src/components/programming_controls/AddBreaksModal.tsx
msgid "Min Duration"
msgstr "Min Duration"

#: src/components/slot_scheduler/MidRollConfigPanel.tsx
msgid "Min Duration (minutes)"
msgstr "Min Duration (minutes)"

#: src/components/channel_config/ChannelEpgConfig.tsx
msgid "Min. Visible in Guide Duration Program (seconds)"
msgstr "Min. Visible in Guide Duration Program (seconds)"

#: src/components/slot_scheduler/MidRollConfigPanel.tsx
msgid "Minimum Program Duration (minutes)"
msgstr "Minimum Program Duration (minutes)"

#: src/components/channels/ChannelOptionsMenu.tsx
msgid "Modify Programming"
msgstr "Modify Programming"

#: src/components/channel_config/ChannelProgrammingConfig.tsx
msgid "Month"
msgstr "Month"

#: src/components/ui/patterns/AppShell/PhoneNav.tsx
#: src/components/ui/patterns/AppShell/ShellTopBar.tsx
#: src/components/ui/patterns/AppShell/ShellTopBar.tsx
msgid "More"
msgstr "More"

#: src/components/ui/patterns/AppShell/CommandPalette.tsx
msgid "move"
msgstr "move"

#: src/components/channel_config/SelectedProgrammingList.tsx
msgid "Movie"
msgstr "Movie"

#: src/components/programming_controls/AddBlockShuffleModal.tsx
#: src/components/programming_controls/AddBlockShuffleModal.tsx
msgid "Movie Sort"
msgstr "Movie Sort"

#: src/components/programming_controls/AddBlockShuffleModal.tsx
#: src/components/programming_controls/AddBlockShuffleModal.tsx
msgid "Movie Sort Order"
msgstr "Movie Sort Order"

#. placeholder {0}: media.year
#: src/components/channel_config/SelectedProgrammingList.tsx
msgid "Movie, {0}"
msgstr "Movie, {0}"

#: src/components/channels/ChannelPrograms.tsx
#: src/pages/library/TrashPage.tsx
msgid "Movies"
msgstr "Movies"

#: src/components/programming_controls/AddBlockShuffleModal.tsx
msgid "Movies are grouped altogether"
msgstr "Movies are grouped altogether"

#: src/components/programming_controls/AddBlockShuffleModal.tsx
msgid "Music tracks are grouped by artist"
msgstr "Music tracks are grouped by artist"

#: src/components/channels/ChannelPrograms.tsx
#: src/pages/library/TrashPage.tsx
msgid "Music Videos"
msgstr "Music Videos"

#: src/pages/settings/FfmpegSettingsPage.tsx
msgid "Must define at least one language preference"
msgstr "Must define at least one language preference"

#: src/components/settings/general/GeneralSettingsForm.tsx
msgid "Must use a valid URL, or empty."
msgstr "Must use a valid URL, or empty."

#: src/components/custom-shows/EditCustomShowForm.tsx
#: src/components/filler/EditFillerListForm.tsx
#: src/components/MediaSourceLibraryTable.tsx
#: src/components/settings/ConnectMediaSources.tsx
#: src/components/settings/ffmpeg/TranscodeConfigSettingsForm.tsx
#: src/components/settings/ffmpeg/TranscodeConfigsTable.tsx
#: src/components/settings/media_source/EmbyServerEditDialog.tsx
#: src/components/settings/media_source/JelllyfinServerEditDialog.tsx
#: src/components/settings/media_source/LocalMediaEditDialog.tsx
#: src/components/settings/media_source/PlexServerEditDialog.tsx
#: src/components/smart_collections/CreateSmartCollectionDialog.tsx
#: src/components/smart_collections/EditSmartCollectionDialog.tsx
#: src/components/smart_collections/SmartCollectionsTable.tsx
#: src/pages/channels/ChannelsPage.tsx
#: src/pages/library/CustomShowsPage.tsx
#: src/pages/library/FillerListsPage.tsx
#: src/pages/settings/MediaSourceSettingsPage.tsx
#: src/pages/settings/TaskSettingsPage.tsx
#: src/pages/system/TroubleshootPage.tsx
msgid "Name"
msgstr "Name"

#: src/components/settings/media_source/EmbyServerEditDialog.tsx
#: src/components/settings/media_source/JelllyfinServerEditDialog.tsx
#: src/components/settings/media_source/LocalMediaEditDialog.tsx
#: src/components/settings/media_source/PlexServerEditDialog.tsx
msgid "Name can only contain alphanumeric characters, dashes, and underscores"
msgstr "Name can only contain alphanumeric characters, dashes, and underscores"

#: src/components/settings/media_source/LocalMediaEditDialog.tsx
msgid "Need at least one path"
msgstr "Need at least one path"

#: src/components/settings/media_source/EditMediaSourceLibrariesDialog.tsx
msgid "never"
msgstr "never"

#: src/components/settings/ffmpeg/TranscodeConfigsTable.tsx
#: src/hooks/useRouteName.ts
#: src/hooks/useRouteName.ts
#: src/hooks/useRouteName.ts
#: src/pages/channels/ChannelsPage.tsx
#: src/pages/library/CustomShowsPage.tsx
#: src/pages/library/FillerListsPage.tsx
msgid "New"
msgstr "New"

#: src/pages/channels/NewChannelPage.tsx
#: src/pages/welcome/WelcomePage.tsx
msgid "New Channel"
msgstr "New Channel"

#: src/pages/library/EditCustomShowPage.tsx
#: src/pages/library/NewCustomShowPage.tsx
msgid "New Custom Show"
msgstr "New Custom Show"

#: src/components/settings/media_source/EmbyServerEditDialog.tsx
msgid "New Emby Media Source"
msgstr "New Emby Media Source"

#: src/pages/library/NewFillerPage.tsx
msgid "New Filler List"
msgstr "New Filler List"

#: src/components/settings/media_source/LocalMediaEditDialog.tsx
msgid "New Local Media Source"
msgstr "New Local Media Source"

#: src/components/settings/media_source/JelllyfinServerEditDialog.tsx
msgid "New Media Source"
msgstr "New Media Source"

#: src/components/settings/media_source/PlexServerEditDialog.tsx
msgid "New Plex Server"
msgstr "New Plex Server"

#: src/pages/welcome/WelcomePage.tsx
#~ msgid "Next"
#~ msgstr "Next"

#: src/pages/settings/TaskSettingsPage.tsx
msgid "Next run"
msgstr "Next run"

#: src/pages/settings/TaskSettingsPage.tsx
msgid "Next Scheduled Execution"
msgstr "Next Scheduled Execution"

#: src/pages/channels/ChannelsPage.tsx
#: src/pages/channels/ChannelsPage.tsx
msgid "No active sessions"
msgstr "No active sessions"

#: src/pages/welcome/WelcomePage.tsx
msgid "No libraries are enabled yet. Tunarr only syncs content from enabled libraries, so choose at least one below."
msgstr "No libraries are enabled yet. Tunarr only syncs content from enabled libraries, so choose at least one below."

#: src/components/settings/media_source/MediaSourceLibrariesChip.tsx
msgid "No libraries enabled"
msgstr "No libraries enabled"

#: src/pages/welcome/WelcomePage.tsx
#~ msgid "No media sources connected."
#~ msgstr "No media sources connected."

#: src/components/channel_config/ProgrammingSelector.tsx
msgid "No Media Sources detected."
msgstr "No Media Sources detected."

#: src/components/ui/patterns/AppShell/CommandPalette.tsx
msgid "No pages or lists match."
msgstr "No pages or lists match."

#: src/components/channel_config/ChannelLineupList.tsx
msgid "No programming added yet"
msgstr "No programming added yet"

#: src/components/guide/TvGuide.tsx
msgid "No Programming scheduled"
msgstr "No Programming scheduled"

#: src/components/guide/TvGuide.tsx
msgid "No programming scheduled for this time period"
msgstr "No programming scheduled for this time period"

#: src/components/channel_config/AddSelectedMediaButton.tsx
#~ msgid "No programs selected"
#~ msgstr "No programs selected"

#: src/components/ui/table/DataTable.tsx
msgid "No records to display"
msgstr "No records to display"

#: src/components/channel_config/MediaItemGrid.tsx
#: src/components/channel_config/MediaItemList.tsx
msgid "No results"
msgstr "No results"

#: src/components/ui/table/DataTable.tsx
msgid "No results found"
msgstr "No results found"

#: src/components/VersionFooter.tsx
#~ msgid "NodeJS: {0}"
#~ msgstr "NodeJS: {0}"

#: src/components/programming_controls/ShuffleProgrammingModal.tsx
#: src/pages/system/TroubleshootPage.tsx
msgid "None"
msgstr "None"

#: src/components/programming_controls/ShuffleProgrammingModal.tsx
msgid "None:"
msgstr "None:"

#: src/components/settings/ffmpeg/TranscodeConfigVideoSettingsForm.tsx
msgid "Normalize Frame Rate"
msgstr "Normalize Frame Rate"

#: src/components/channel_config/ChannelPropertiesEditor.tsx
msgid "Not a valid number"
msgstr "Not a valid number"

#: src/components/settings/media_source/EmbyServerEditDialog.tsx
#: src/components/settings/media_source/JelllyfinServerEditDialog.tsx
#: src/components/settings/media_source/PlexServerEditDialog.tsx
msgid "Not a valid URL"
msgstr "Not a valid URL"

#: src/routes/__root.tsx
msgid "Not found!"
msgstr "Not found!"

#: src/components/MediaSourceLibraryTable.tsx
msgid "Not synced"
msgstr "Not synced"

#: src/components/channels/ChannelNowPlayingCard.tsx
msgid "Now Playing:"
msgstr "Now Playing:"

#: src/pages/channels/ChannelsPage.tsx
msgid "Number"
msgstr "Number"

#: src/pages/settings/XmlTvSettingsPage.tsx
msgid "Number of hours to include in the XMLTV file"
msgstr "Number of hours to include in the XMLTV file"

#: src/components/programming_controls/AddReplicateModal.tsx
#: src/components/programming_controls/AddReplicateModal.tsx
msgid "Number of Replications"
msgstr "Number of Replications"

#: src/pages/system/SystemDebugPage.tsx
msgid "Nvidia Capabilities"
msgstr "Nvidia Capabilities"

#: src/components/channel_config/ChannelPropertiesEditor.tsx
msgid "On-Demand"
msgstr "On-Demand"

#: src/components/channel_config/ChannelPropertiesEditor.tsx
msgid "On-Demand channels resume from where you left off. Programming is paused when the channel is not streaming.<0/><1>NOTE:</1> While the channel is inactive, the TV Guide for the channel will be empty."
msgstr "On-Demand channels resume from where you left off. Programming is paused when the channel is not streaming.<0/><1>NOTE:</1> While the channel is inactive, the TV Guide for the channel will be empty."

#: src/pages/channels/ChannelsPage.tsx
msgid "On-Demand?"
msgstr "On-Demand?"

#: src/pages/ErrorPage.tsx
msgid "Oops!"
msgstr "Oops!"

#: src/components/channel_config/ChannelTranscodingConfig.tsx
msgid "Opacity"
msgstr "Opacity"

#: src/components/ui/patterns/AppShell/CommandPalette.tsx
msgid "open"
msgstr "open"

#. placeholder {0}: capitalize(program.sourceType)
#: src/components/programs/MediaDetailCard.tsx
msgid "Open in {0}"
msgstr "Open in {0}"

#: src/components/ui/patterns/AppShell/CommandPalette.tsx
msgid "Opens Search"
msgstr "Opens Search"

#: src/components/channel_config/plex/PlexFilterBuilder.tsx
#: src/components/channel_config/plex/PlexFilterBuilder.tsx
#~ msgid "Operation"
#~ msgstr "Operation"

#: src/components/search/SearchValueNode.tsx
#: src/components/search/SearchValueNode.tsx
msgid "Operator"
msgstr "Operator"

#: src/components/channels/ChannelOptionsButton.tsx
msgid "Options"
msgstr "Options"

#: src/components/settings/media_source/EmbyServerEditDialog.tsx
#: src/components/settings/media_source/JelllyfinServerEditDialog.tsx
msgid "OR"
msgstr "OR"

#: src/components/slot_scheduler/RandomSlotTable.tsx
#: src/components/slot_scheduler/RandomSlotTable.tsx
#: src/components/slot_scheduler/SlotOrderFormControl.tsx
#: src/components/slot_scheduler/SlotOrderFormControl.tsx
#: src/components/slot_scheduler/TimeSlotTable.tsx
msgid "Order"
msgstr "Order"

#: src/components/slot_scheduler/RandomSlotTable.tsx
msgid "Order of programming within the slot"
msgstr "Order of programming within the slot"

#: src/components/channel_config/ChannelProgrammingOrganizeOptions.tsx
msgid "Organize"
msgstr "Organize"

#: src/components/channels/ChannelPrograms.tsx
#: src/pages/library/TrashPage.tsx
msgid "Other Videos"
msgstr "Other Videos"

#: src/components/settings/general/BackupForm.tsx
#: src/pages/settings/XmlTvSettingsPage.tsx
msgid "Output Path"
msgstr "Output Path"

#: src/components/settings/ffmpeg/TranscodeConfigVideoSettingsForm.tsx
msgid "Output video at a constant frame rate."
msgstr "Output video at a constant frame rate."

#: src/components/slot_scheduler/SlotLinkingControl.tsx
#: src/components/slot_scheduler/SlotLinkingControl.tsx
msgid "Overflow Behavior"
msgstr "Overflow Behavior"

#: src/components/channel_config/ChannelTranscodingConfig.tsx
msgid "Override global audio and subtitle settings for this channel."
msgstr "Override global audio and subtitle settings for this channel."

#: src/components/slot_scheduler/TimeSlotConfigDialogPanel.tsx
msgid "Override how far past its boundary this slot's content can extend."
msgstr "Override how far past its boundary this slot's content can extend."

#: src/components/slot_scheduler/TimeSlotConfigDialogPanel.tsx
msgid "Override how late this slot can start if a previous slot ran long."
msgstr "Override how late this slot can start if a previous slot ran long."

#: src/components/slot_scheduler/TimeSlotConfigDialogPanel.tsx
msgid "Override how programs within this slot are padded."
msgstr "Override how programs within this slot are padded."

#. placeholder {0}: hardwareAccelerationMode === 'qsv' ? 'QSV' : 'VA-API'
#: src/components/settings/ffmpeg/TranscodeConfigVideoSettingsForm.tsx
msgid "Override the default {0} device path (defaults to <0>/dev/dri/renderD128</0> on Linux and blank otherwise)"
msgstr "Override the default {0} device path (defaults to <0>/dev/dri/renderD128</0> on Linux and blank otherwise)"

#: src/components/programs/ProgramDetailsDialog.tsx
msgid "Overview"
msgstr "Overview"

#: src/components/programming_controls/AddPaddingModal.tsx
#: src/components/programming_controls/AddPaddingModal.tsx
#: src/components/programming_controls/AddPaddingModal.tsx
msgid "Pad Start Times"
msgstr "Pad Start Times"

#: src/components/channel_config/ChannelProgrammingFlexTools.tsx
msgid "Pad Start Times..."
msgstr "Pad Start Times..."

#: src/components/slot_scheduler/RandomSlotSettingsForm.tsx
#: src/components/slot_scheduler/RandomSlotSettingsForm.tsx
msgid "Pad Style"
msgstr "Pad Style"

#: src/components/slot_scheduler/RandomSlotSettingsForm.tsx
#: src/components/slot_scheduler/RandomSlotSettingsForm.tsx
#: src/components/slot_scheduler/TimeSlotConfigDialogPanel.tsx
#: src/components/slot_scheduler/TimeSlotConfigDialogPanel.tsx
#: src/pages/channels/TimeSlotEditorPage.tsx
#: src/pages/channels/TimeSlotEditorPage.tsx
msgid "Pad Times"
msgstr "Pad Times"

#: src/components/shell/CommandPaletteContainer.tsx
msgid "Page"
msgstr "Page"

#: src/components/shell/CommandPaletteContainer.tsx
msgid "Pages"
msgstr "Pages"

#: src/components/settings/ffmpeg/TranscodeConfigAudioSettingsForm.tsx
msgid "Passthrough audio unchanged. Other settings will not apply."
msgstr "Passthrough audio unchanged. Other settings will not apply."

#: src/components/settings/media_source/EmbyServerEditDialog.tsx
#: src/components/settings/media_source/EmbyServerEditDialog.tsx
#: src/components/settings/media_source/JelllyfinServerEditDialog.tsx
#: src/components/settings/media_source/JelllyfinServerEditDialog.tsx
msgid "Password"
msgstr "Password"

#: src/components/settings/media_source/LocalMediaEditDialog.tsx
#: src/pages/system/TroubleshootPage.tsx
msgid "Path"
msgstr "Path"

#: src/components/settings/media_source/EditPathReplacementsForm.tsx
msgid "Path Replacements"
msgstr "Path Replacements"

#: src/components/slot_scheduler/MidRollConfigPanel.tsx
msgid "Percentage-Based"
msgstr "Percentage-Based"

#: src/pages/channels/TimeSlotEditorPage.tsx
#: src/pages/channels/TimeSlotEditorPage.tsx
msgid "Period"
msgstr "Period"

#: src/components/programming_controls/RemoveShowsModal.tsx
msgid "Pick specific programming to remove from the channel."
msgstr "Pick specific programming to remove from the channel."

#: src/pages/system/TroubleshootPage.tsx
msgid "Pipeline"
msgstr "Pipeline"

#: src/pages/system/TroubleshootPage.tsx
msgid "Pipeline Steps"
msgstr "Pipeline Steps"

#: src/pages/system/TroubleshootPage.tsx
msgid "Pixel Format"
msgstr "Pixel Format"

#: src/components/channel_config/ChannelEpgConfig.tsx
msgid "Placeholder Program Title"
msgstr "Placeholder Program Title"

#: src/pages/system/TroubleshootPage.tsx
msgid "Platform"
msgstr "Platform"

#: src/components/custom-shows/EditCustomShowForm.tsx
msgid "Playlist"
msgstr "Playlist"

#: src/components/channel_config/plex/PlexLibrarySelector.tsx
#: src/components/channel_config/plex/PlexProgrammingSelector.tsx
#~ msgid "Playlists"
#~ msgstr "Playlists"

#: src/components/channel_config/ChannelProgrammingSort.tsx
#~ msgid "Plays shows in a random order, one episode at a time, keeping each show's episodes in sequence. Each show starts at a random episode. Use Block Shuffle to start every show at its first episode or to loop shorter shows."
#~ msgstr "Plays shows in a random order, one episode at a time, keeping each show's episodes in sequence. Each show starts at a random episode. Use Block Shuffle to start every show at its first episode or to loop shorter shows."

#: src/components/channel_config/ChannelProgrammingSort.tsx
msgid "Plays shows in a random order, one episode at a time, keeping each show's episodes in sequence. Opens the shuffle settings, where you can start every show at its first episode or loop shorter shows."
msgstr "Plays shows in a random order, one episode at a time, keeping each show's episodes in sequence. Opens the shuffle settings, where you can start every show at its first episode or loop shorter shows."

#: src/components/channel_config/ChannelProgrammingFlexTools.tsx
msgid "Plays the channel's programming only between the hours you set. Flex fills the rest of the day. Removes existing Flex first, and removes programs longer than the allowed hours."
msgstr "Plays the channel's programming only between the hours you set. Flex fills the rest of the day. Removes existing Flex first, and removes programs longer than the allowed hours."

#: src/components/channel_config/ChannelProgrammingFlexTools.tsx
#~ msgid "Plays the channel's programming only between the hours you set. Flex fills the rest of the day. Removes existing Flex first."
#~ msgstr "Plays the channel's programming only between the hours you set. Flex fills the rest of the day. Removes existing Flex first."

#: src/components/programming_controls/AddReplicateModal.tsx
msgid "Please choose a value greater than 1"
msgstr "Please choose a value greater than 1"

#: src/components/settings/media_source/AddMediaSourceButton.tsx
msgid "Plex (Auto)"
msgstr "Plex (Auto)"

#: src/components/settings/media_source/AddMediaSourceButton.tsx
msgid "Plex (Manual)"
msgstr "Plex (Manual)"

#: src/components/channel_config/ChannelTranscodingConfig.tsx
#: src/components/channel_config/ChannelTranscodingConfig.tsx
msgid "Position"
msgstr "Position"

#: src/components/slot_scheduler/SlotFillerDialogPanel.tsx
msgid "Post"
msgstr "Post"

#: src/components/slot_scheduler/SlotFillerDialogPanel.tsx
msgid "Pre"
msgstr "Pre"

#: src/components/programming_controls/AddBlockShuffleModal.tsx
#: src/components/programming_controls/AddBlockShuffleModal.tsx
msgid "Preset"
msgstr "Preset"

#: src/components/slot_scheduler/RandomSlotPresetButton.tsx
msgid "Presets"
msgstr "Presets"

#: src/components/channel_config/ChannelSubtitlePreferencesTable.tsx
msgid "Priority"
msgstr "Priority"

#: src/components/settings/UnsavedNavigationAlert.tsx
msgid "Proceed"
msgstr "Proceed"

#: src/pages/system/TroubleshootPage.tsx
msgid "Profile"
msgstr "Profile"

#: src/components/ProgramSearchAutocomplete.tsx
#: src/components/slot_scheduler/RandomSlotTable.tsx
#: src/components/slot_scheduler/RedirectProgrammingForm.tsx
#: src/components/slot_scheduler/ShowSlotProgrammingForm.tsx
#: src/components/slot_scheduler/TimeSlotTable.tsx
#: src/pages/system/TroubleshootPage.tsx
msgid "Program"
msgstr "Program"

#: src/components/programming_controls/BalanceProgrammingModal.tsx
#: src/components/slot_scheduler/EditRandomSlotDialogContent.tsx
msgid "Program Count"
msgstr "Program Count"

#: src/components/RawProgramDetails.tsx
msgid "Program JSON"
msgstr "Program JSON"

#: src/pages/system/TroubleshootPage.tsx
msgid "Program Playback Troubleshooter"
msgstr "Program Playback Troubleshooter"

#: src/components/custom-shows/EditCustomShowForm.tsx
#: src/components/filler/EditFillerListForm.tsx
#: src/components/slot_scheduler/EditRandomSlotDialogContent.tsx
#: src/components/slot_scheduler/EditTimeSlotDialogContent.tsx
#: src/hooks/useRouteName.ts
msgid "Programming"
msgstr "Programming"

#: src/pages/channels/RandomSlotEditorPage.tsx
#: src/pages/channels/TimeSlotEditorPage.tsx
msgid "Programming Preview"
msgstr "Programming Preview"

#: src/components/channel_config/ChannelPropertiesEditor.tsx
#: src/pages/channels/TimeSlotEditorPage.tsx
msgid "Programming Start"
msgstr "Programming Start"

#: src/components/programming_controls/AddRestrictHoursModal.tsx
msgid "Programming starts at {startTime} and stops at {endTime}"
msgstr "Programming starts at {startTime} and stops at {endTime}"

#: src/components/channels/ChannelSummaryQuickStats.tsx
msgid "Programs"
msgstr "Programs"

#: src/components/channel_config/AddProgrammingButton.tsx
#~ msgid "Programs a Flex time slot. Normally you'd use pad times, restrict times or add breaks to add a large quantity of Flex times at once, but this exists for more specific cases."
#~ msgstr "Programs a Flex time slot. Normally you'd use pad times, restrict times or add breaks to add a large quantity of Flex times at once, but this exists for more specific cases."

#: src/components/channel_config/AddProgrammingButton.tsx
#~ msgid "Programs a single Flex time slot. To add Flex across the whole lineup at once, use the Flex menu."
#~ msgstr "Programs a single Flex time slot. To add Flex across the whole lineup at once, use the Flex menu."

#: src/components/channel_config/ChannelProgrammingConfig.tsx
msgid "Programs saved!"
msgstr "Programs saved!"

#. placeholder {0}: errors?.guideMinimumDuration?.message ?? ''
#: src/components/channel_config/ChannelEpgConfig.tsx
msgid ""
"Programs shorter than this value will be treated the same as Flex time. Meaning that the TV Guide will try to meld them with the previous program or display the block of programs as the \"place holder program\" if they make a large continuous group. Use 0 to disable this feature or use a large value to make the channel report only the placeholder program and not the real programming.\n"
"{0}"
msgstr ""
"Programs shorter than this value will be treated the same as Flex time. Meaning that the TV Guide will try to meld them with the previous program or display the block of programs as the \"place holder program\" if they make a large continuous group. Use 0 to disable this feature or use a large value to make the channel report only the placeholder program and not the real programming.\n"
"{0}"

#: src/components/slot_scheduler/SlotProgrammingTooLongWarningDetails.tsx
msgid "Programs Too Long"
msgstr "Programs Too Long"

#: src/components/channel_config/EditChannelForm.tsx
msgid "Properties"
msgstr "Properties"

#: src/components/settings/media_source/EmbyServerEditDialog.tsx
#: src/components/settings/media_source/JelllyfinServerEditDialog.tsx
#: src/components/settings/media_source/PlexServerEditDialog.tsx
msgid "Protocol must be HTTP or HTTPS"
msgstr "Protocol must be HTTP or HTTPS"

#: src/components/settings/ffmpeg/TranscodeConfigVideoSettingsForm.tsx
msgid "QSV Device"
msgstr "QSV Device"

#: src/components/MediaSourceLibraryTable.tsx
#: src/components/MediaSourceLibraryTable.tsx
msgid "Queued"
msgstr "Queued"

#: src/components/channel_config/ChannelProgrammingSort.tsx
#: src/components/custom-shows/CustomShowSortToolsMenu.tsx
#: src/components/programming_controls/AddBlockShuffleModal.tsx
#: src/components/programming_controls/AddBlockShuffleModal.tsx
msgid "Random"
msgstr "Random"

#: src/components/channel_config/ChannelProgrammingSort.tsx
#: src/components/custom-shows/CustomShowSortToolsMenu.tsx
msgid "Random (by show)"
msgstr "Random (by show)"

#: src/components/programming_controls/AddBlockShuffleModal.tsx
msgid "Random Episode"
msgstr "Random Episode"

#: src/components/channel_config/ChannelProgrammingSort.tsx
msgid "Random..."
msgstr "Random..."

#: src/components/custom-shows/CustomShowSortToolsMenu.tsx
msgid "Random…"
msgstr "Random…"

#: src/components/slot_scheduler/MidRollConfigPanel.tsx
msgid "Range"
msgstr "Range"

#: src/components/programs/MediaDetailCard.tsx
msgid "Read Less"
msgstr "Read Less"

#: src/components/programs/MediaDetailCard.tsx
msgid "Read More"
msgstr "Read More"

#: src/components/programming_controls/AddRedirectModal.tsx
msgid "Redirect duration"
msgstr "Redirect duration"

#. placeholder {0}: p.channelName
#. placeholder {0}: p.name
#: src/hooks/programming_controls/useSlotProgramOptions.ts
#: src/hooks/useProgramTitleFormatter.ts
msgid "Redirect to \"{0}\""
msgstr "Redirect to \"{0}\""

#. placeholder {0}: p.channel
#: src/components/guide/TvGuide.tsx
msgid "Redirect to Channel {0}"
msgstr "Redirect to Channel {0}"

#: src/components/channel_config/AddProgrammingButton.tsx
msgid "Redirect..."
msgstr "Redirect..."

#: src/hooks/useVersion.tsx
msgid "Refresh"
msgstr "Refresh"

#: src/pages/settings/MediaSourceSettingsPage.tsx
msgid "Refresh Libraries"
msgstr "Refresh Libraries"

#: src/pages/ErrorPage.tsx
msgid "Refresh Page"
msgstr "Refresh Page"

#: src/components/slot_scheduler/RandomSlotSettingsForm.tsx
#: src/pages/channels/TimeSlotEditorPage.tsx
msgid "Refresh Preview"
msgstr "Refresh Preview"

#: src/pages/settings/XmlTvSettingsPage.tsx
#: src/pages/settings/XmlTvSettingsPage.tsx
msgid "Refresh Timer (Hours)"
msgstr "Refresh Timer (Hours)"

#: src/components/channel_config/ChannelProgrammingSort.tsx
#: src/components/custom-shows/CustomShowSortToolsMenu.tsx
#: src/components/programming_controls/AddBlockShuffleModal.tsx
msgid "Release Date"
msgstr "Release Date"

#: src/components/channel_config/ChannelProgrammingSort.tsx
#: src/components/custom-shows/CustomShowSortToolsMenu.tsx
msgid "Release Date (asc)"
msgstr "Release Date (asc)"

#: src/components/channel_config/ChannelProgrammingSort.tsx
#: src/components/custom-shows/CustomShowSortToolsMenu.tsx
msgid "Release Date (desc)"
msgstr "Release Date (desc)"

#: src/components/Video.tsx
msgid "Reload Stream"
msgstr "Reload Stream"

#: src/components/library/ProgramListItem.tsx
msgid "Remove"
msgstr "Remove"

#. placeholder {0}: import { betterHumanize } from '@/helpers/dayjs'; import { isNonEmptyString } from '@/helpers/util'; import { Autocomplete, Box, Checkbox, Chip, DialogContentText, List, ListItem, ListItemText, TextField, } from '@mui/material'; import Button from '@mui/material/Button'; import Dialog from '@mui/material/Dialog'; import DialogActions from '@mui/material/DialogActions'; import DialogContent from '@mui/material/DialogContent'; import DialogTitle from '@mui/material/DialogTitle'; import { seq } from '@tunarr/shared/util'; import dayjs from 'dayjs'; import { every, identity, includes, isEmpty, map, reduce, some, uniqBy, values, } from 'lodash-es'; import { Trans, useLingui } from '@lingui/react/macro'; import { plural } from '@lingui/core/macro'; import type { HTMLAttributes } from 'react'; import { useMemo, useState } from 'react'; import { match, P } from 'ts-pattern'; import { useCounter } from 'usehooks-ts'; import { extractProgramGrandparent } from '../../helpers/programUtil.ts'; import type { RemoveProgrammingRequest } from '../../hooks/programming_controls/useRemoveProgramming'; import { useRemoveProgramming } from '../../hooks/programming_controls/useRemoveProgramming'; import useStore from '../../store'; import { materializedProgramListSelector } from '../../store/selectors'; type RemoveShowsModalProps = { open: boolean; onClose: () => void; }; interface FilmOptionType { id: string; title: string; firstLetter?: string; } const RemoveShowsModalContent = ({ onClose, }: Omit<RemoveShowsModalProps, 'open'>) => { const { t } = useLingui(); const { count, increment, decrement } = useCounter(0); const removeProgramming = useRemoveProgramming(); const [removeRequest, setRemoveRequest] = useState<RemoveProgrammingRequest>( {}, ); const programs = useStore(materializedProgramListSelector); const hasMovies = useMemo(() => { return some( programs, (p) => p.type === 'content' && p.program.type === 'movie', ); }, [programs]); const numAndDurationById = useMemo(() => { return reduce( programs, (acc, curr) => { const key = match(curr) .with( { type: 'content', program: { type: P.select(P.union('movie', 'music_video', 'other_video')), }, }, identity, ) .with( { type: 'content', program: { type: 'episode' } }, ({ program }) => program.show?.uuid ?? program.season?.show?.uuid, ) .with( { type: 'content', program: { type: 'track' } }, ({ program }) => program.artist?.uuid ?? program.album?.artist?.uuid, ) .with({ type: P._ }, () => undefined) .exhaustive(); if (key) { acc[key] ??= { totalDuration: 0, totalPrograms: 0 }; acc[key].totalDuration += curr.duration; acc[key].totalPrograms++; } return acc; }, {} as Record<string, { totalPrograms: number; totalDuration: number }>, ); }, [programs]); // Get the total number of movies from the memoized object const movieCount = numAndDurationById['movie']?.totalPrograms ?? 0; const showList = useMemo(() => { return map( uniqBy( seq.collect(programs, (program) => { if ( program.type === 'content' && program.program.type === 'episode' && isNonEmptyString( program.program.show?.uuid ?? program.program.season?.show?.uuid, ) ) { return program; } return; }), ({ program }) => extractProgramGrandparent(program)?.uuid, ), ({ program }) => ({ // Verified safe above // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain id: extractProgramGrandparent(program)?.uuid!, title: extractProgramGrandparent(program)?.title ?? program.title, }), ); }, [programs]); const artistList = useMemo(() => { return map( uniqBy( seq.collect(programs, (program) => { if ( program.type === 'content' && program.program.type === 'track' && isNonEmptyString(extractProgramGrandparent(program.program)?.uuid) ) { return program; } return; }), ({ program }) => extractProgramGrandparent(program)?.uuid, ), ({ program }) => ({ // Verified safe above // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain id: extractProgramGrandparent(program)?.uuid!, title: extractProgramGrandparent(program)?.title ?? program.title, }), ); }, [programs]); const mapListToGroupedOptions = ( list: Array<{ id: string; title: string }>, ) => { return list.map((option) => { // Get the first letter, use a placeholder if title is empty. const firstLetter = (option.title?.[0] ?? '-').toUpperCase(); return { // Group numbers/digits under '0-9', otherwise use the first letter. firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter, ...option, }; }); }; const showOptions = useMemo( () => mapListToGroupedOptions(showList), [showList], ); const artistOptions = useMemo( () => mapListToGroupedOptions(artistList), [artistList], ); const isEmptyRemoveRequest = useMemo(() => { return ( isEmpty(removeRequest) ?? every(values(removeRequest), (value) => { // If it's a boolean (movies: true/false), only check if it's the 'empty' state (false). // We do this because lodash treats booleans as empty regardless of value if (typeof value === 'boolean') { return value === false; } // Otherwise, check if the value is empty. return isEmpty(value); }) ); }, [removeRequest]); const removeShowsProgramming = () => { removeProgramming(removeRequest); onClose(); }; const getProgramCounts = (id: string, type?: string) => { const details = numAndDurationById[id]; if (!details) { return null; } const count = details.totalPrograms; const programLabel = type === 'episode' ? plural(count, { one: 'episode', other: 'episodes' }) : type === 'track' ? plural(count, { one: 'track', other: 'tracks' }) : plural(count, { one: 'program', other: 'programs' }); return t`${count} ${programLabel}, ${betterHumanize( dayjs.duration(details.totalDuration), { style: 'short', }, )}`; }; const getArtistIds = (options: FilmOptionType[]) => map(options, 'id'); return ( <> <DialogTitle> <Trans>Remove Programming</Trans> </DialogTitle> <DialogContent> <DialogContentText> <Trans>Pick specific programming to remove from the channel.</Trans> </DialogContentText> <Autocomplete options={[...showOptions].sort( (a, b) => -b.firstLetter.localeCompare(a.firstLetter), )} groupBy={(option: FilmOptionType) => option.firstLetter ?? '-'} getOptionLabel={(option: FilmOptionType) => option.title} openOnFocus sx={{ my: 2, flex: 1 }} autoComplete includeInputInList multiple={true} getOptionDisabled={(option) => { const selectedIds = removeRequest.showIds ?? []; return includes(selectedIds, option.id); }} onChange={(_, newOptions) => { // Extract the IDs from the selected options const newShowIds = map(newOptions, 'id'); setRemoveRequest((prev) => ({ ...prev, showIds: newShowIds, })); // Update the program counter based on the number of selected shows const countDifference = newShowIds.length - (removeRequest.showIds?.length ?? 0); if (countDifference > 0) { for (let i = 0; i < countDifference; i++) increment(); } else if (countDifference < 0) { for (let i = 0; i < Math.abs(countDifference); i++) decrement(); } }} value={ removeRequest.showIds ? showList.filter((show) => (removeRequest.showIds ?? []).includes(show.id), ) : [] } renderInput={(params) => ( <TextField {...params} label={t`Select Shows to Remove`} /> )} renderOption={( props: HTMLAttributes<HTMLLIElement>, option: FilmOptionType, ) => { const { ...optionProps } = props; return ( <Box key={option.id} component="li" sx={{ width: '100%', flexDirection: ['column', 'row'], }} {...optionProps} > <div style={{ textAlign: 'left', width: '100%', }} > {option.title} </div> <Chip label={getProgramCounts(option.id, 'episode')} size="small" sx={{ width: '100%' }} /> </Box> ); }} /> {artistList.length > 0 && ( <Autocomplete options={[...artistOptions].sort( (a, b) => -b.firstLetter.localeCompare(a.firstLetter), )} groupBy={(option: FilmOptionType) => option.firstLetter ?? '-'} getOptionLabel={(option: FilmOptionType) => option.title} openOnFocus sx={{ my: 2, flex: 1 }} autoComplete includeInputInList multiple={true} getOptionDisabled={(option) => { const selectedIds = removeRequest.artistIds ?? []; return includes(selectedIds, option.id); }} value={ removeRequest.artistIds ? artistList.filter((artist) => (removeRequest.artistIds ?? []).includes(artist.id), ) : [] } onChange={(_, newOptions) => { const newArtistIds = getArtistIds(newOptions); const previousArtistIds = removeRequest.artistIds ?? []; setRemoveRequest((prev) => ({ ...prev, artistIds: newArtistIds, })); // Update the program counter based on the number of selected shows const countDifference = newArtistIds.length - previousArtistIds.length; if (countDifference > 0) { for (let i = 0; i < countDifference; i++) increment(); } else if (countDifference < 0) { for (let i = 0; i < Math.abs(countDifference); i++) decrement(); } }} renderInput={(params) => ( <TextField {...params} label={t`Select Artists to Remove`} /> )} renderOption={( props: HTMLAttributes<HTMLLIElement>, option: FilmOptionType, ) => { const { ...optionProps } = props; return ( <Box key={option.id} component="li" sx={{ width: '100%', flexDirection: ['column', 'row'], }} {...optionProps} > <div style={{ textAlign: 'left', width: '100%', }} > {option.title} </div> <Chip label={getProgramCounts(option.id, 'track')} size="small" sx={{ width: '100%' }} /> </Box> ); }} /> )} <Box key="dynamic-list-container"> <List dense> {hasMovies && ( <ListItem secondaryAction={ <Checkbox edge="end" onChange={(e) => { const isChecked = e.target.checked; setRemoveRequest((prev) => { const newState = { ...prev, movies: isChecked, }; return newState; }); const countDelta = isChecked ? movieCount : -movieCount; for (let i = 0; i < Math.abs(countDelta); i++) { if (countDelta > 0) increment(); else decrement(); } }} checked={!!removeRequest.movies} /> } > <ListItemText primary={t`Remove All ${movieCount} ${plural(movieCount, { one: 'Movie', other: 'Movies' })}`} secondary={getProgramCounts('movies')} /> </ListItem> )} </List> </Box> </DialogContent> <DialogActions> <Button onClick={() => onClose()}> <Trans>Cancel</Trans> </Button> <Button variant="contained" onClick={() => removeShowsProgramming()} disabled={isEmptyRemoveRequest} > <Trans> Remove {count}{' '} {plural(count, { one: 'program', other: 'programs' })} </Trans> </Button> </DialogActions> </> ); }; // The content mounts only while the dialog is open, so it does no work when closed. export const RemoveShowsModal = ({ open, ...props }: RemoveShowsModalProps) => ( <Dialog open={open} scroll={'paper'}> <RemoveShowsModalContent {...props} /> </Dialog> ); 
#: src/components/programming_controls/RemoveShowsModal.tsx
msgid "Remove {count} {0}"
msgstr "Remove {count} {0}"

#: src/components/slot_scheduler/SlotProgrammingTooLongWarningDetails.tsx
msgid "Remove All"
msgstr "Remove All"

#: src/components/programming_controls/RemoveShowsModal.tsx
msgid "Remove All {movieCount} {movieCount, plural, one {Movie} other {Movies}}"
msgstr "Remove All {movieCount} {movieCount, plural, one {Movie} other {Movies}}"

#: src/components/channel_config/ChannelProgrammingFlexTools.tsx
msgid "Remove All Flex"
msgstr "Remove All Flex"

#: src/components/channel_config/ChannelPropertiesEditor.tsx
#~ msgid "Remove custom icon"
#~ msgstr "Remove custom icon"

#: src/components/channel_config/ChannelPropertiesEditor.tsx
msgid "Remove icon"
msgstr "Remove icon"

#: src/components/programming_controls/RemoveShowsModal.tsx
msgid "Remove Programming"
msgstr "Remove Programming"

#: src/components/channel_config/ChannelProgrammingDeleteOptions.tsx
msgid "Remove..."
msgstr "Remove..."

#: src/components/channel_config/ChannelProgrammingFlexTools.tsx
msgid "Removes all Flex periods from the schedule."
msgstr "Removes all Flex periods from the schedule."

#: src/components/custom-shows/CustomShowSortToolsMenu.tsx
msgid "Removes all programs from custom show"
msgstr "Removes all programs from custom show"

#: src/components/channel_config/ChannelProgrammingDeleteOptions.tsx
msgid "Removes all programs from schedule"
msgstr "Removes all programs from schedule"

#: src/components/channel_config/ChannelProgrammingDeleteOptions.tsx
msgid "Removes any specials from the schedule. Specials are episodes with season '00'."
msgstr "Removes any specials from the schedule. Specials are episodes with season '00'."

#: src/components/channel_config/ChannelProgrammingDeleteOptions.tsx
msgid "Removes repeated programs."
msgstr "Removes repeated programs."

#: src/components/slot_scheduler/SlotProgrammingTooLongWarningDetails.tsx
msgid "Removing overrun programs from the channel."
msgstr "Removing overrun programs from the channel."

#: src/components/channel_config/ChannelTranscodingConfig.tsx
msgid "Renders a channel icon (also known as bug or Digital On-screen Graphic) on top of the channel's stream."
msgstr "Renders a channel icon (also known as bug or Digital On-screen Graphic) on top of the channel's stream."

#: src/components/programming_controls/AddRerunBlockModal.tsx
msgid "Repeats"
msgstr "Repeats"

#: src/components/programming_controls/AddReplicateModal.tsx
msgid "Replicate Programs"
msgstr "Replicate Programs"

#: src/components/channel_config/ChannelProgrammingOrganizeOptions.tsx
msgid "Replicate..."
msgstr "Replicate..."

#: src/components/slot_scheduler/SlotLinkingControl.tsx
msgid "Rerun"
msgstr "Rerun"

#: src/pages/settings/ScannerSettingsPage.tsx
#: src/pages/settings/ScannerSettingsPage.tsx
msgid "Rescan Interval (hours)"
msgstr "Rescan Interval (hours)"

#: src/components/channel_config/ChannelProgrammingConfig.tsx
#: src/components/custom-shows/EditCustomShowForm.tsx
#: src/components/filler/EditFillerListForm.tsx
msgid "Reset"
msgstr "Reset"

#: src/components/channel_config/ChannelEditActions.tsx
#: src/components/settings/ffmpeg/TranscodeConfigSettingsForm.tsx
#: src/pages/settings/FeaturesSettingsPage.tsx
#: src/pages/settings/FfmpegSettingsPage.tsx
#: src/pages/settings/HdhrSettingsPage.tsx
#: src/pages/settings/XmlTvSettingsPage.tsx
msgid "Reset Changes"
msgstr "Reset Changes"

#: src/components/channel_config/ChannelProgrammingConfig.tsx
msgid "Reset changes made to the channel's lineup"
msgstr "Reset changes made to the channel's lineup"

#: src/components/settings/general/GeneralSettingsForm.tsx
#: src/pages/channels/RandomSlotEditorPage.tsx
#: src/pages/channels/TimeSlotEditorPage.tsx
msgid "Reset Options"
msgstr "Reset Options"

#: src/components/custom-shows/EditCustomShowForm.tsx
msgid "Reset programming to most recently saved state"
msgstr "Reset programming to most recently saved state"

#: src/pages/guide/GuidePage.tsx
msgid "Reset to current date/time"
msgstr "Reset to current date/time"

#: src/components/settings/ffmpeg/TranscodeConfigsTable.tsx
#: src/components/settings/ffmpeg/TranscodeConfigVideoSettingsForm.tsx
#: src/pages/system/TroubleshootPage.tsx
msgid "Resolution"
msgstr "Resolution"

#: src/components/channel_config/ChannelPropertiesEditor.tsx
msgid "Restore default logo"
msgstr "Restore default logo"

#: src/pages/settings/HdhrSettingsPage.tsx
#: src/pages/settings/XmlTvSettingsPage.tsx
msgid "Restore Default Settings"
msgstr "Restore Default Settings"

#: src/components/programming_controls/AddRestrictHoursModal.tsx
msgid "Restrict Hours"
msgstr "Restrict Hours"

#: src/components/channel_config/ChannelProgrammingFlexTools.tsx
msgid "Restrict Hours..."
msgstr "Restrict Hours..."

#: src/components/search/SearchInput.tsx
msgid "Restrict search fields"
msgstr "Restrict search fields"

#: src/components/ui/patterns/AppShell/CommandPalette.tsx
msgid "Results"
msgstr "Results"

#: src/components/channel_config/SelectedProgrammingActions.tsx
msgid "Review"
msgstr "Review"

#: src/components/channel_config/SelectedProgrammingActions.tsx
msgid "Review Selections"
msgstr "Review Selections"

#: src/components/settings/general/LogRollForm.tsx
msgid "Roll based on size"
msgstr "Roll based on size"

#: src/components/settings/general/LogRollForm.tsx
msgid "Roll on Schedule"
msgstr "Roll on Schedule"

#: src/components/settings/general/LogRollForm.tsx
msgid "Roll the log file on a fixed schedule, regardless of file size."
msgstr "Roll the log file on a fixed schedule, regardless of file size."

#: src/components/settings/general/LogRollForm.tsx
msgid "Roll the log file when it grows past the maximum size."
msgstr "Roll the log file when it grows past the maximum size."

#: src/components/library/LibraryListViewBreadcrumbs.tsx
msgid "Root"
msgstr "Root"

#: src/components/ui/table/DataTable.tsx
msgid "Rows per page"
msgstr "Rows per page"

#: src/pages/settings/TaskSettingsPage.tsx
msgid "Run"
msgstr "Run"

#: src/pages/settings/TaskSettingsPage.tsx
msgid "Run now"
msgstr "Run now"

#: src/pages/system/TroubleshootPage.tsx
msgid "Run Troubleshooter"
msgstr "Run Troubleshooter"

#: src/pages/system/TroubleshootPage.tsx
msgid "Running..."
msgstr "Running..."

#: src/components/settings/ffmpeg/TranscodeConfigAudioSettingsForm.tsx
msgid "Sample rate cannot be changed when copying input audio"
msgstr "Sample rate cannot be changed when copying input audio"

#: src/components/channel_config/ChannelEditActions.tsx
#: src/components/channel_config/ChannelEditActions.tsx
#: src/components/channel_config/ChannelProgrammingConfig.tsx
#: src/components/custom-shows/EditCustomShowForm.tsx
#: src/components/filler/EditFillerListForm.tsx
#: src/components/programming_controls/AddBreaksModal.tsx
#: src/components/programming_controls/AddFlexModal.tsx
#: src/components/programming_controls/AddRedirectModal.tsx
#: src/components/programming_controls/AddReplicateModal.tsx
#: src/components/programming_controls/AddRerunBlockModal.tsx
#: src/components/programming_controls/AddRestrictHoursModal.tsx
#: src/components/programming_controls/AdjustWeightsModal.tsx
#: src/components/settings/general/GeneralSettingsForm.tsx
#: src/components/slot_scheduler/EditRandomSlotDialogContent.tsx
#: src/components/slot_scheduler/EditTimeSlotDialogContent.tsx
#: src/components/slot_scheduler/SlotSchedulerCyclicShuffleDialog.tsx
#: src/components/smart_collections/CreateSmartCollectionDialog.tsx
#: src/components/smart_collections/EditSmartCollectionDialog.tsx
#: src/pages/channels/RandomSlotEditorPage.tsx
#: src/pages/channels/TimeSlotEditorPage.tsx
#: src/pages/settings/FeaturesSettingsPage.tsx
#: src/pages/settings/FfmpegSettingsPage.tsx
#: src/pages/settings/HdhrSettingsPage.tsx
#: src/pages/settings/ScannerSettingsPage.tsx
#: src/pages/settings/XmlTvSettingsPage.tsx
msgid "Save"
msgstr "Save"

#: src/components/smart_collections/CreateSmartCollectionDialog.tsx
msgid "Save as new collection…"
msgstr "Save as new collection…"

#: src/components/search/SearchInput.tsx
msgid "Save as Smart Collection"
msgstr "Save as Smart Collection"

#: src/components/smart_collections/CreateSmartCollectionDialog.tsx
msgid "Save Smart Collection"
msgstr "Save Smart Collection"

#: src/components/MediaSourceLibraryTable.tsx
msgid "Scan"
msgstr "Scan"

#. placeholder {0}: prettifySnakeCaseString(programType)
#: src/components/programs/ProgramOperationsMenu.tsx
msgid "Scan {0}"
msgstr "Scan {0}"

#: src/pages/welcome/WelcomePage.tsx
msgid "Scan your libraries"
msgstr "Scan your libraries"

#: src/components/shell/useShellNav.tsx
msgid "Scanner"
msgstr "Scanner"

#: src/components/MediaSourceLibraryTable.tsx
#: src/components/MediaSourceLibraryTable.tsx
msgid "Scanning"
msgstr "Scanning"

#: src/components/channel_config/ChannelProgrammingOrganizeOptions.tsx
msgid "Schedule programming in blocks that are either count or duration based. Can be used to generate random schedules."
msgstr "Schedule programming in blocks that are either count or duration based. Can be used to generate random schedules."

#: src/components/channel_config/ChannelProgrammingOrganizeOptions.tsx
msgid "Schedule programming using slots assigned a start time and duration."
msgstr "Schedule programming using slots assigned a start time and duration."

#: src/components/ui/table/DataTable.tsx
#: src/components/ui/table/DataTable.tsx
#: src/hooks/useRouteName.ts
msgid "Search"
msgstr "Search"

#: src/components/ui/patterns/AppShell/ShellTopBar.tsx
msgid "Search ({searchShortcut})"
msgstr "Search ({searchShortcut})"

#: src/pages/system/TroubleshootPage.tsx
msgid "Search for a program"
msgstr "Search for a program"

#: src/components/ProgramSearchAutocomplete.tsx
msgid "Search for shows"
msgstr "Search for shows"

#: src/routes/media_sources_/$mediaSourceId/libraries_.$libraryId.tsx
msgid "Search is currently scoped to this Media Source Library."
msgstr "Search is currently scoped to this Media Source Library."

#: src/routes/media_sources_/$mediaSourceId/index.tsx
msgid "Search is currently scoped to this Media Source."
msgstr "Search is currently scoped to this Media Source."

#. placeholder {0}: query.trim()
#: src/components/ui/patterns/AppShell/CommandPalette.tsx
msgid "Search library for “{0}”"
msgstr "Search library for “{0}”"

#: src/components/ui/patterns/AppShell/CommandPalette.tsx
#: src/components/ui/patterns/AppShell/CommandPalette.tsx
#: src/components/ui/patterns/AppShell/PhoneNav.tsx
#: src/components/ui/patterns/AppShell/ShellTopBar.tsx
msgid "Search or jump to"
msgstr "Search or jump to"

#: src/components/ui/patterns/AppShell/CommandPalette.tsx
#: src/components/ui/patterns/AppShell/ShellTopBar.tsx
msgid "Search or jump to…"
msgstr "Search or jump to…"

#: src/pages/system/StatusPage.tsx
msgid "Search Server URL:"
msgstr "Search Server URL:"

#: src/components/TopBar.tsx
#~ msgid "Search…"
#~ msgstr "Search…"

#: src/components/programs/Seasons.tsx
msgid "Seasons"
msgstr "Seasons"

#: src/pages/system/TroubleshootPage.tsx
msgid "Select a program and channel to test playback. The troubleshooter will analyze stream selection, build the FFmpeg pipeline, and run a short test transcode."
msgstr "Select a program and channel to test playback. The troubleshooter will analyze stream selection, build the FFmpeg pipeline, and run a short test transcode."

#: src/components/slot_scheduler/SlotLinkingControl.tsx
msgid "Select a slot to link to"
msgstr "Select a slot to link to"

#: src/components/channel_config/SelectedProgrammingActions.tsx
#: src/components/search/SearchFieldRestrictMenu.tsx
msgid "Select All"
msgstr "Select All"

#: src/components/programming_controls/RemoveShowsModal.tsx
msgid "Select Artists to Remove"
msgstr "Select Artists to Remove"

#: src/components/programming_controls/RemoveShowsModal.tsx
msgid "Select Shows to Remove"
msgstr "Select Shows to Remove"

#: src/components/settings/general/GeneralSettingsForm.tsx
msgid "Select the port the Tunarr server will listen on. This requires a server restart to take effect."
msgstr "Select the port the Tunarr server will listen on. This requires a server restart to take effect."

#: src/pages/system/TroubleshootPage.tsx
msgid "Selected Audio"
msgstr "Selected Audio"

#: src/pages/system/TroubleshootPage.tsx
msgid "Selected Subtitle"
msgstr "Selected Subtitle"

#: src/components/settings/media_source/EmbyServerEditDialog.tsx
#: src/components/settings/media_source/JelllyfinServerEditDialog.tsx
#: src/components/settings/media_source/PlexServerEditDialog.tsx
msgid "Server is unreachable"
msgstr "Server is unreachable"

#: src/components/settings/general/GeneralSettingsForm.tsx
msgid "Server Listen Port"
msgstr "Server Listen Port"

#: src/components/settings/media_source/EditPathReplacementsForm.tsx
msgid "Server Path"
msgstr "Server Path"

#: src/components/settings/general/GeneralSettingsForm.tsx
msgid "Server Settings"
msgstr "Server Settings"

#: src/pages/settings/FeaturesSettingsPage.tsx
msgid "Set by environment variable"
msgstr "Set by environment variable"

#: src/components/settings/general/GeneralSettingsForm.tsx
msgid "Set the host of your Tunarr backend. When empty, the web UI will use the current host/port to communicate with the backend."
msgstr "Set the host of your Tunarr backend. When empty, the web UI will use the current host/port to communicate with the backend."

#: src/components/settings/general/GeneralSettingsForm.tsx
msgid "Set the log level for the Tunarr server.<0/>Selecting <1>\"Use environment settings\"</1> will instruct the server to use the <2>LOG_LEVEL</2> environment variable, if set, or system default \"info\"."
msgstr "Set the log level for the Tunarr server.<0/>Selecting <1>\"Use environment settings\"</1> will instruct the server to use the <2>LOG_LEVEL</2> environment variable, if set, or system default \"info\"."

#: src/components/settings/general/BackupForm.tsx
msgid "Set to 0 to never delete backups"
msgstr "Set to 0 to never delete backups"

#: src/components/settings/ffmpeg/TranscodeConfigSettingsForm.tsx
msgid "Sets the number of threads used to decode the input stream. Set to 0 to let ffmpeg automatically decide how many threads to use. Read more about this option <0>here</0>. <1>Note: </1> this option is overridden to 1 when using hardware accelearation for stability reasons."
msgstr "Sets the number of threads used to decode the input stream. Set to 0 to let ffmpeg automatically decide how many threads to use. Read more about this option <0>here</0>. <1>Note: </1> this option is overridden to 1 when using hardware accelearation for stability reasons."

#: src/components/shell/useShellNav.tsx
#: src/components/slot_scheduler/RandomSlotSettingsForm.tsx
#: src/pages/channels/TimeSlotEditorPage.tsx
#: src/pages/settings/SettingsLayout.tsx
#: src/pages/welcome/WelcomePage.tsx
msgid "Settings"
msgstr "Settings"

#: src/components/settings/general/GeneralSettingsForm.tsx
#: src/pages/settings/FfmpegSettingsPage.tsx
#: src/pages/settings/HdhrSettingsPage.tsx
#: src/pages/settings/XmlTvSettingsPage.tsx
msgid "Settings Saved!"
msgstr "Settings Saved!"

#: src/components/programming_controls/ShuffleProgrammingModal.tsx
#: src/components/slot_scheduler/ShowSearchSlotProgrammingForm.tsx
#: src/components/slot_scheduler/SlotSchedulerCyclicShuffleDialog.tsx
#: src/components/slot_scheduler/SlotSchedulerCyclicShuffleDialog.tsx
msgid "Show"
msgstr "Show"

#: src/components/settings/ffmpeg/TranscodeConfigSettingsForm.tsx
msgid "Show Advanced"
msgstr "Show Advanced"

#: src/components/MediaSourceLibraryTable.tsx
msgid "Show disabled libraries"
msgstr "Show disabled libraries"

#: src/components/channel_config/ProgrammingSelector.tsx
#~ msgid "Show only synced libraries"
#~ msgstr "Show only synced libraries"

#: src/components/programming_controls/AddBlockShuffleModal.tsx
#: src/components/programming_controls/AddBlockShuffleModal.tsx
msgid "Show Order"
msgstr "Show Order"

#: src/pages/guide/GuidePage.tsx
msgid "Show Stealth"
msgstr "Show Stealth"

#: src/components/programming_controls/ShuffleProgrammingModal.tsx
msgid "Show:"
msgstr "Show:"

#. placeholder {0}: show.title
#: src/components/slot_scheduler/SlotSchedulerCyclicShuffleDialog.tsx
msgid "Show: {0}"
msgstr "Show: {0}"

#: src/components/ui/table/DataTable.tsx
#: src/components/ui/table/DataTable.tsx
msgid "Show/Hide columns"
msgstr "Show/Hide columns"

#: src/components/ui/table/DataTable.tsx
#: src/components/ui/table/DataTable.tsx
msgid "Show/Hide filters"
msgstr "Show/Hide filters"

#: src/components/ui/table/DataTable.tsx
msgid "Show/Hide filters ({activeFilters} active)"
msgstr "Show/Hide filters ({activeFilters} active)"

#: src/components/ui/table/DataTable.tsx
#: src/components/ui/table/DataTable.tsx
msgid "Show/Hide search"
msgstr "Show/Hide search"

#: src/components/channels/ChannelPrograms.tsx
#: src/hooks/programming_controls/useSlotProgramOptions.ts
msgid "Shows"
msgstr "Shows"

#: src/components/programming_controls/AddBlockShuffleModal.tsx
msgid "Shows come up at random, one episode at a time. Each show's episodes stay in order, starting from a random episode."
msgstr "Shows come up at random, one episode at a time. Each show's episodes stay in order, starting from a random episode."

#: src/components/programming_controls/AddBlockShuffleModal.tsx
msgid "Shows take turns in a fixed order, each playing a block of episodes before the next show."
msgstr "Shows take turns in a fixed order, each playing a block of episodes before the next show."

#: src/components/programming_controls/AddBlockShuffleModal.tsx
msgid "Shows take turns in a fixed order."
msgstr "Shows take turns in a fixed order."

#: src/components/programming_controls/AddBlockShuffleModal.tsx
#: src/components/programming_controls/AddReplicateModal.tsx
#: src/components/programming_controls/ShuffleProgrammingModal.tsx
msgid "Shuffle"
msgstr "Shuffle"

#: src/components/programming_controls/ShuffleProgrammingModal.tsx
#: src/components/programming_controls/ShuffleProgrammingModal.tsx
msgid "Shuffle Grouping"
msgstr "Shuffle Grouping"

#: src/components/programming_controls/ShuffleProgrammingModal.tsx
msgid "Shuffle Programming"
msgstr "Shuffle Programming"

#: src/components/programming_controls/ShuffleProgrammingModal.tsx
msgid "Shuffle programming in a channel, optionally grouping programs by certain criteria."
msgstr "Shuffle programming in a channel, optionally grouping programs by certain criteria."

#: src/components/slot_scheduler/MidRollConfigPanel.tsx
msgid "Skip mid-roll for programs shorter than this"
msgstr "Skip mid-roll for programs shorter than this"

#: src/pages/welcome/WelcomePage.tsx
msgid "Skip Setup"
msgstr "Skip Setup"

#: src/hooks/useRouteName.ts
msgid "Slot Editor"
msgstr "Slot Editor"

#: src/pages/channels/RandomSlotEditorPage.tsx
msgid "Slot Scheduler"
msgstr "Slot Scheduler"

#: src/components/slot_scheduler/RandomSlotWarningsDialog.tsx
#: src/components/slot_scheduler/TimeSlotWarningsDialog.tsx
msgid "Slot Warnings"
msgstr "Slot Warnings"

#: src/pages/channels/RandomSlotEditorPage.tsx
msgid "Slots"
msgstr "Slots"

#: src/components/channel_config/ChannelProgrammingOrganizeOptions.tsx
msgid "Slots Editor..."
msgstr "Slots Editor..."

#: src/components/shell/CommandPaletteContainer.tsx
msgid "Smart collection"
msgstr "Smart collection"

#: src/components/slot_scheduler/SmartCollectionSlotProgrammingForm.tsx
msgid "Smart Collection"
msgstr "Smart Collection"

#. placeholder {0}: collectionName ?? ''
#: src/hooks/slot_scheduler/useSlotName.ts
msgid "Smart Collection - {0}"
msgstr "Smart Collection - {0}"

#. placeholder {0}: smartCollection.name
#: src/routes/library/smart_collections/$id.tsx
msgid "Smart Collection: {0}"
msgstr "Smart Collection: {0}"

#: src/components/shell/CommandPaletteContainer.tsx
#: src/components/shell/useShellNav.tsx
#: src/hooks/useRouteName.ts
#: src/routes/library/smart_collections/index.tsx
msgid "Smart Collections"
msgstr "Smart Collections"

#: src/routes/library/smart_collections/index.tsx
msgid "Smart Collections are self-updating content lists. You set the query and the collection automatically adds any new content from your library that fits those rules. Any newly added content matching query will not modify existing channel programming at this time."
msgstr "Smart Collections are self-updating content lists. You set the query and the collection automatically adds any new content from your library that fits those rules. Any newly added content matching query will not modify existing channel programming at this time."

#: src/components/settings/ffmpeg/TranscodeConfigsTable.tsx
msgid "Software (No GPU)"
msgstr "Software (No GPU)"

#: src/components/channel_config/ChannelProgrammingSort.tsx
msgid "Sort"
msgstr "Sort"

#: src/components/ui/table/SortButton.tsx
msgid "Sort by {label} ascending"
msgstr "Sort by {label} ascending"

#: src/components/ui/table/SortButton.tsx
msgid "Sort by {label} descending"
msgstr "Sort by {label} descending"

#: src/components/channel_config/ChannelProgrammingSort.tsx
#: src/components/custom-shows/CustomShowSortToolsMenu.tsx
msgid "Sort By..."
msgstr "Sort By..."

#: src/components/channel_config/ChannelProgrammingSort.tsx
msgid "Sort TV Shows"
msgstr "Sort TV Shows"

#: src/components/channel_config/ChannelProgrammingSort.tsx
msgid "Sort TV Shows (asc)"
msgstr "Sort TV Shows (asc)"

#: src/components/channel_config/ChannelProgrammingSort.tsx
msgid "Sort TV Shows (desc)"
msgstr "Sort TV Shows (desc)"

#: src/components/ui/table/SortButton.tsx
msgid "Sorted by {label} ascending"
msgstr "Sorted by {label} ascending"

#: src/components/ui/table/SortButton.tsx
msgid "Sorted by {label} descending"
msgstr "Sorted by {label} descending"

#: src/components/channel_config/ChannelProgrammingSort.tsx
#: src/components/custom-shows/CustomShowSortToolsMenu.tsx
msgid "Sorts alphabetically by program title"
msgstr "Sorts alphabetically by program title"

#: src/components/channel_config/ChannelProgrammingSort.tsx
#: src/components/custom-shows/CustomShowSortToolsMenu.tsx
msgid "Sorts everything by its release date. This will only work correctly if the release dates in Plex are correct. In case any item does not have a release date specified, it will be moved to the bottom."
msgstr "Sorts everything by its release date. This will only work correctly if the release dates in Plex are correct. In case any item does not have a release date specified, it will be moved to the bottom."

#: src/components/channel_config/ChannelProgrammingSort.tsx
msgid "Sorts the list by TV Show and the episodes in each TV show by their season/episode number. Movies are moved to the bottom of the schedule."
msgstr "Sorts the list by TV Show and the episodes in each TV show by their season/episode number. Movies are moved to the bottom of the schedule."

#: src/components/channel_config/ChannelFlexConfig.tsx
msgid "Soundtrack"
msgstr "Soundtrack"

#: src/components/MediaSourceLibraryTable.tsx
#: src/pages/system/TroubleshootPage.tsx
msgid "Source"
msgstr "Source"

#: src/components/MediaSourceLibraryTable.tsx
#~ msgid "Source Type"
#~ msgstr "Source Type"

#: src/components/shell/useShellNav.tsx
#: src/hooks/useRouteName.ts
msgid "Sources"
msgstr "Sources"

#: src/components/channel_config/ChannelProgrammingDeleteOptions.tsx
msgid "Specials"
msgstr "Specials"

#: src/components/programming_controls/AddRerunBlockModal.tsx
msgid "Start"
msgstr "Start"

#: src/components/programming_controls/AddRestrictHoursModal.tsx
#: src/components/slot_scheduler/EditTimeSlotDialogContent.tsx
#: src/components/slot_scheduler/TimeSlotTable.tsx
msgid "Start Time"
msgstr "Start Time"

#: src/components/channels/ChannelNowPlayingCard.tsx
msgid "Started {startedAgo} - {remainingTime}remaining"
msgstr "Started {startedAgo} - {remainingTime}remaining"

#: src/components/programming_controls/AddBlockShuffleModal.tsx
#: src/components/programming_controls/AddBlockShuffleModal.tsx
msgid "Starting Episode"
msgstr "Starting Episode"

#: src/components/shell/useShellNav.tsx
msgid "Status"
msgstr "Status"

#: src/components/channel_config/ChannelEpgConfig.tsx
msgid "Stealth Mode"
msgstr "Stealth Mode"

#: src/pages/channels/ChannelsPage.tsx
msgid "Stealth?"
msgstr "Stealth?"

#: src/components/MediaSourceLibraryTable.tsx
msgid "Stop syncing this library"
msgstr "Stop syncing this library"

#: src/components/channels/ChannelOptionsMenu.tsx
msgid "Stop Transcode Session"
msgstr "Stop Transcode Session"

#: src/components/programs/ProgramDetailsDialog.tsx
msgid "Stream Info"
msgstr "Stream Info"

#: src/components/ProgramStreamDetails.tsx
msgid "Stream JSON"
msgstr "Stream JSON"

#: src/components/channels/ChannelSummaryQuickStats.tsx
msgid "Stream Mode"
msgstr "Stream Mode"

#: src/pages/system/TroubleshootPage.tsx
msgid "Stream Selection"
msgstr "Stream Selection"

#: src/components/channel_config/ChannelTranscodingConfig.tsx
msgid "Stream this channel through the experimental ErsatzTV next backend instead of Tunarr's own pipeline. Use this to move channels over one at a time. Turning on the global ErsatzTV next feature flag enrolls every channel and replaces this setting."
msgstr "Stream this channel through the experimental ErsatzTV next backend instead of Tunarr's own pipeline. Use this to move channels over one at a time. Turning on the global ErsatzTV next feature flag enrolls every channel and replaces this setting."

#: src/components/channel_config/EditChannelForm.tsx
msgid "Streaming"
msgstr "Streaming"

#: src/components/settings/ffmpeg/TranscodeConfigSettingsForm.tsx
msgid "Submit"
msgstr "Submit"

#: src/components/settings/ffmpeg/TranscodeConfigSettingsForm.tsx
msgid "Submitting..."
msgstr "Submitting..."

#: src/pages/system/TroubleshootPage.tsx
msgid "Subtitle Action"
msgstr "Subtitle Action"

#: src/pages/system/TroubleshootPage.tsx
msgid "Subtitle Streams"
msgstr "Subtitle Streams"

#: src/pages/settings/FfmpegSettingsPage.tsx
msgid "Subtitles"
msgstr "Subtitles"

#: src/pages/system/TroubleshootPage.tsx
msgid "Successfully copied to clipboard!"
msgstr "Successfully copied to clipboard!"

#: src/pages/library/TrashPage.tsx
#~ msgid "Successfully emptied trash."
#~ msgstr "Successfully emptied trash."

#: src/pages/system/StatusPage.tsx
msgid "Successfully ran system fixer {fixerId}"
msgstr "Successfully ran system fixer {fixerId}"

#: src/components/settings/ffmpeg/useTranscodeConfigFormOptions.ts
#: src/components/settings/ffmpeg/useTranscodeConfigFormOptions.ts
msgid "Successfully saved config!"
msgstr "Successfully saved config!"

#: src/pages/settings/TaskSettingsPage.tsx
msgid "Successfully scheduled {taskId} (running in background)."
msgstr "Successfully scheduled {taskId} (running in background)."

#: src/pages/settings/ScannerSettingsPage.tsx
msgid "Successfully updated Media Source settings."
msgstr "Successfully updated Media Source settings."

#: src/components/ui/patterns/AppShell/PhoneNav.tsx
#: src/components/ui/patterns/AppShell/ShellTopBar.tsx
msgid "Switch to dark mode"
msgstr "Switch to dark mode"

#: src/components/ui/patterns/AppShell/PhoneNav.tsx
#: src/components/ui/patterns/AppShell/ShellTopBar.tsx
msgid "Switch to light mode"
msgstr "Switch to light mode"

#: src/components/MediaSourceLibraryTable.tsx
msgid "Sync"
msgstr "Sync"

#: src/components/custom-shows/EditCustomShowForm.tsx
msgid "Sync Now"
msgstr "Sync Now"

#: src/components/MediaSourceLibraryTable.tsx
msgid "Sync this library to Tunarr"
msgstr "Sync this library to Tunarr"

#: src/components/custom-shows/EditCustomShowForm.tsx
msgid "Sync with external playlist"
msgstr "Sync with external playlist"

#: src/pages/library/CustomShowsPage.tsx
msgid "Synced with external playlist"
msgstr "Synced with external playlist"

#: src/components/settings/DarkModeButton.tsx
#: src/components/shell/useShellNav.tsx
#: src/pages/system/SystemLayout.tsx
msgid "System"
msgstr "System"

#: src/pages/system/SystemDebugPage.tsx
msgid "System Environment"
msgstr "System Environment"

#: src/pages/system/StatusPage.tsx
msgid "System Health"
msgstr "System Health"

#: src/pages/system/StatusPage.tsx
#: src/pages/system/TroubleshootPage.tsx
msgid "System Info"
msgstr "System Info"

#: src/components/slot_scheduler/SlotFillerDialogPanel.tsx
msgid "Tail"
msgstr "Tail"

#: src/components/slot_scheduler/MidRollConfigPanel.tsx
msgid "Tail Buffer (minutes)"
msgstr "Tail Buffer (minutes)"

#: src/components/programming_controls/AddBlockShuffleModal.tsx
msgid "Take Turns"
msgstr "Take Turns"

#: src/components/shell/useShellNav.tsx
#: src/pages/settings/TaskSettingsPage.tsx
msgid "Tasks"
msgstr "Tasks"

#: src/components/settings/general/GeneralSettingsForm.tsx
#~ msgid "Temporarily caches responses from Plex based by request path. Could potentially speed up channel editing."
#~ msgstr "Temporarily caches responses from Plex based by request path. Could potentially speed up channel editing."

#: src/routes/channels_/test.tsx
msgid "Test"
msgstr "Test"

#: src/pages/system/TroubleshootPage.tsx
msgid "Test Duration (seconds)"
msgstr "Test Duration (seconds)"

#: src/pages/system/TroubleshootPage.tsx
msgid "Test Playback"
msgstr "Test Playback"

#: src/pages/system/TroubleshootPage.tsx
msgid "Test Transcode"
msgstr "Test Transcode"

#: src/components/programming_controls/AddRestrictHoursModal.tsx
msgid "The channel's regular programming between the specified hours. Flex time will fill up the remaining hours."
msgstr "The channel's regular programming between the specified hours. Flex time will fill up the remaining hours."

#: src/components/channel_config/MediaItemGrid.tsx
msgid "The End."
msgstr "The End."

#: src/components/channel_config/ChannelTranscodingConfig.tsx
msgid "The ErsatzTV next backend does not serve this stream mode. It supports HLS, HLS Direct v2 and MPEG-TS."
msgstr "The ErsatzTV next backend does not serve this stream mode. It supports HLS, HLS Direct v2 and MPEG-TS."

#: src/components/settings/ffmpeg/EtvNextCompatibilityNotice.tsx
msgid "The ErsatzTV next backend ignores some of these settings"
msgstr "The ErsatzTV next backend ignores some of these settings"

#: src/components/channel_config/ChannelTranscodingConfig.tsx
msgid "The image will be rendered at its actual size without any scaling applied."
msgstr "The image will be rendered at its actual size without any scaling applied."

#: src/hooks/useVersion.tsx
msgid "The loaded version of the Tunarr UI does not match the server. Reload the browser to get the latest. If this message persists, clear your browser cache and reload."
msgstr "The loaded version of the Tunarr UI does not match the server. Reload the browser to get the latest. If this message persists, clear your browser cache and reload."

#: src/components/UnavailableLibraryIndicator.tsx
msgid "The media server stopped reporting this library on {since}. Its programs and channel schedules are preserved. Tunarr will not scan it until the server reports it again."
msgstr "The media server stopped reporting this library on {since}. Its programs and channel schedules are preserved. Tunarr will not scan it until the server reports it again."

#: src/components/LanguagePreferencesList.tsx
msgid "The selected languages will be considered in order they are selected."
msgstr "The selected languages will be considered in order they are selected."

#: src/components/channel_config/ChannelTranscodingConfig.tsx
msgid "The streaming mode affects the type of underlying transcoding process used to create the channel's video stream.<0/>Learn more about Tunarr's stream modes <1>here</1>!"
msgstr "The streaming mode affects the type of underlying transcoding process used to create the channel's video stream.<0/>Learn more about Tunarr's stream modes <1>here</1>!"

#: src/components/settings/media_source/LocalMediaEditDialog.tsx
msgid "The type of media in the provided paths"
msgstr "The type of media in the provided paths"

#: src/components/settings/general/WebSettings.tsx
msgid "Theme Settings"
msgstr "Theme Settings"

#: src/hooks/slot_scheduler/useScheduleSlots.ts
msgid "There was an error generating slots. {serverMessage}"
msgstr "There was an error generating slots. {serverMessage}"

#: src/hooks/slot_scheduler/useScheduleSlots.ts
msgid "There was an error generating time slots. Check the browser console log for more information"
msgstr "There was an error generating time slots. Check the browser console log for more information"

#: src/pages/settings/ScannerSettingsPage.tsx
msgid "There was an error submitting the request to update Media Source settings. Please check the form and try again"
msgstr "There was an error submitting the request to update Media Source settings. Please check the form and try again"

#: src/components/settings/media_source/LocalMediaEditDialog.tsx
msgid "There was an error when submitting the form. Please see console logs for details."
msgstr "There was an error when submitting the form. Please see console logs for details."

#: src/components/settings/general/WebSettings.tsx
msgid "These settings are stored in your browser and are saved automatically when changed."
msgstr "These settings are stored in your browser and are saved automatically when changed."

#. placeholder {0}: slot.type .split('-') .map((s) => capitalize(s)) .join(' ')
#: src/components/slot_scheduler/RandomSlotTable.tsx
#: src/components/slot_scheduler/TimeSlotTable.tsx
msgid "This {0} is marked as missing in the database."
msgstr "This {0} is marked as missing in the database."

#: src/components/channel_config/ChannelProgrammingOrganizeOptions.tsx
msgid "This allows to schedule specific shows to run at specific time slots of the day or a week. It's recommended you first populate the channel with the episodes from the shows you want to play and/or other content like movies and redirects."
msgstr "This allows to schedule specific shows to run at specific time slots of the day or a week. It's recommended you first populate the channel with the episodes from the shows you want to play and/or other content like movies and redirects."

#: src/components/programming_controls/AdjustWeightsModal.tsx
msgid "This allows you to pick the weights for each of the shows, so you can decide that some shows should be less frequent than other shows."
msgstr "This allows you to pick the weights for each of the shows, so you can decide that some shows should be less frequent than other shows."

#: src/pages/channels/RandomSlotEditorPage.tsx
msgid "This channel has an existing time slot schedule. A channel can only use one scheduling type at a time. Saving a schedule here will remove the existing time slot schedule."
msgstr "This channel has an existing time slot schedule. A channel can only use one scheduling type at a time. Saving a schedule here will remove the existing time slot schedule."

#. placeholder {0}: schedule.type === 'time' ? 'Time ' : ' '
#: src/pages/channels/ChannelProgrammingPage.tsx
msgid "This channel is set up to use <0>{0}Slots</0> for programming. Any manual changes on this page will likely make this channel stop adhering to that schedule."
msgstr "This channel is set up to use <0>{0}Slots</0> for programming. Any manual changes on this page will likely make this channel stop adhering to that schedule."

#: src/components/channel_config/ChannelPropertiesEditor.tsx
msgid "This channel number has already been used"
msgstr "This channel number has already been used"

#: src/components/slot_scheduler/SlotProgrammingTooLongWarningDetails.tsx
msgid "This could cause the following slot's programs to go unscheduled. Possible solutions include:"
msgstr "This could cause the following slot's programs to go unscheduled. Possible solutions include:"

#: src/components/slot_scheduler/CustomShowSlotProgrammingForm.tsx
msgid "This custom show has no programs. Add programs to it or choose another show."
msgstr "This custom show has no programs. Add programs to it or choose another show."

#: src/components/custom-shows/EditCustomShowForm.tsx
msgid "This custom show is synced with an external playlist. Content is updated automatically and cannot be edited manually."
msgstr "This custom show is synced with an external playlist. Content is updated automatically and cannot be edited manually."

#: src/components/slot_scheduler/CustomShowSlotProgrammingForm.tsx
msgid "This custom show was deleted. Choose another show."
msgstr "This custom show was deleted. Choose another show."

#: src/components/settings/general/GeneralSettingsForm.tsx
#~ msgid "This feature is currently experimental. Proceed with caution and if you experience an issue, try disabling caching."
#~ msgstr "This feature is currently experimental. Proceed with caution and if you experience an issue, try disabling caching."

#: src/components/slot_scheduler/SlotFillerDialogPanel.tsx
msgid "This filler list has no programs and will be ignored."
msgstr "This filler list has no programs and will be ignored."

#: src/components/channel_config/ChannelEpgConfig.tsx
msgid "This is the name of the fake program that will appear in the TV guide when there are no programs to display in that time slot guide, e.g when a large Flex block is scheduled."
msgstr "This is the name of the fake program that will appear in the TV guide when there are no programs to display in that time slot guide, e.g when a large Flex block is scheduled."

#: src/components/channel_config/ChannelPropertiesEditor.tsx
msgid "This is used by iptv clients to categorize the channels. You can leave it as 'tunarr' if you don't need this sort of classification."
msgstr "This is used by iptv clients to categorize the channels. You can leave it as 'tunarr' if you don't need this sort of classification."

#: src/components/channel_config/ProgrammingSelector.tsx
msgid "This media source has no enabled or scanned libraries. Enable libraries for this source on the <0>Media Sources</0> page or manually trigger scans on the <1>Library</1> page."
msgstr "This media source has no enabled or scanned libraries. Enable libraries for this source on the <0>Media Sources</0> page or manually trigger scans on the <1>Library</1> page."

#: src/components/programming_controls/AddBlockShuffleModal.tsx
msgid "This option is disabled because it would calculate a schedule that is too long."
msgstr "This option is disabled because it would calculate a schedule that is too long."

#: src/components/slot_scheduler/TimeSlotTable.tsx
#: src/components/slot_scheduler/TimeSlotTable.tsx
msgid "This show is marked as missing in the database."
msgstr "This show is marked as missing in the database."

#. placeholder {0}: groupPeers.length
#. placeholder {1}: groupPeers.length
#: src/components/slot_scheduler/SlotLinkingControl.tsx
msgid "This slot is linked with {0} other {1, plural, one {slot} other {slots}}. Content fields are shared across the group."
msgstr "This slot is linked with {0} other {1, plural, one {slot} other {slots}}. Content fields are shared across the group."

#: src/components/slot_scheduler/SlotLinkingControl.tsx
#~ msgid "This slot is linked with {0} other {1, plural, one {slot} other {slots}}Content fields are shared across the group."
#~ msgstr "This slot is linked with {0} other {1, plural, one {slot} other {slots}}Content fields are shared across the group."

#: src/components/slot_scheduler/SlotLinkingControl.tsx
#~ msgid "This slot is linked with {0} other slot(s). Content fields are shared across the group."
#~ msgstr "This slot is linked with {0} other slot(s). Content fields are shared across the group."

#: src/components/slot_scheduler/SlotLinkingControl.tsx
msgid "This slot replays content aired by continue slots earlier in the period."
msgstr "This slot replays content aired by continue slots earlier in the period."

#: src/components/slot_scheduler/SlotUnavailableCustomShowWarningDetails.tsx
msgid "This slot's custom show has no programs, so the slot cannot be scheduled. Add programs to the show, choose another show, or remove the slot."
msgstr "This slot's custom show has no programs, so the slot cannot be scheduled. Add programs to the show, choose another show, or remove the slot."

#: src/components/slot_scheduler/SlotUnavailableCustomShowWarningDetails.tsx
msgid "This slot's custom show was deleted, so the slot cannot be scheduled. Choose another show or remove the slot."
msgstr "This slot's custom show was deleted, so the slot cannot be scheduled. Choose another show or remove the slot."

#: src/components/settings/ffmpeg/TranscodeConfigSettingsForm.tsx
msgid "Threads"
msgstr "Threads"

#: src/components/channel_config/ChannelPropertiesEditor.tsx
msgid "Thumbnail URL"
msgstr "Thumbnail URL"

#: src/components/slot_scheduler/MidRollConfigPanel.tsx
msgid "Time before first break"
msgstr "Time before first break"

#: src/components/slot_scheduler/MidRollConfigPanel.tsx
msgid "Time between subsequent breaks"
msgstr "Time between subsequent breaks"

#: src/components/settings/general/WebSettings.tsx
msgid "Time format"
msgstr "Time format"

#: src/components/settings/general/WebSettings.tsx
msgid "Time Format"
msgstr "Time Format"

#: src/hooks/useRouteName.ts
msgid "Time Slot Editor"
msgstr "Time Slot Editor"

#: src/pages/channels/TimeSlotEditorPage.tsx
msgid "Time Slots"
msgstr "Time Slots"

#: src/components/channel_config/ChannelProgrammingOrganizeOptions.tsx
msgid "Time Slots..."
msgstr "Time Slots..."

#: src/pages/system/SystemLogsPage.tsx
msgid "Timestamp"
msgstr "Timestamp"

#: src/pages/system/TroubleshootPage.tsx
#: src/pages/system/TroubleshootPage.tsx
msgid "Title"
msgstr "Title"

#: src/components/programming_controls/AddRestrictHoursModal.tsx
msgid "TO"
msgstr "TO"

#: src/components/slot_scheduler/EditSlotProgrammingForm.tsx
msgid "To schedule movies, add them to a custom show and choose Custom Show."
msgstr "To schedule movies, add them to a custom show and choose Custom Show."

#: src/pages/welcome/WelcomePage.tsx
#~ msgid "To use Tunarr, you must first connect at least one media source. Media sources provide all content used to create channels in Tunarr. Plex and Jellyfin are currently supported."
#~ msgstr "To use Tunarr, you must first connect at least one media source. Media sources provide all content used to create channels in Tunarr. Plex and Jellyfin are currently supported."

#: src/components/channel_config/ProgrammingSelector.tsx
msgid "To use Tunarr, you need to first connect a media source. This will allow you to build custom channels with your content."
msgstr "To use Tunarr, you need to first connect a media source. This will allow you to build custom channels with your content."

#: src/components/slot_scheduler/ProgramWeekCalendarView.tsx
msgid "Today"
msgstr "Today"

#: src/components/settings/media_source/EmbyServerEditDialog.tsx
#: src/components/settings/media_source/JelllyfinServerEditDialog.tsx
#: src/components/settings/media_source/PlexServerEditDialog.tsx
msgid "toggle access token visibility"
msgstr "toggle access token visibility"

#: src/components/settings/media_source/EmbyServerEditDialog.tsx
#: src/components/settings/media_source/JelllyfinServerEditDialog.tsx
msgid "toggle password visibility"
msgstr "toggle password visibility"

#: src/components/ui/table/DataTable.tsx
msgid "Toggle visibility {label}"
msgstr "Toggle visibility {label}"

#: src/components/channel_config/ChannelProgrammingTools.tsx
#: src/components/custom-shows/CustomShowSortToolsMenu.tsx
msgid "Tools"
msgstr "Tools"

#. placeholder {0}: isNonEmptyString(query.query) && totalHits >= 1000 ? '>1000' : totalHits
#: src/components/library/LibraryProgramGrid.tsx
msgid "Total hits: {0}"
msgstr "Total hits: {0}"

#: src/components/channels/ChannelSummaryQuickStats.tsx
msgid "Total Runtime"
msgstr "Total Runtime"

#: src/components/programs/Tracks.tsx
#: src/pages/library/TrashPage.tsx
msgid "Tracks"
msgstr "Tracks"

#: src/pages/channels/ChannelsPage.tsx
#: src/pages/system/TroubleshootPage.tsx
msgid "Transcode Config"
msgstr "Transcode Config"

#: src/pages/system/TroubleshootPage.tsx
#: src/pages/system/TroubleshootPage.tsx
msgid "Transcode Config (optional override)"
msgstr "Transcode Config (optional override)"

#: src/components/channels/ChannelSummaryQuickStats.tsx
msgid "Transcode Config <0> <1/></0>"
msgstr "Transcode Config <0> <1/></0>"

#: src/pages/settings/FfmpegSettingsPage.tsx
msgid "Transcoding Configs"
msgstr "Transcoding Configs"

#: src/components/channel_config/ChannelTranscodingConfig.tsx
msgid "Transcoding Settings"
msgstr "Transcoding Settings"

#: src/components/shell/useShellNav.tsx
#: src/hooks/useRouteName.ts
#: src/pages/library/TrashPage.tsx
msgid "Trash"
msgstr "Trash"

#: src/pages/library/TrashPage.tsx
msgid "Trashed items are items that were previously scanned, but not found in a recent scan. This could be due to missing files or a media server no longer returning the item from its API. These items will be unplayable in channels in their current state. When the trash is emptied, their spots in channels will be replaced with flex."
msgstr "Trashed items are items that were previously scanned, but not found in a recent scan. This could be due to missing files or a media server no longer returning the item from its API. These items will be unplayable in channels in their current state. When the trash is emptied, their spots in channels will be replaced with flex."

#: src/components/shell/useShellNav.tsx
msgid "Troubleshoot"
msgstr "Troubleshoot"

#. placeholder {0}: version.tunarr
#: src/components/ui/patterns/AppShell/HelpMenu.tsx
msgid "Tunarr {0}"
msgstr "Tunarr {0}"

#: src/components/settings/general/GeneralSettingsForm.tsx
msgid "Tunarr Backend URL"
msgstr "Tunarr Backend URL"

#: src/pages/system/StatusPage.tsx
msgid "Tunarr Backend URL:"
msgstr "Tunarr Backend URL:"

#: src/components/ui/patterns/AppShell/PhoneNav.tsx
#: src/components/ui/patterns/AppShell/ShellTopBar.tsx
msgid "Tunarr home"
msgstr "Tunarr home"

#: src/components/Video.tsx
msgid "Tunarr is currently configured to use the AC3 audio encoder. This audio format is not supported by browsers. The resultant stream will likely not have audio or will not play at all."
msgstr "Tunarr is currently configured to use the AC3 audio encoder. This audio format is not supported by browsers. The resultant stream will likely not have audio or will not play at all."

#. placeholder {0}: mediaSource.name
#: src/components/settings/media_source/EditMediaSourceLibrariesDialog.tsx
msgid "Tunarr only syncs content from enabled libraries. Choose the libraries from {0} that you want to use in your channels."
msgstr "Tunarr only syncs content from enabled libraries. Choose the libraries from {0} that you want to use in your channels."

#: src/components/settings/media_source/MediaSourceLibrariesChip.tsx
msgid "Tunarr only syncs content from enabled libraries. Click to choose libraries."
msgstr "Tunarr only syncs content from enabled libraries. Click to choose libraries."

#: src/components/MediaSourceLibraryTable.tsx
msgid "Tunarr only syncs content from enabled libraries. Turn on a library's switch to sync it, or manage sources in <0>Media Source Settings.</0>"
msgstr "Tunarr only syncs content from enabled libraries. Turn on a library's switch to sync it, or manage sources in <0>Media Source Settings.</0>"

#: src/pages/settings/TaskSettingsPage.tsx
msgid "Tunarr runs various tasks, sometimes on a schedule, for background operations."
msgstr "Tunarr runs various tasks, sometimes on a schedule, for background operations."

#: src/pages/welcome/WelcomePage.tsx
msgid "Tunarr scans enabled libraries in the background. Channels can only use programs that have been scanned by Tunarr."
msgstr "Tunarr scans enabled libraries in the background. Channels can only use programs that have been scanned by Tunarr."

#: src/pages/welcome/WelcomePage.tsx
msgid "Tunarr uses FFmpeg 6.1 or newer to transcode streams."
msgstr "Tunarr uses FFmpeg 6.1 or newer to transcode streams."

#: src/pages/welcome/WelcomePage.tsx
msgid "Tunarr uses FFmpeg to transcode streams. Your container image includes it, but Tunarr could not use it."
msgstr "Tunarr uses FFmpeg to transcode streams. Your container image includes it, but Tunarr could not use it."

#: src/components/settings/media_source/PlexServerEditDialog.tsx
msgid "Tunarr will attempt to get Plex to pull Tunarr's updated XMLTV upon regeneration"
msgstr "Tunarr will attempt to get Plex to pull Tunarr's updated XMLTV upon regeneration"

#: src/components/settings/media_source/JelllyfinServerEditDialog.tsx
msgid "Tunarr will update Jellyfin's \"now playing\" state while channels are active."
msgstr "Tunarr will update Jellyfin's \"now playing\" state while channels are active."

#: src/components/settings/media_source/PlexServerEditDialog.tsx
msgid "Tunarr will update Plex's \"now playing\" state while channels are active."
msgstr "Tunarr will update Plex's \"now playing\" state while channels are active."

#: src/pages/settings/HdhrSettingsPage.tsx
#: src/pages/settings/HdhrSettingsPage.tsx
msgid "Tuner Count"
msgstr "Tuner Count"

#: src/components/programming_controls/AddBlockShuffleModal.tsx
msgid "TV shows are grouped by show"
msgstr "TV shows are grouped by show"

#: src/components/programming_controls/AddReplicateModal.tsx
#: src/components/programming_controls/AddReplicateModal.tsx
#: src/components/slot_scheduler/EditSlotProgrammingForm.tsx
#: src/components/slot_scheduler/EditSlotProgrammingForm.tsx
#: src/components/slot_scheduler/RandomSlotTable.tsx
#: src/components/slot_scheduler/SlotSchedulerCyclicShuffleDialog.tsx
#: src/components/slot_scheduler/SlotSchedulerCyclicShuffleDialog.tsx
#: src/pages/settings/MediaSourceSettingsPage.tsx
#: src/pages/system/TroubleshootPage.tsx
#: src/pages/system/TroubleshootPage.tsx
msgid "Type"
msgstr "Type"

#: src/components/UnavailableLibraryIndicator.tsx
#: src/components/UnavailableLibraryIndicator.tsx
msgid "Unavailable"
msgstr "Unavailable"

#: src/components/search/DateSearchValueNode.tsx
#: src/components/search/DateSearchValueNode.tsx
msgid "Unit"
msgstr "Unit"

#: src/components/slot_scheduler/SlotLinkingControl.tsx
msgid "Unlink"
msgstr "Unlink"

#: src/components/slot_scheduler/SlotLinkingControl.tsx
#~ msgid "Unlink from group"
#~ msgstr "Unlink from group"

#: src/components/settings/media_source/EmbyServerEditDialog.tsx
#: src/components/settings/media_source/JelllyfinServerEditDialog.tsx
#: src/components/settings/media_source/LocalMediaEditDialog.tsx
#: src/components/settings/media_source/PlexServerEditDialog.tsx
msgid "Update"
msgstr "Update"

#: src/components/settings/media_source/JelllyfinServerEditDialog.tsx
#: src/components/settings/media_source/PlexServerEditDialog.tsx
msgid "Update Play Status"
msgstr "Update Play Status"

#: src/components/settings/media_source/EmbyServerEditDialog.tsx
#: src/components/settings/media_source/JelllyfinServerEditDialog.tsx
#: src/components/settings/media_source/PlexServerEditDialog.tsx
#: src/pages/settings/MediaSourceSettingsPage.tsx
msgid "URL"
msgstr "URL"

#: src/pages/system/TroubleshootPage.tsx
msgid "Use channel default"
msgstr "Use channel default"

#: src/components/channel_config/ChannelTranscodingConfig.tsx
msgid "Use ErsatzTV next Backend (Experimental)"
msgstr "Use ErsatzTV next Backend (Experimental)"

#: src/components/slot_scheduler/TimeSlotConfigDialogPanel.tsx
#: src/components/slot_scheduler/TimeSlotConfigDialogPanel.tsx
msgid "Use schedule default"
msgstr "Use schedule default"

#: src/pages/settings/XmlTvSettingsPage.tsx
msgid "Use Show Poster"
msgstr "Use Show Poster"

#: src/components/channel_config/ChannelTranscodingConfig.tsx
msgid "Use these settings to override global ffmpeg settings for this channel."
msgstr "Use these settings to override global ffmpeg settings for this channel."

#: src/components/settings/media_source/EmbyServerEditDialog.tsx
#: src/components/settings/media_source/EmbyServerEditDialog.tsx
#: src/components/settings/media_source/JelllyfinServerEditDialog.tsx
#: src/components/settings/media_source/JelllyfinServerEditDialog.tsx
msgid "Username"
msgstr "Username"

#: src/pages/channels/TimeSlotEditorPage.tsx
msgid "Usually slots need to add flex time to ensure that the next slot starts at the correct time. When there are multiple videos in the slot, you might prefer to distribute the flex time between the videos or to place most of the flex time at the end of the slot."
msgstr "Usually slots need to add flex time to ensure that the next slot starts at the correct time. When there are multiple videos in the slot, you might prefer to distribute the flex time between the videos or to place most of the flex time at the end of the slot."

#: src/components/settings/ffmpeg/TranscodeConfigVideoSettingsForm.tsx
msgid "VA-API Device"
msgstr "VA-API Device"

#: src/pages/system/SystemDebugPage.tsx
msgid "VAAPI Capabilities"
msgstr "VAAPI Capabilities"

#: src/components/search/DateSearchValueNode.tsx
#: src/components/search/DateSearchValueNode.tsx
#: src/components/search/DateSearchValueNode.tsx
#: src/components/search/FacetStringValueSearchNode.tsx
#: src/components/search/NumericValueSearchNode.tsx
#: src/components/search/StringValueSearchNode.tsx
msgid "Value"
msgstr "Value"

#: src/hooks/useVersion.tsx
msgid "Version Mismatch!"
msgstr "Version Mismatch!"

#: src/components/ui/patterns/AppShell/HelpMenu.tsx
msgid "Version unknown"
msgstr "Version unknown"

#: src/components/VersionFooter.tsx
#~ msgid "Version: {0}"
#~ msgstr "Version: {0}"

#: src/components/VersionFooter.tsx
#~ msgid "Version: unknown"
#~ msgstr "Version: unknown"

#: src/pages/system/TroubleshootPage.tsx
msgid "Video"
msgstr "Video"

#: src/components/settings/ffmpeg/TranscodeConfigVideoSettingsForm.tsx
msgid "Video Bitrate"
msgstr "Video Bitrate"

#: src/components/settings/ffmpeg/TranscodeConfigVideoSettingsForm.tsx
msgid "Video Buffer Size"
msgstr "Video Buffer Size"

#: src/components/settings/ffmpeg/TranscodeConfigsTable.tsx
#: src/components/settings/ffmpeg/TranscodeConfigVideoSettingsForm.tsx
msgid "Video Format"
msgstr "Video Format"

#: src/components/settings/ffmpeg/TranscodeConfigSettingsForm.tsx
msgid "Video Options"
msgstr "Video Options"

#: src/pages/system/TroubleshootPage.tsx
msgid "Video Streams"
msgstr "Video Streams"

#: src/components/channel_config/ChannelFlexConfig.tsx
msgid "Videos from the filler list will be randomly picked to play unless there are cooldown restrictions to place or if no videos are short enough for the remaining Flex time.<0/>Each filler can be assigned a cooldown, which restricts how frequently the list will be chosen during flex time."
msgstr "Videos from the filler list will be randomly picked to play unless there are cooldown restrictions to place or if no videos are short enough for the remaining Flex time.<0/>Each filler can be assigned a cooldown, which restricts how frequently the list will be chosen during flex time."

#: src/components/smart_collections/SmartCollectionsTable.tsx
msgid "View Collection"
msgstr "View Collection"

#: src/components/ProgramMetadataDialogContent.tsx
#: src/components/programs/ProgramOperationsMenu.tsx
msgid "View Full Details"
msgstr "View Full Details"

#. placeholder {0}: capitalize(firstProgram.program.sourceType)
#. placeholder {0}: capitalize(program.sourceType)
#: src/components/channels/ChannelNowPlayingCard.tsx
#: src/components/ProgramMetadataDialogContent.tsx
msgid "View in {0}"
msgstr "View in {0}"

#: src/components/MediaSourceLibraryTable.tsx
#~ msgid "View Library"
#~ msgstr "View Library"

#: src/pages/welcome/WelcomePage.tsx
msgid "Waiting for the first scan to finish..."
msgstr "Waiting for the first scan to finish..."

#: src/hooks/useRouteName.ts
msgid "Watch"
msgstr "Watch"

#: src/components/channels/ChannelOptionsMenu.tsx
msgid "Watch Channel"
msgstr "Watch Channel"

#: src/pages/welcome/WelcomePage.tsx
msgid "Watch from a client"
msgstr "Watch from a client"

#: src/components/channel_config/ChannelTranscodingConfig.tsx
msgid "Watermark"
msgstr "Watermark"

#: src/components/channel_config/ChannelTranscodingConfig.tsx
msgid "Watermark Image URL"
msgstr "Watermark Image URL"

#: src/components/settings/general/WebSettings.tsx
msgid "Web Settings"
msgstr "Web Settings"

#. placeholder {0}: trimStart(__TUNARR_VERSION__, 'v')
#. placeholder {1}: trimStart(query.data?.tunarr, 'v')
#: src/hooks/useVersion.tsx
msgid "Web version = {0}, Server version = {1}"
msgstr "Web version = {0}, Server version = {1}"

#: src/components/channel_config/ChannelProgrammingConfig.tsx
msgid "Week"
msgstr "Week"

#: src/pages/channels/TimeSlotEditorPage.tsx
msgid "Weekly"
msgstr "Weekly"

#: src/components/channel_config/ChannelFlexConfig.tsx
#: src/components/slot_scheduler/RandomSlotTable.tsx
msgid "Weight"
msgstr "Weight"

#: src/components/slot_scheduler/EditRandomSlotDialogContent.tsx
msgid "Weight %"
msgstr "Weight %"

#: src/components/slot_scheduler/SlotOrderFormControl.tsx
#: src/components/slot_scheduler/SlotOrderFormControl.tsx
msgid "Weighting"
msgstr "Weighting"

#: src/components/shell/useShellNav.tsx
msgid "Welcome"
msgstr "Welcome"

#: src/pages/welcome/WelcomePage.tsx
msgid "Welcome to Tunarr!"
msgstr "Welcome to Tunarr!"

#: src/pages/system/TroubleshootPage.tsx
msgid "What the ErsatzTV next worker recorded the last few times this channel failed to play an item. Attach it to a bug report."
msgstr "What the ErsatzTV next worker recorded the last few times this channel failed to play an item. Attach it to a bug report."

#: src/components/channel_config/ChannelTranscodingConfig.tsx
msgid "When enabled, intermittent watermarks fade in immediately when a stream is initialized. When disabled, the first watermark fade-in occurs after a full period."
msgstr "When enabled, intermittent watermarks fade in immediately when a stream is initialized. When disabled, the first watermark fade-in occurs after a full period."

#: src/components/settings/general/GeneralSettingsForm.tsx
msgid "When enabling, Tunarr will generate an initial backup immediately"
msgstr "When enabling, Tunarr will generate an initial backup immediately"

#: src/components/settings/media_source/EditPathReplacementsForm.tsx
msgid "When file paths on the remote server differ from the paths Tunarr can see, use Path Replacements to instruct Tunarr how to stream media from disk."
msgstr "When file paths on the remote server differ from the paths Tunarr can see, use Path Replacements to instruct Tunarr how to stream media from disk."

#: src/components/settings/ffmpeg/TranscodeConfigAdvancedOptions.tsx
msgid "Will force use of a software decoder despite hardware acceleration settings."
msgstr "Will force use of a software decoder despite hardware acceleration settings."

#: src/components/settings/ffmpeg/TranscodeConfigAdvancedOptions.tsx
msgid "Will force use of a software encoder despite hardware acceleration settings."
msgstr "Will force use of a software encoder despite hardware acceleration settings."

#: src/components/settings/ffmpeg/TranscodeConfigAdvancedOptions.tsx
msgid "Will force use of a software filters (e.g. scale, pad, etc.) despite hardware acceleration settings."
msgstr "Will force use of a software filters (e.g. scale, pad, etc.) despite hardware acceleration settings."

#: src/components/shell/useShellNav.tsx
msgid "XMLTV"
msgstr "XMLTV"

#: src/pages/welcome/WelcomePage.tsx
msgid "XMLTV guide"
msgstr "XMLTV guide"

#: src/pages/system/StatusPage.tsx
msgid "XMLTV Link:"
msgstr "XMLTV Link:"

#: src/components/programming_controls/AddBlockShuffleModal.tsx
msgid "You can change any setting below before shuffling."
msgstr "You can change any setting below before shuffling."

#: src/pages/library/FillerListsPage.tsx
msgid "You have no Filler Lists. Create your first Filler List <0>here.</0>"
msgstr "You have no Filler Lists. Create your first Filler List <0>here.</0>"

#: src/components/smart_collections/SmartCollectionsTable.tsx
msgid "You have no smart collections. Smart collections can be created on the <0>search</0> page."
msgstr "You have no smart collections. Smart collections can be created on the <0>search</0> page."

#: src/components/settings/UnsavedNavigationAlert.tsx
msgid "You have unsaved changes!"
msgstr "You have unsaved changes!"

#: src/components/channel_config/NoChannelsCreated.tsx
msgid "You haven't created any channels yet."
msgstr "You haven't created any channels yet."

#: src/components/channel_config/ChannelFlexConfig.tsx
msgid "You haven't created any filler lists yet! Go to the <0>Filler Lists</0> page to create one."
msgstr "You haven't created any filler lists yet! Go to the <0>Filler Lists</0> page to create one."

#: src/components/slot_scheduler/EditRandomSlotDialogContent.tsx
msgid "You must create at least one <0>filler list</0> before assigning filler to a lot."
msgstr "You must create at least one <0>filler list</0> before assigning filler to a lot."

#: src/pages/welcome/WelcomePage.tsx
#~ msgid "You're All Set!"
#~ msgstr "You're All Set!"

#. placeholder {0}: field.value
#: src/components/programming_controls/AddReplicateModal.tsx
msgid "Your list will be replicated {0} times"
msgstr "Your list will be replicated {0} times"
